<template>
  <svg
    :x="svgCoords.x"
    :y="svgCoords.y"
    width="380"
    height="380"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 314.2 328.1"
    id="milestone-deploypreview"
    role="presentation"
    aria-labelledby="atomicdeploypreviews"
  >
    <title id="atomicdeploypreviews">Launch of Atomic Deploy Previews</title>
    <defs>
      <clipPath id="clip-path" transform="translate(-1 -0.4)">
        <rect class="cls-1" x="1" y="42.9" width="54" height="117" />
      </clipPath>
    </defs>
    <path class="cls-2" d="M101.9,215.9l12.2,6.7-.5.9-12.2-6.8Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M99.3,217.1l12.2,6.8-.4.8L98.8,218Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M97,218.7l12.2,6.7-.4.9-12.3-6.8Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M94.3,220l12.2,6.7-.4.9-12.3-6.8Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M92.3,221.3l12.3,6.8-.5.8-12.2-6.8Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M89.8,222.9l12.2,6.7-.4.9-12.3-6.8Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M87.4,224.1l12.2,6.8-.4.8L86.9,225Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M84.9,225.5l12.2,6.8-.4.8-12.3-6.8Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M82.6,227l12.2,6.8-.4.8-12.3-6.7Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M79.9,228.3l12.3,6.8-.5.8-12.2-6.7Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M77.6,229.8l12.3,6.8-.5.9-12.2-6.8Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M75,231.2l12.3,6.7-.5.9L74.6,232Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M73.9,233.1l9.8,5.5-.5.8L73.5,234Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M74.1,235.9l5.9,3.4-.5.8-5.9-3.3Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M140.7,193.6l12.2,6.7-.4.9-12.3-6.8Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M138,194.8l12.3,6.8-.5.8-12.2-6.7Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M135.7,196.4l12.3,6.7-.5.9-12.2-6.8Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M133.1,197.7l12.2,6.7-.4.9-12.3-6.8Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M131,199.2l12.2,6.8-.4.8L130.5,200Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M128.5,200.5l12.3,6.8-.5.9-12.2-6.8Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M126.3,201.9l12.3,6.8-.5.8-12.3-6.8Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M123.7,203.2,136,210l-.5.8L123.3,204Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M121.4,204.7l12.3,6.8-.5.8L121,205.5Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M118.7,206l12.3,6.8-.5.8-12.2-6.8Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M116.5,207.5l12.2,6.8-.4.8L116,208.4Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M113.8,208.8l12.2,6.8-.4.8-12.3-6.7Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M111.7,210.4l12.2,6.7-.4.9-12.3-6.8Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M109.1,211.6l12.2,6.8-.4.9-12.3-6.8Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M106.8,213.2l12.3,6.7-.5.9L106.4,214Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M104.3,214.6l12.2,6.7-.4.9-12.3-6.8Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M102,215.8l12.2,6.8-.5.8-12.2-6.8Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M171.5,177.7l7.8,4.4-.5.8-7.8-4.3Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M167.7,178.2l10.7,6-.4.8-10.8-6Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M164.7,179.3l12.2,6.8-.4.8-12.3-6.7Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M162.2,180.7l12.3,6.8-.5.8-12.2-6.8Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M159.8,182.1l12.2,6.8-.4.9L159.3,183Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M157.3,183.5l12.2,6.8-.4.8-12.3-6.7Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M155,185.1l12.2,6.8-.4.8-12.3-6.8Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M152.3,186.4l12.3,6.7-.5.9-12.2-6.8Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M150.3,187.7l12.3,6.8-.5.8-12.2-6.8Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M147.6,189.2l12.2,6.7-.4.9L147.1,190Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M145.4,190.5l12.3,6.8-.5.8L145,191.3Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M142.8,191.8l12.2,6.8-.4.8-12.3-6.8Z" transform="translate(-1 -0.4)" />
    <path
      class="cls-2"
      d="M36,214.7l2.6,3.1,133-76.8c.7-.6,2.2-.4,3.2.2l1.7.9,5.3-1.5s2.8,2.5.4,6.6c0,.2-.2.2-.4.4h-.2l-.4.4L47.5,225.1c-1.7,1-4.5.8-6.4-.2l-5.9-3.4-5.8-3.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M44.7,226.8a6.8,6.8,0,0,0,3.2-.7l133.7-77.2.6-.4h.2a.9.9,0,0,0,.3-.5v-.2l-.7-.4.7.4c2.3-3.8.6-6.6-.5-7.8l-.4-.2-5.3,1.6-1.3-.8a4.1,4.1,0,0,0-4-.2L38.8,216.8l-2.6-3-8.5,4.7,13,7.6A13.4,13.4,0,0,0,44.7,226.8ZM181.4,147c-.2.2-.2.2-.2.4l-.4.2L47.1,224.8a6.9,6.9,0,0,1-5.6-.2l-10.6-6.1,4.7-2.6,2.7,3,.5-.4,133-76.8a3.4,3.4,0,0,1,2.4.2l1.9,1.2,5.1-1.4C182.2,142.3,183.1,144,181.4,147Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M47.5,220.8l133.7-77.2c1.7-.9,1.5-2.6-.4-3.8l-5.8-3.4a4,4,0,0,0-3.2-.1L35,215.1c-.7.6-.7,1.3.2,1.9l5.9,3.4A7.3,7.3,0,0,0,47.5,220.8Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M44.7,222.3a5.9,5.9,0,0,0,3.2-.8l133.7-77.1a2.8,2.8,0,0,0,1.5-2.3,3.2,3.2,0,0,0-2.1-2.8l-5.8-3.4a4.1,4.1,0,0,0-4-.2L34.5,214.5a2,2,0,0,0-1,1.6,1.9,1.9,0,0,0,1.2,1.7l5.8,3.4A9.7,9.7,0,0,0,44.7,222.3Zm2.4-2.3a6.2,6.2,0,0,1-5.6-.2l-5.9-3.4-.4-.3.2-.2L172.1,137a2.8,2.8,0,0,1,2.5.2l5.9,3.4a2,2,0,0,1,1.1,1.3,1.3,1.3,0,0,1-.8,1Z"
      transform="translate(-1 -0.4)"
    />
    <path class="cls-4" d="M43.9,221.4h1.4v4.7H43.9Z" transform="translate(-1 -0.4)" />
    <path
      class="cls-3"
      d="M12.5,212.3V107.7c0-5.5,3.4-11.9,7.6-14.4L177.2,2.6l1.2-.6c1.7-1,5.5-1.3,8.9.8S192,9,192,9l-7.2,1.1V112.2c0,5.5-3.4,12-7.6,14.4L21.8,216.4l3,1.4,1.4,4.7s-5.1,1.3-8.9-.8S12.5,212.3,12.5,212.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M22.4,223.8a18.5,18.5,0,0,0,3.8-.4l.7-.2-1.5-5.8-1.9-1,154.1-88.8c4.4-2.5,8-9.3,8-15V10.9l7.3-1.2V8.8A14,14,0,0,0,187.6,2a10.5,10.5,0,0,0-9.6-.8l-1.1.6L19.7,92.6c-4.3,2.4-7.9,9.2-7.9,14.9V212.1c0,.4-.2,7.4,4.9,10.4A10.8,10.8,0,0,0,22.4,223.8Zm2.6-1.7c-1.5.2-4.9.6-7.5-.9s-4-5.7-4.2-7.6V107.7c0-5.3,3.2-11.3,7.2-13.6L177.6,3.3c.4-.2.6-.4,1-.4h.3a9.8,9.8,0,0,1,7.8.9,10.2,10.2,0,0,1,4,4.9l-6.8,1V112.4c0,5.3-3.2,11.4-7.2,13.6L19.9,216.6l4.2,1.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M177.1,2.6l1.1-.6c1.7-1,5.5-1.3,8.9.8S191.8,9,191.8,9l-3.8.6a11.6,11.6,0,0,0-4.9-1.7,15.9,15.9,0,0,0-8.7-4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M26,222.7s-5.1,1.3-8.9-.8-4.6-9.6-4.6-9.6V107.7a18.9,18.9,0,0,1,3.4-10.2,12.6,12.6,0,0,0,7.8,4.5c4.3,1,13,81.2,16.1,104.2l-18,10.4,3,1.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M27.7,221.9l157.1-90.8c4.2-2.4,7.6-8.8,7.6-14.3V12.8c0-5.5-3.4-8.2-7.6-5.7L27.7,97.9c-4.2,2.4-7.6,8.9-7.6,14.3V216.4C20.3,221.7,23.5,224.4,27.7,221.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M24.8,223.6a8.2,8.2,0,0,0,3.4-.9l157.2-90.8c4.3-2.5,7.9-9.3,7.9-14.9V12.8c0-3.2-1.1-5.7-3-6.8s-3.6-.8-5.7.3L27.5,97.1c-4.4,2.5-8,9.3-8,15V216.2c0,3.3,1.2,5.7,3.1,6.9A4.5,4.5,0,0,0,24.8,223.6Zm2.5-2.4a4.3,4.3,0,0,1-4.2.3c-1.3-.7-2.2-2.8-2.2-5.3V112.1c0-5.3,3.2-11.4,7.1-13.7L185.2,7.7a4.1,4.1,0,0,1,4.2-.4c1.3.7,2.2,2.8,2.2,5.3V116.8c0,5.3-3.2,11.3-7.2,13.6Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M29.9,213.2l152.6-88.1c1.7-.9,3.1-3.6,3.1-5.7V18.1c0-2.3-1.4-3.2-3.1-2.3L29.9,103.9a7.2,7.2,0,0,0-3,5.7V210.9C26.9,213.2,28.4,214.2,29.9,213.2Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M28.8,214.4a3.3,3.3,0,0,0,1.5-.4l152.6-88.1a8.3,8.3,0,0,0,3.4-6.5V18.1a3.4,3.4,0,0,0-1.5-3.2,3.1,3.1,0,0,0-2.8.1L29.4,103.2a7.9,7.9,0,0,0-3.4,6.4V210.9a3.5,3.5,0,0,0,1.5,3.3A3.2,3.2,0,0,0,28.8,214.4Zm.8-1.9a1.6,1.6,0,0,1-1.2.2c-.4-.2-.5-1-.5-1.8V109.6a6.4,6.4,0,0,1,2.6-5.1L183.1,16.4a1.1,1.1,0,0,1,1.1-.2c.4.2.6.9.6,1.7V119.2a6.4,6.4,0,0,1-2.6,5.1Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M178.4,122.8c1.7-.9,3-3.6,3-5.6V16.4l1.1-.8c1.7-.9,3.1,0,3.1,2.3V119.2a6.9,6.9,0,0,1-3.1,5.7L29.9,213c-1.7,1-3,0-3-2.2v-.6Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M28.8,214.4a3.3,3.3,0,0,0,1.5-.4l152.6-88.1a8.3,8.3,0,0,0,3.4-6.5V18.1a3.4,3.4,0,0,0-1.5-3.2,3.1,3.1,0,0,0-2.8.1l-1.5,1V117.2a6.8,6.8,0,0,1-2.7,5.1L26,210v1.1a3.5,3.5,0,0,0,1.5,3.3ZM183.7,16.2h.4a2.3,2.3,0,0,1,.5,1.7V119.2a6.4,6.4,0,0,1-2.6,5.1L29.4,212.5a1.6,1.6,0,0,1-1.2.2,2.6,2.6,0,0,1-.5-1.8h0l151.1-87.2a8.2,8.2,0,0,0,3.4-6.4V16.9l.7-.3A1.5,1.5,0,0,1,183.7,16.2Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M19.2,109.4l.3-1.1a19.1,19.1,0,0,1-5.6-3.2l-.8.9A15.5,15.5,0,0,0,19.2,109.4Z"
      transform="translate(-1 -0.4)"
    />
    <path class="cls-4" d="M181.4,119.5l3.1,1.9-.7,1.1-3.1-1.9Z" transform="translate(-1 -0.4)" />
    <path
      class="cls-4"
      d="M78.3,197.7l-5.8,3.4a2.4,2.4,0,0,1-2.8-.2l-2.1-1.5a1.4,1.4,0,0,1,.2-2.3l5.6-3.5a2.4,2.4,0,0,1,2.9.1l2.2,1.7A1.4,1.4,0,0,1,78.3,197.7Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M71.2,202.2l1.7-.3,5.8-3.4a3,3,0,0,0,1.2-1.7,2.2,2.2,0,0,0-.8-1.9l-2.3-1.7a2.9,2.9,0,0,0-3.7-.2l-5.7,3.6a1.9,1.9,0,0,0-1,1.7,2.5,2.5,0,0,0,.8,1.9l2.1,1.5A2.7,2.7,0,0,0,71.2,202.2Zm3.6-8.1a3,3,0,0,1,1.1.4l2.3,1.7a.8.8,0,0,1,0,.8l-5.9,3.4a1.7,1.7,0,0,1-1.9-.2l-2.1-1.5a.5.5,0,0,1,0-.8l5.7-3.6C74.2,194.1,74.4,194.1,74.8,194.1Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M78.3,196.2l-5.8,3.4a2.4,2.4,0,0,1-2.8-.2l-2.1-1.5a1.4,1.4,0,0,1,.2-2.3l5.6-3.6a2.6,2.6,0,0,1,2.9.2l2.2,1.7A1.4,1.4,0,0,1,78.3,196.2Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M71.2,200.7l1.7-.3,5.8-3.4a3,3,0,0,0,1.2-1.7,2.2,2.2,0,0,0-.8-1.9l-2.3-1.7a2.9,2.9,0,0,0-3.7-.2l-5.7,3.6a1.8,1.8,0,0,0-1,1.7,2.5,2.5,0,0,0,.8,1.9l1.9,1.3A3,3,0,0,0,71.2,200.7Zm3.6-8.1a3,3,0,0,1,1.1.4l2.3,1.7a1,1,0,0,1,.1.4.4.4,0,0,1-.1.3l-5.9,3.4a1.5,1.5,0,0,1-1.9-.1l-2.1-1.6a.4.4,0,0,1-.2-.3.7.7,0,0,1,.2-.4l5.7-3.6C74.2,192.6,74.4,192.6,74.8,192.6Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M168.9,146.1l-21.7,12.5a3,3,0,0,1-2.9-.2l-2-1.5a1.4,1.4,0,0,1,.2-2.3L164,141.9a2.4,2.4,0,0,1,2.8.2l2.3,1.7C169.9,144.6,169.9,145.7,168.9,146.1Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M146,159.9a4.7,4.7,0,0,0,1.7-.4l21.6-12.7a2.2,2.2,0,0,0,.4-3.5l-2.3-1.8a3.1,3.1,0,0,0-3.8-.1L142.1,154a3,3,0,0,0-1.2,1.7,2.2,2.2,0,0,0,.8,1.9l2.1,1.5A3.3,3.3,0,0,0,146,159.9Zm22.5-14.4L146.8,158a1.4,1.4,0,0,1-1.9-.2l-2.1-1.5a.5.5,0,0,1,0-.8l21.6-12.6a1.7,1.7,0,0,1,2.1.2l2.2,1.7.2.3C168.7,145.1,168.7,145.3,168.5,145.5Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M168.9,144.6l-21.7,12.5a3,3,0,0,1-2.9-.2l-2-1.5a1.4,1.4,0,0,1,.2-2.3L164,140.4a2.1,2.1,0,0,1,2.8.2l2.3,1.7C169.9,143.1,169.9,144.2,168.9,144.6Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M146,158.4a4.7,4.7,0,0,0,1.7-.4l21.6-12.7a2.1,2.1,0,0,0,1.1-1.7,2.4,2.4,0,0,0-.7-1.9l-2.3-1.7a3.3,3.3,0,0,0-3.8-.2l-21.5,12.7a3,3,0,0,0-1.2,1.7,2.4,2.4,0,0,0,.8,1.9l2.1,1.5A4.9,4.9,0,0,0,146,158.4Zm22.5-14.6-21.7,12.5a1.4,1.4,0,0,1-1.9-.2l-2.1-1.5a.5.5,0,0,1,0-.8l21.6-12.6a1.7,1.7,0,0,1,2.1.2l2.2,1.7.2.3C168.7,143.6,168.7,143.8,168.5,143.8Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M275.3,207.6l2.6.4,16.9,9.6a5,5,0,0,1,.3,1.3l-5.2-3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M269.6,207a7.5,7.5,0,0,1,2.1.2L295,220.6c0,.4-.2.6-.2,1Z"
      transform="translate(-1 -0.4)"
    />
    <path class="cls-2" d="M264.9,207h1.7L294,222.9l-.6.8Z" transform="translate(-1 -0.4)" />
    <path
      class="cls-2"
      d="M250,201.3a25.6,25.6,0,0,1,3.4,1l7.1,4.1c.2.4.6.6.8,1h.8L292.5,225l-.8.7Z"
      transform="translate(-1 -0.4)"
    />
    <path class="cls-2" d="M243.9,200.6l2.1.2,44.6,25.7-.9.6Z" transform="translate(-1 -0.4)" />
    <path
      class="cls-2"
      d="M239,200.6h1.7L288.2,228c-.4.2-.6.4-1,.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M235,201l1.5-.2,49.2,28.3a3,3,0,0,1-1.1.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M231.4,201.7c.4-.2,1-.2,1.3-.4l50,28.8-1.4.4Z"
      transform="translate(-1 -0.4)"
    />
    <path class="cls-2" d="M228.2,202.7l1.1-.4,50,28.7-1.4.4Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M225.6,204l.9-.6,49,28.2-1.5.2Z" transform="translate(-1 -0.4)" />
    <path
      class="cls-2"
      d="M223.3,205.5c.2-.2.6-.4.7-.6l47.3,27.3h-1.7Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M221.8,207.2a3.5,3.5,0,0,0,.5-.8l44.5,25.8h-1.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M239.9,220.6c0-.4-.2-.5-.2-.9v-.2L261.3,232l-2.3-.2Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M221,209.7a1.8,1.8,0,0,1,.2-1l18.5,10.6a6.2,6.2,0,0,1-2-.2Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M221.2,211.5l12.3,7a25.5,25.5,0,0,1-3.2-.7l-8.1-4.7A7,7,0,0,1,221.2,211.5Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M240.9,222.7l13.8,7.9-3.8-1.1-8.5-4.9A4.5,4.5,0,0,1,240.9,222.7Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M293.3,215l-10.1-5.9C287.6,210.6,291.2,212.7,293.3,215Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M295.7,156.8l-10.6,12.3s15.7,1.5,21.8,8.7l7.5-11.3C314.4,166.6,311.2,160.4,295.7,156.8Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M306.9,179.1l8.3-12.6-.2-.4c-.2-.2-3.6-6.5-19.1-10.2l-.6-.2-12.1,14,1.6.2c.1,0,15.5,1.5,21.3,8.5Zm6.6-12.5-6.6,10.1c-5.5-5.5-16.1-7.6-20.1-8.2l9.3-10.7C308.4,160.8,312.4,165.3,313.5,166.6Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M286.3,154.9l-4.8,15.7s15-5.1,23.5-.9l2.3-13.5S302,152.1,286.3,154.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M280.4,171.8l1.5-.6c.2,0,14.8-4.9,22.9-1l.9.6,2.5-14.9-.4-.4c-.2-.2-5.8-4.5-21.7-1.5h-.6Zm16.1-4.6a48.9,48.9,0,0,0-13.6,2.1l4.1-13.6c12.5-2.3,18.2.2,19.5,1.1l-1.9,11.7A24.5,24.5,0,0,0,296.5,167.2Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M279.1,157.9l2.2,16.1s11.6-10.9,21-10.8l-3.6-13C298.7,150.4,292.1,148.9,279.1,157.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M280.8,175.9l1.1-1.1c.2-.2,11.4-10.8,20.4-10.6h1.2l-4-14.6-.4-.2c-.4,0-7.2-1.5-20.2,7.8l-.4.4Zm20.6-13.2c-7.8.4-16.3,7.2-19.3,9.8L280,158.3c10.4-7.2,16.5-7.3,18.2-7.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M235.8,208.4l.4-1.5a6.9,6.9,0,0,1,.5-1.3l7.6-7.2.7-.6,4-2.2a2.2,2.2,0,0,1,1-.2l2.2.9,1.9,3.4-.7,2.9-12,10.6-5.1-3.3a1.9,1.9,0,0,1-.9-1.7C235.6,208.6,235.8,208.6,235.8,208.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M241.6,214.5l12.5-11.2,1-3.4-2.3-3.9-2.7-1.2a1.8,1.8,0,0,0-1.7.2l-3.9,2.3a2.2,2.2,0,0,0-1,.9l-7.5,7a10.6,10.6,0,0,0-1,1.7l-.4,1.5v.4a2.4,2.4,0,0,0,1.4,2.5Zm11.2-12.1-11.4,10-4.5-2.8a1.1,1.1,0,0,1-.6-.8l-.7-.4.7.2.4-1.5c0-.4.2-.6.6-.9l7.6-7c.1-.4.3-.4.5-.6l4-2.3c.2-.2.2,0,.2,0l2.1,1,1.7,2.8Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M244.3,198.6l.7-.6,4-2.2a2.2,2.2,0,0,1,1-.2l2.2.9,5.5,3.4v.2l-4.3,2.9-5.5,4.3c-1.3-.8-3.6,2.8-3.8,2.8l-1-.3-6.2-3.8a.4.4,0,0,1,0-.6Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M244.3,210.9c.4,0,.7-.4,1.1-1s1.9-2,2.3-2l.4.3.5-.3,5.5-4.4,4.7-3v-.6a.8.8,0,0,0-.3-.7l-5.7-3.4-2.3-1a1.8,1.8,0,0,0-1.7.2l-3.9,2.3-1,.7-7.4,7a1.5,1.5,0,0,0-.2,1c0,.4.2.5.6.7l6.2,3.8c.2.2.6.2,1.2.4Zm3.4-4.5c-1.3,0-2.7,1.5-3.4,2.4l-.2.2-.4-.2-5.7-3.4,7-6.4c.2-.2.4-.4.6-.4l4-2.3c.2-.2.2,0,.2,0l2.2,1,4.6,2.8-3.4,2.1Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M258.5,200.9v1.7A2.7,2.7,0,0,1,257,205l-14.4,8.4c-1,.5-1.7-.2-1.3-1.6l.3-1.5.6-1.3,7.6-7.2c.2-.2.5-.5.7-.5l4-2.3a1.8,1.8,0,0,1,.9-.2l2.3.9A1.4,1.4,0,0,1,258.5,200.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M242,214.5a2.1,2.1,0,0,0,1.1-.4l14.4-8.3a3.6,3.6,0,0,0,1.9-3.2v-1.7a1.8,1.8,0,0,0-.9-1.7l-2.3-1a1.7,1.7,0,0,0-1.7.2l-4,2.3a2.6,2.6,0,0,0-.9.9l-7.6,7a9.5,9.5,0,0,0-.9,1.7l-.4,1.5a2.2,2.2,0,0,0,.6,2.3A.7.7,0,0,0,242,214.5Zm15.7-13.8v1.9a4.8,4.8,0,0,1-.9,1.9l-14.4,8.3h-.2v-.6l.4-1.5c0-.4.2-.6.5-.9l7.6-7c.2-.4.4-.4.6-.6l3.9-2.3c.2-.2.2,0,.2,0Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M249.6,200.7c-2.9.2-5.3-1-5.5-2.5a1.5,1.5,0,0,1,.2-.9,4.7,4.7,0,0,1,2.8-2.3,8,8,0,0,1,4.2,0,4.1,4.1,0,0,1,3,2.5v.2c0,.1.2.1.2.3S252.6,200.7,249.6,200.7Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M249.2,201.6h.4a6.6,6.6,0,0,0,5.1-1.9,2.5,2.5,0,0,0,.7-1.9v-.3l-.2-.4v-.2a5.3,5.3,0,0,0-3.5-2.8,9.6,9.6,0,0,0-4.6,0,6,6,0,0,0-3.4,2.8,2.8,2.8,0,0,0-.4,1.3C243.5,200.3,246,201.6,249.2,201.6Zm4.5-3.8v.2a.7.7,0,0,1-.2.6,5.4,5.4,0,0,1-3.9,1.3c-2.7,0-4.6-.9-4.6-1.7s0-.2.2-.4a4.6,4.6,0,0,1,2.5-2,6.5,6.5,0,0,1,3.8,0A2.8,2.8,0,0,1,253.7,197.8Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M249.6,197.8c1.7,0,3.2-.7,3-1.7s-1.5-1.5-3.4-1.5-3.2.8-3,1.7S247.7,197.8,249.6,197.8Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M249.4,198.6h.2a5,5,0,0,0,3.4-1.3,2,2,0,0,0,.5-1.3c-.1-1.4-1.8-2.3-4.1-2.3A4.8,4.8,0,0,0,246,195a2.2,2.2,0,0,0-.6,1.3C245.4,197.7,247.1,198.6,249.4,198.6Zm.2-1.5c-1.7,0-2.5-.6-2.5-.8v-.2a3.9,3.9,0,0,1,2.3-.7,3.5,3.5,0,0,1,2.4.7v.2A2.8,2.8,0,0,1,249.6,197.1Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M246.4,196.3l6.2-.2a163,163,0,0,0-5.1-34.6l3-14.9a39.6,39.6,0,0,1,8.3-17.4l-4.7-4a48.2,48.2,0,0,0-9.6,20.3l-3.2,16.4v.8A152.4,152.4,0,0,1,246.4,196.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M250.5,156.6v1.2a17.4,17.4,0,0,1-.5,3.9,7.8,7.8,0,0,1-8.2,6.3c-.4,0-.5-.2-.5-.4s-2.7-6.8-1.6-11.2a6.9,6.9,0,0,1,3.8-4.7,5.4,5.4,0,0,1,7.2,4.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M241.8,168.7a10,10,0,0,0,6.5-2.2,9,9,0,0,0,2.6-4.8,15.5,15.5,0,0,0,.6-3.9v-1.7a6.2,6.2,0,0,0-3.1-4.6,6.6,6.6,0,0,0-5.3-.5,7.6,7.6,0,0,0-4.1,5.2c-1.1,4.6.9,10.1,1.5,11.8A1.5,1.5,0,0,0,241.8,168.7Zm3.2-16.6a4.7,4.7,0,0,1,2.5.7,4.6,4.6,0,0,1,2.3,3.3v1.7a14.1,14.1,0,0,1-.6,3.7,7.4,7.4,0,0,1-2.1,3.8,8.1,8.1,0,0,1-5.3,1.9c-.5-1.3-2.4-6.4-1.3-10.6.6-2.1,1.7-3.6,3.2-4.1A1.8,1.8,0,0,1,245,152.1Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M239.9,163.6a15.9,15.9,0,0,1-.3-7.2,6.8,6.8,0,0,1,.9-2.2,10.7,10.7,0,0,1,4.5.3,2.9,2.9,0,0,1,1.9,2.7c0,.7-.2,1.9-.3,3a4.8,4.8,0,0,1-5.3,3.8A2.9,2.9,0,0,1,239.9,163.6Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M241.8,164.9a5.6,5.6,0,0,0,5.5-4.5,17.5,17.5,0,0,0,.4-3.2,3.8,3.8,0,0,0-2.5-3.6,11.6,11.6,0,0,0-4.9-.4h-.4l-.2.2a14.5,14.5,0,0,0-.9,2.5,14,14,0,0,0,.4,7.5v.4l.4.2,1.5.6A.8.8,0,0,0,241.8,164.9Zm.2-10a6.8,6.8,0,0,1,2.7.4,1.9,1.9,0,0,1,1.3,1.9,13.5,13.5,0,0,1-.4,2.8,3.9,3.9,0,0,1-4.3,3.2h-.8a14.5,14.5,0,0,1-.2-6.5l.6-1.7Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M239.7,99.7l1.7-13.8a25.2,25.2,0,0,1,8-15.3L245.2,66a30.8,30.8,0,0,0-9.8,19.1l-1.7,13.8Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M253.5,128.4a4.9,4.9,0,0,1,.8-4.1,11.8,11.8,0,0,1,3.4-2.8l2.5,2.2,1.1,7.8a.4.4,0,0,1-.4.4,12.6,12.6,0,0,1-4.5-.2h-.2A5.5,5.5,0,0,1,253.5,128.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M259.2,132.6a8.2,8.2,0,0,0,2.1-.2,1,1,0,0,0,.8-.4,2,2,0,0,0,.1-.9l-1.3-7.9-3-2.9-.6.4a15.8,15.8,0,0,0-3.6,3,4.9,4.9,0,0,0-.9,4.9c.6,2.1,1.9,3.6,3.6,3.8h.2C256.6,132.2,257.5,132.6,259.2,132.6Zm1.5-1.7a11.6,11.6,0,0,1-3.7-.2h-.2a3.7,3.7,0,0,1-1.7-5.8v-.2a12.7,12.7,0,0,1,2.7-2.3l1.7,1.7Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M256.4,127.3c.7,3,3.2,4.9,5.3,4.4s3.2-3.4,2.2-6.5-3.2-4.9-5.2-4.3S255.4,124.5,256.4,127.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M260.9,132.4a1.5,1.5,0,0,0,1-.2,4.1,4.1,0,0,0,2.8-2.8,6.9,6.9,0,0,0,.2-4.5,6.1,6.1,0,0,0-2.5-3.8,3.9,3.9,0,0,0-3.7-1c-2.5.8-3.8,4-2.9,7.4a6.7,6.7,0,0,0,2.5,3.8A2.7,2.7,0,0,0,260.9,132.4Zm-1.5-10.8a2.6,2.6,0,0,1,1.9.8,6.2,6.2,0,0,1,1.9,3,5.5,5.5,0,0,1,0,3.6,3.6,3.6,0,0,1-1.7,1.9,3,3,0,0,1-2.5-.6,5.8,5.8,0,0,1-1.9-3c-.7-2.4.2-4.9,1.9-5.5C259,121.6,259.2,121.6,259.4,121.6Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M261.5,112.4c0-.4,18.7,11.1,18.7,11.1v.2c0,.8-.2,5.3-1.9,8.3a12.8,12.8,0,0,1-10.2,6.8c-.4,0-.6-.1-.6-.5l1.2-6.4c0-.2,0-.4-.2-.4C263,125.6,261.7,115.2,261.5,112.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M268.1,139.6a14,14,0,0,0,11.2-7.4,22,22,0,0,0,2-8.7.9.9,0,0,0-.1-.5l-.2-.2-.2-.2c-18.9-11.5-19.1-11.5-19.7-11.2l-.4.2v.6c.2,3,1.5,13.4,7.2,19.3l-1.1,6.2a1.2,1.2,0,0,0,.4,1.1C267.4,139.4,267.7,139.6,268.1,139.6Zm9.5-7.7a12.2,12.2,0,0,1-9.1,6l1.1-6a1.5,1.5,0,0,0-.4-1.2c-4.7-4.7-6.2-13-6.6-17,3.1,1.7,11.2,6.6,17,10.2,0,1.1-.3,5.1-1.8,7.6Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M273.2,127.7h0c0,1.5-.7,14.7-8.7,10.2s-9.8-18.2-10-21.2a.4.4,0,0,1,.6-.4l16,7.4.2.2Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M267.5,139.6a3.5,3.5,0,0,0,2.1-.6c3.8-2,4.4-9.6,4.4-11.1a.7.7,0,0,0-.2-.6l-1.9-4-.6-.5-16-7.4c-.4-.2-1-.2-1.2.2a1.1,1.1,0,0,0-.6,1.1c.4,4,2.1,17.2,10.4,22A8.8,8.8,0,0,0,267.5,139.6Zm5-11.5c-.2,3-1,8.3-3.6,9.6s-2.5.4-4-.6c-7.4-4.1-9.1-16-9.5-19.8l15.4,7Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M279.5,125l-4,2.3a3.3,3.3,0,0,1-3.8,0l-16.5-9.8a1.7,1.7,0,0,1,0-2.7l3.8-2.2a3.3,3.3,0,0,1,3.8,0l16.7,9.8A1.4,1.4,0,0,1,279.5,125Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M273.6,128.6a6.4,6.4,0,0,0,2.3-.5l3.9-2.3a2.1,2.1,0,0,0,1.2-2.1,2.2,2.2,0,0,0-1.2-2.1l-16.6-9.8a5.5,5.5,0,0,0-4.7,0l-3.8,2.3a2.1,2.1,0,0,0-1.2,2.1,2,2,0,0,0,1.2,2l16.4,9.9A7.4,7.4,0,0,0,273.6,128.6Zm-12.7-15.8a3.7,3.7,0,0,1,1.5.3l16.7,9.9a.7.7,0,0,1,.4.7.8.8,0,0,1-.4.8l-4,2.2a2.7,2.7,0,0,1-3,0l-16.5-9.8a.7.7,0,0,1-.4-.7c0-.2,0-.4.4-.8l3.8-2.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M266.2,135.4h1.7v-4.5a6.1,6.1,0,0,0-2.8-5.1,2.6,2.6,0,0,0-2.9,0,2.7,2.7,0,0,0-1.3,2.5v3.9h1.7v-3.9a1.1,1.1,0,0,1,.6-1,1.1,1.1,0,0,1,1.1,0,4.2,4.2,0,0,1,2.1,3.6v4.5Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M270.9,123.3a2,2,0,0,0,2.1-2v-6.5a2,2,0,0,0-2.1-2,2,2,0,0,0-2,2v6.5A2,2,0,0,0,270.9,123.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M263.8,119.2a2.1,2.1,0,0,0,2-2.1v-6.4a2,2,0,0,0-2-2.1,2.1,2.1,0,0,0-2.1,2.1v6.4A2.1,2.1,0,0,0,263.8,119.2Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M243,67c1.1-2.3,3-3.6,4.9-3.6a26.3,26.3,0,0,1,6.6.2l.4,4.7-6.3,9.5a.7.7,0,0,1-.7.2,28.6,28.6,0,0,1-4.8-4.6v-.2C241.6,71.7,241.6,69.4,243,67Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M248.3,78.9h.1a1.1,1.1,0,0,0,1-.6l6.2-9.6-.5-5.7-.6-.2a23.5,23.5,0,0,0-6.8-.2c-2.1,0-4.4,1.7-5.5,4s-1.3,5.3.2,7l.2.2a19.8,19.8,0,0,0,4.9,4.7A1,1,0,0,0,248.3,78.9Zm5.6-10.6-5.8,8.9a20.2,20.2,0,0,1-4.4-4.2h-.2c-1.1-1.2-1.1-3.3,0-5.3s2.7-3.3,4.2-3.3h.2a18.4,18.4,0,0,1,5.5.2Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M246.7,68.7c-1.9,4-1.3,8.3,1.6,9.6s6.8-.5,8.7-4.5,1.3-8.3-1.6-9.6S248.8,64.7,246.7,68.7Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M250.3,79.7a6,6,0,0,0,3.1-.8,10.9,10.9,0,0,0,5.4-10.8,5.4,5.4,0,0,0-3-4.5,6,6,0,0,0-5.5.2,10.9,10.9,0,0,0-5.4,10.8,5.7,5.7,0,0,0,3,4.5A5.3,5.3,0,0,0,250.3,79.7Zm3.2-15.4a3.8,3.8,0,0,1,1.6.4,3.9,3.9,0,0,1,2,3.4,9.1,9.1,0,0,1-.9,5.3,10.5,10.5,0,0,1-3.8,4,4.7,4.7,0,0,1-4,.2,4.1,4.1,0,0,1-2-3.4,9.1,9.1,0,0,1,.9-5.3,10.5,10.5,0,0,1,3.8-4A14,14,0,0,1,253.5,64.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M281.7,81.9a9.5,9.5,0,0,1-.5,8.7c-1.9,3.4-1.2,10.2-.6,14a55.3,55.3,0,0,1,.7,7l.2,2.9a1.2,1.2,0,0,1-.5.9l-8.4,4.5h-.1c-1.6-1.7-19.7-23.6-20.1-24.2s4.4-15.9,4.2-16.4,14.5-6.1,14.5-6.1l4.4.8,3.6,3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M272.6,120.5c.2,0,.4,0,.4-.2l8.3-4.5a2.1,2.1,0,0,0,1-1.7l-.2-2.9c-.2-2.4-.4-4.7-.8-7s-1.3-10.2.4-13.4c2.7-5.1.8-9.1.6-9.4l-2.5-5.1L275.9,73l-5-.7h-.1c-14.6,5.3-15.4,6-15.2,6.8s-.9,3.6-1.7,6.2c-2.8,9.9-2.6,10.1-2.2,10.6s12.4,15.2,19.6,23.7l.4.5A1,1,0,0,0,272.6,120.5ZM281,82.3a8.5,8.5,0,0,1-.6,7.9c-1.9,3.6-1.3,9.9-.6,14.4.4,2.3.6,4.6.8,7l.2,2.9h0l-8,4.2v-.2L253.4,95.2c.1-1.2,1.5-6.1,2.4-9.3s1.7-5.7,1.7-6.4,8-3.4,13.8-5.5l4,.7,3.4,2.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M283,81.7a.8.8,0,0,1-1.5.2,4.5,4.5,0,0,0-4.5-2.6c-4.5,0-11.2,7.5-7,19.3a44.7,44.7,0,0,1,2.5,21c0,.1-.2.1-.2.1l-17.2-10a12.3,12.3,0,0,1-5.5-6.6,72.3,72.3,0,0,1-3.2-11c-2.3-9.6-1-19.6,1.7-24.2s9.4-7.5,9.4-7.5,15,4.7,21.8,13C283,78,283.2,80.4,283,81.7Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M272.5,120.5h.3c.4-.2.6-.4.6-.8s1.5-10.7-2.5-21.5c-2.8-8-.3-12.9,1-14.8s3.6-3.4,5.3-3.4a3.9,3.9,0,0,1,3.8,2.3,1.8,1.8,0,0,0,1.7,1c.7-.2,1.3-.6,1.3-1.4s-1-5.3-3.8-8.9c-6.8-8.3-21.5-13-22.1-13.2l-.4-.2-.4.2c-.3.2-7.2,3.6-9.8,7.8s-4.2,14.5-1.9,24.7a108.9,108.9,0,0,0,3.2,11,14.3,14.3,0,0,0,5.9,7l17.2,10A.7.7,0,0,0,272.5,120.5Zm4.7-42c-2.3,0-4.7,1.5-6.6,4.2-3.1,4.3-3.4,10.2-1.2,16.2a41.9,41.9,0,0,1,2.5,19.7L255.6,109a12.2,12.2,0,0,1-5.1-6.1,110.5,110.5,0,0,1-3.2-10.8c-2.3-9.8-.7-19.4,1.7-23.6s7.6-6.4,8.9-7,15.1,5.3,21,12.7c2.6,3.2,3.8,5.6,3.4,7.5l.7.2-.7-.2C281.9,80.4,280.4,78.5,277.2,78.5Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M249.2,81.4a57.4,57.4,0,0,0,14.7,8.7c.2,0,.2.1.2.3s-.2,4.2,1.2,6.8c0,.2,0,.2-.2.2a55.9,55.9,0,0,1-14.8-8.7v-.2A24,24,0,0,1,249.2,81.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M265.3,98.2a1.3,1.3,0,0,0,.7-.4c.2-.4.4-.7.2-1.1a13.7,13.7,0,0,1-1.1-6.5,1.1,1.1,0,0,0-.8-1.1c-1.3-.6-8.5-3.4-14.5-8.5l-1.4-1.1v1.7a19.2,19.2,0,0,0,1.4,7.5l.2.4v.2a66.9,66.9,0,0,0,15,8.7A.2.2,0,0,0,265.3,98.2Zm-1.9-7.6a25,25,0,0,0,.5,5.5,55.2,55.2,0,0,1-12.8-7.7,18.5,18.5,0,0,1-1.1-5.3A59.8,59.8,0,0,0,263.4,90.6Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M255.1,105.6a37.2,37.2,0,0,1-3.8-11,58.8,58.8,0,0,0,13.2,7.2,1.9,1.9,0,0,1,1.3,1.3,36.1,36.1,0,0,1,1.6,9.5c0,.3-.4.5-.8.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M267,113.7c.2,0,.4,0,.5-.2a1.3,1.3,0,0,0,.6-1.1,43.8,43.8,0,0,0-1.5-9.7,2.3,2.3,0,0,0-1.7-1.7,53.5,53.5,0,0,1-13.1-7l-.3-.3-1,.5v.6c.2.7,1.5,7,4,11.3l.2.2,11.7,7.2ZM252.6,96.3a59.7,59.7,0,0,0,11.7,6.1,1.1,1.1,0,0,1,.8.7,52.9,52.9,0,0,1,1.5,8.5L255.8,105A42.6,42.6,0,0,1,252.6,96.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M264.7,87l.6-1.5a55.6,55.6,0,0,1-14.8-8.7L249.4,78C255.8,83.8,264.3,86.8,264.7,87Z"
      transform="translate(-1 -0.4)"
    />
    <path class="cls-2" d="M280.4,108.6a30,30,0,0,1-6.2,2.6Z" transform="translate(-1 -0.4)" />
    <path
      class="cls-4"
      d="M274.4,112a36.3,36.3,0,0,0,6.4-2.8l-.8-1.4a38,38,0,0,1-6,2.7Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M273.8,84.4c1.9-4,5.8-6.1,8.7-4.6a6.6,6.6,0,0,1,1.5,1.4,8.7,8.7,0,0,1,2.3,6.2,9.2,9.2,0,0,1-3.1,5.5c-2,2.1-5.3,1.7-6.6,1.5h-.4c-.3,0-.5-.2-.9-.4C272.5,92.5,271.9,88.2,273.8,84.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M278.5,95.4a7.4,7.4,0,0,0,5.3-1.9,9,9,0,0,0,.8-13.1,8,8,0,0,0-1.7-1.5,6,6,0,0,0-5.5.2,10.1,10.1,0,0,0-4.4,4.5c-2.2,4.4-1.3,9.1,1.9,10.8.2.2.6.2.8.4h.7A2.7,2.7,0,0,0,278.5,95.4ZM280.6,80a5.3,5.3,0,0,1,1.7.4,3.6,3.6,0,0,1,1.3,1.2,7.3,7.3,0,0,1,2.1,5.6,7.9,7.9,0,0,1-2.7,4.9c-1.8,1.7-4.9,1.6-6,1.4h-.2a2,2,0,0,1-.7-.2c-2.5-1.2-3.1-5.1-1.2-8.7a10.5,10.5,0,0,1,3.8-4A2.7,2.7,0,0,1,280.6,80Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M279.3,87.2c-1.2,2.5-.8,5.1.9,6.1s4.2-.4,5.3-2.9.8-5.1-.9-6S280.6,84.8,279.3,87.2Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M281.5,94.2c1.9,0,3.8-1.3,5-3.6a6.3,6.3,0,0,0,.7-3.9,3.9,3.9,0,0,0-2.1-3.1,3.9,3.9,0,0,0-3.6.2,8.2,8.2,0,0,0-2.8,3c-1.3,2.9-.8,6.1,1.3,7A2,2,0,0,0,281.5,94.2Zm1.9-9.2h1a3.2,3.2,0,0,1,1.1,1.9,4.4,4.4,0,0,1-.6,3.1c-.9,2-3,3-4.3,2.4s-1.5-2.8-.6-4.9a6.7,6.7,0,0,1,2.1-2.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M273,132.6c2.1-1.9,4.9-2.3,6.3-.9a1.6,1.6,0,0,1,.5,1.1,5.3,5.3,0,0,1,0,4.3,5.7,5.7,0,0,1-3,2.7c-1.7.8-3.6-.2-4.3-.6a.2.2,0,0,1-.2-.2c-.2-.2-.4-.2-.4-.3S270.9,134.7,273,132.6Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M275.3,141.1a8.1,8.1,0,0,0,1.9-.4,7.6,7.6,0,0,0,3.4-3,6.4,6.4,0,0,0,0-4.9,2.9,2.9,0,0,0-.8-1.3,3.8,3.8,0,0,0-3.6-1.2,8.2,8.2,0,0,0-3.7,1.9,6.9,6.9,0,0,0-2.1,3.8,4,4,0,0,0,.9,3.6l.4.4.2.2a.2.2,0,0,1,.2.2A10.9,10.9,0,0,0,275.3,141.1Zm1.7-9.4a2.6,2.6,0,0,1,1.7.5,1.5,1.5,0,0,1,.4.8,4.8,4.8,0,0,1,0,3.8,5.3,5.3,0,0,1-2.7,2.2c-1.3.6-3-.2-3.6-.5h-.2c-.1-.2-.1-.2-.3-.2a2.3,2.3,0,0,1-.6-2.3,5.2,5.2,0,0,1,1.7-2.8,6.1,6.1,0,0,1,3-1.5Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M275.7,135.6c-1.3,1.2-1.5,3.1-.8,3.8s2.7.8,4-.6,1.5-3,.7-3.7S277,134.5,275.7,135.6Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M276.4,140.9a4.2,4.2,0,0,0,3.1-1.3,3.8,3.8,0,0,0,1.3-2.5,2.6,2.6,0,0,0-.6-2.4,2.7,2.7,0,0,0-2.4-.8,3.9,3.9,0,0,0-2.5,1.4,3.3,3.3,0,0,0-1.3,2.4,3,3,0,0,0,.5,2.5A2.6,2.6,0,0,0,276.4,140.9Zm1.7-5.6a.9.9,0,0,1,.8.3.9.9,0,0,1,.2,1.2,2.9,2.9,0,0,1-1,1.5c-.9.9-2.2,1.1-2.6.5a.8.8,0,0,1-.2-1.1,2.9,2.9,0,0,1,.9-1.5,3.7,3.7,0,0,1,1.7-.8Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M263.9,224.9l.4-1.5c.2-.4.4-1,.6-1.3l7.6-7.2c.1-.2.5-.6.7-.6l4-2.3a1.8,1.8,0,0,1,.9-.2l2.3,1,1.9,3.4-.8,2.8-11.9,10.6-5.1-3.2a1.9,1.9,0,0,1-.9-1.7C263.9,225.1,263.9,225.1,263.9,224.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M270,230.9l12.5-11.1.9-3.4-2.2-4-2.7-1.1a1.7,1.7,0,0,0-1.7.2l-4,2.2a2.9,2.9,0,0,0-.9,1l-7.6,7a5.6,5.6,0,0,0-.9,1.7l-.4,1.5v.4a2.4,2.4,0,0,0,1.3,2.4Zm11.2-12.1-11.4,10.1-4.5-2.9a1,1,0,0,1-.6-.7l-.8-.4.8.2.4-1.5c0-.4.2-.6.6-1l7.5-7a.9.9,0,0,1,.6-.5l4-2.3c.1-.2.1,0,.1,0l2.1.9,1.7,2.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M272.6,215.1c.2-.2.6-.6.8-.6l4-2.3a1.8,1.8,0,0,1,.9-.2l2.3,1,5.5,3.4v.2l-4.4,2.8-5.5,4.4c-1.3-.8-3.6,2.8-3.7,2.8l-1-.4-6.2-3.8c-.2-.2-.2-.3,0-.5Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M272.6,227.3q.6,0,1.2-.9c1.3-1.7,2.1-2.1,2.3-2.1l.5.4.4-.4,5.5-4.3,4.7-3.1v-.5a1,1,0,0,0-.4-.8l-5.6-3.4-2.3-.9a1.7,1.7,0,0,0-1.7.2l-4,2.2a2.3,2.3,0,0,0-.9.8l-7.4,7a.8.8,0,0,0-.2.9c0,.4.2.6.6.8l6.2,3.8c.2.2.6.2,1.1.3Zm3.5-4.5c-1.4,0-2.7,1.5-3.5,2.7h-.5l-5.7-3.4,7-6.5c.2-.2.4-.4.6-.4l3.9-2.2c.2-.2.2,0,.2,0l2.3.9,4.5,2.9-3.4,2-5.3,4.2Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M286.8,217.5v1.7a2.6,2.6,0,0,1-1.5,2.5L270.9,230c-.9.6-1.7-.2-1.3-1.5l.4-1.5.6-1.4,7.5-7.1c.2-.2.6-.6.8-.6l4-2.3a1.6,1.6,0,0,1,.9-.2l2.3,1A1,1,0,0,1,286.8,217.5Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M270.4,230.9a2.3,2.3,0,0,0,1.1-.3l14.4-8.4a3.5,3.5,0,0,0,1.9-3.2v-1.7a1.8,1.8,0,0,0-1-1.7l-2.2-.9a1.7,1.7,0,0,0-1.7.2l-4,2.2a2.4,2.4,0,0,0-1,1l-7.5,7a5.9,5.9,0,0,0-1,1.7l-.3,1.5a2.5,2.5,0,0,0,.5,2.3A1,1,0,0,0,270.4,230.9Zm15.5-13.8V219a3.5,3.5,0,0,1-1,1.9l-14.3,8.3c-.2,0-.2.2-.2,0v-.5l.4-1.5a1.2,1.2,0,0,1,.5-1l7.6-7c.2-.4.4-.4.6-.6l3.9-2.2c.2-.2.2,0,.2,0Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M277.9,217.3c-2.8.2-5.3-.9-5.4-2.4a3.4,3.4,0,0,1,.1-1,4.7,4.7,0,0,1,2.9-2.2,7.7,7.7,0,0,1,4.1,0,4.3,4.3,0,0,1,3.1,2.4v.2c0,.2.2.2.2.4S280.8,217.1,277.9,217.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M277.6,218.1h.3a6.7,6.7,0,0,0,5.1-1.9,2.4,2.4,0,0,0,.8-1.9v-.2l-.2-.4v-.2a6.2,6.2,0,0,0-3.6-2.8,9.3,9.3,0,0,0-4.5,0,6.1,6.1,0,0,0-3.4,2.8,2.9,2.9,0,0,0-.4,1.4C271.9,216.8,274.3,218.1,277.6,218.1Zm4.5-3.8v.2a.7.7,0,0,1-.2.6,6.1,6.1,0,0,1-4,1.3c-2.6,0-4.5-1-4.5-1.7s0-.2.2-.4a4.6,4.6,0,0,1,2.5-2.1,7.5,7.5,0,0,1,3.7,0A3.1,3.1,0,0,1,282.1,214.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M277.9,214.3c1.7,0,3.3-.8,3.1-1.7s-1.5-1.5-3.4-1.5-3.3.7-3.1,1.7S276.1,214.5,277.9,214.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M277.6,215.2h.2a4.6,4.6,0,0,0,3.4-1.3,2.4,2.4,0,0,0,.5-1.3c-.2-1.3-1.9-2.5-4.1-2.3a4.5,4.5,0,0,0-3.4,1.4,1.8,1.8,0,0,0-.6,1.3C273.8,214.3,275.5,215.2,277.6,215.2Zm.3-3.4c1.6,0,2.3.6,2.3.8v.2a3.1,3.1,0,0,1-2.3.7c-1.5,0-2.4-.5-2.4-.7v-.2a3.1,3.1,0,0,1,2.3-.8Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M289.5,111.2l6.2-.3c-1.1-16.5-10.8-24.1-11.1-24.4l-3.8,4.9,1.9-2.5-1.9,2.5C281,91.6,288.5,97.6,289.5,111.2Z"
      transform="translate(-1 -0.4)"
    />
    <path class="cls-2" d="M289.5,118.6h6.2v28h-6.2Z" transform="translate(-1 -0.4)" />
    <path
      class="cls-3"
      d="M288.7,158.9l.6-.6a7.1,7.1,0,0,0,1.3-4.3c0-.2-.2-.4-.4-.2l-2.8.7c-.6,0-1.1-.5-1.3-1.5l-1-3.9a1.5,1.5,0,0,1,.2-1.4l2.9-3.7c.1-.2.3-.2.5-.2l3.4-1h.4a22.9,22.9,0,0,1,1.7,2.3c.2.2,0,.4-.2.4l-1.9.3a4.4,4.4,0,0,1,.6,1l.4.9v.2l.7,2.7a9.8,9.8,0,0,1,.4,5.3v.2l.8,2.6c0,.2,0,.4-.2.4l-3.6,1.1a2.7,2.7,0,0,1-2.1-.2C288.7,159.6,288.5,159.1,288.7,158.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M290.2,160.8h1l3.8-1.2a1,1,0,0,0,.7-1.3l-.7-2.6a15.2,15.2,0,0,0-.6-5.5l-1.1-3.8v-.2l.7-.2a.8.8,0,0,0,.8-.7,1.3,1.3,0,0,0-.2-1.2l-.4-.5-1.3-1.7a1.5,1.5,0,0,0-1.2-.4l-3.2.9a1.7,1.7,0,0,0-1.1.6l-2.8,3.8a2.5,2.5,0,0,0-.4,2.1l.9,3.9c.4,1.4,1.4,2.3,2.3,2.1h.2l2.3-.5a5.3,5.3,0,0,1-1,3.2l-.6.5c-.1.4-.3.8-.1,1.2a1.1,1.1,0,0,0,.7.9A2.2,2.2,0,0,0,290.2,160.8Zm3.8-2.7-3.2,1h-1.1l.2-.2a7.7,7.7,0,0,0,1.5-4.9,1.5,1.5,0,0,0-.4-1,1.5,1.5,0,0,0-1-.2l-2.8.8a1.4,1.4,0,0,1-.4-.9l-.9-4v-.8l2.8-3.6,3-.9c.2.4.8.9,1,1.3l-2.7.6,1.2,1.1c.2.2.4.4.4.6l.3.9.8-.2-.8.2.8,2.7a10.4,10.4,0,0,1,.4,4.9v.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M296.5,146.8l.7,2.6c1,3.1.8,6.1-.3,7.8a3.7,3.7,0,0,1-4.4,1.5.8.8,0,0,1-.2-.9l.6-.6c1.1-1.3,1.5-3.6,1.1-6.1-.2-.9-.7-1.7-1.3-1.7h-.8c-.5,0-.7.6-.7,1.4l.2,1.3a1.5,1.5,0,0,1-.4,1.3c-.6.4-1.3-.2-1.7-1.3l-1-4a1.6,1.6,0,0,1,.2-1.3l2.9-3.8a.6.6,0,0,1,.5-.2l1,.2.5.2,2.1,1.9.6.9.4.8Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M293.8,159.6a4,4,0,0,0,3.6-2c1.3-1.9,1.5-5.1.6-8.5l-.8-2.7v-.2l-.3-.9a4.9,4.9,0,0,0-.8-1.3l-2.1-1.9a1.5,1.5,0,0,0-.9-.4l-1-.2a1.8,1.8,0,0,0-1.3.6l-2.8,3.7a2.6,2.6,0,0,0-.4,2.1l.9,4a3.1,3.1,0,0,0,1.7,2.1,1.6,1.6,0,0,0,1.4-.2,1.8,1.8,0,0,0,.5-1.9l-.2-1.3v-.4h.6a3.1,3.1,0,0,1,.6.9c.3,2.3,0,4.4-1,5.5l-.5.6c-.2.4-.4.7-.2,1.1s.3.8.7,1A4,4,0,0,0,293.8,159.6Zm-.9-16,2.1,1.9c.1.2.3.3.3.5l.4,1,.8,2.6c.7,2.9.7,5.5-.4,7.2a2.8,2.8,0,0,1-3,1.3l.2-.2c1.3-1.5,1.7-3.9,1.3-6.8-.2-1.1-1-2.2-2.1-2.2h-.8l-1.1.3a2.1,2.1,0,0,0-.4,1.9l.2,1.4v.3a.7.7,0,0,1-.4-.7l-.9-4v-.7l2.8-3.6Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M296.7,112.9v1.2a20.9,20.9,0,0,1-.4,3.6,7.4,7.4,0,0,1-7.4,6c-.2,0-.6-.2-.6-.4s-2.6-6.2-1.8-10.2a5.8,5.8,0,0,1,3.2-4.5c2.6-1.3,6.4.7,6.8,3.8Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M288.9,124.7a9.2,9.2,0,0,0,6.1-2.5,8.1,8.1,0,0,0,2.2-4.3,32.9,32.9,0,0,0,.4-3.8v-1.7a5.8,5.8,0,0,0-3-4.2,5.3,5.3,0,0,0-4.9-.2,8,8,0,0,0-3.8,5.1c-.8,4.2,1.1,9.3,1.9,10.8S288.3,124.7,288.9,124.7Zm7-11.6v1a22.3,22.3,0,0,1-.4,3.4,6.7,6.7,0,0,1-1.9,3.6,6.3,6.3,0,0,1-4.7,1.9c-.6-1.5-2.4-5.9-1.7-9.7a5.5,5.5,0,0,1,2.8-4,4.5,4.5,0,0,1,3.6.2,3.9,3.9,0,0,1,2.1,2.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M287,119.9a16.3,16.3,0,0,1-.5-6.6,5.2,5.2,0,0,1,.7-2.1,12.7,12.7,0,0,1,4.2.2,2.8,2.8,0,0,1,1.9,2.5,15.2,15.2,0,0,1-.2,2.8,4.6,4.6,0,0,1-4.8,3.8C288,120.1,287.4,120.1,287,119.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M288.7,121.1a5.2,5.2,0,0,0,5.1-4.4,15.1,15.1,0,0,0,.2-3,3.2,3.2,0,0,0-2.4-3.2,13.6,13.6,0,0,0-4.8-.2l-.3.2-.2.2a4.9,4.9,0,0,0-.8,2.2,14.4,14.4,0,0,0,.6,7l.2.4.3.2a3.8,3.8,0,0,0,1.6.4C288.3,121.1,288.5,121.1,288.7,121.1Zm.4-9.3a8.2,8.2,0,0,1,2.1.2,1.7,1.7,0,0,1,1.1,1.7,11.8,11.8,0,0,1-.2,2.6,3.7,3.7,0,0,1-3.8,3.1,1.1,1.1,0,0,1-.7-.2,12.4,12.4,0,0,1-.4-5.9,5.8,5.8,0,0,1,.6-1.5Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M274.5,213.4l5.7-2.5c-.2-.2-10.6-25.2-10.2-35.9.2-4.4,2.1-9.7,5.3-15.5a37.6,37.6,0,0,0,4.9-21.6l-6.2.6a31.9,31.9,0,0,1-4,17.9c-4,6.8-6.1,13.1-6.2,18.4C263.4,186.9,274,212.2,274.5,213.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M272.6,174v1.2a25.6,25.6,0,0,1-.3,3.9,7.6,7.6,0,0,1-2.3,4.4,8,8,0,0,1-5.9,2.2.9.9,0,0,1-.7-.3c-.8-1.5-2.9-6.8-1.9-11.2a7,7,0,0,1,3.6-4.9c3-1.3,7,.8,7.4,4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M264.1,186.5a9.9,9.9,0,0,0,6.5-2.6,11.5,11.5,0,0,0,2.4-4.8,14.3,14.3,0,0,0,.4-3.9v-1.7a5.5,5.5,0,0,0-3.2-4.4,6.2,6.2,0,0,0-5.3-.4,7.4,7.4,0,0,0-4,5.5c-.9,4.5,1.3,10,2.1,11.5S263.6,186.5,264.1,186.5Zm7.6-12.3v1.1a29,29,0,0,1-.4,3.8,6.8,6.8,0,0,1-1.9,4,7.5,7.5,0,0,1-5.3,2.1c-.5-1.3-2.6-6.5-1.9-10.6a6.1,6.1,0,0,1,3.1-4.4,5.3,5.3,0,0,1,3.9.2,4.3,4.3,0,0,1,2.3,3.2Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M262.2,181.6c-.5-2.1-1.1-4.9-.5-7.2a20.2,20.2,0,0,1,.7-2.3,10.2,10.2,0,0,1,4.6.2,2.9,2.9,0,0,1,1.9,2.7,17.3,17.3,0,0,1-.2,3,4.8,4.8,0,0,1-5.1,4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M263.9,182.7a5.6,5.6,0,0,0,5.5-4.7,17.2,17.2,0,0,0,.2-3.2,3.5,3.5,0,0,0-2.6-3.4,9.8,9.8,0,0,0-4.9-.2l-.4.2-.2.2a8.7,8.7,0,0,0-1,2.4,20.8,20.8,0,0,0,.6,7.6l.2.4.4.2a6.5,6.5,0,0,0,1.7.3A.6.6,0,0,0,263.9,182.7Zm.4-10a4.7,4.7,0,0,1,2.3.4,1.8,1.8,0,0,1,1.3,1.9,13.2,13.2,0,0,1-.2,2.8,4,4,0,0,1-4.3,3.4c-.4,0-.6,0-.8-.2a18.2,18.2,0,0,1-.4-6.4l.6-1.7A3.6,3.6,0,0,1,264.3,172.7Z"
      transform="translate(-1 -0.4)"
    />
    <g id="robotarm">
      <path
        class="cls-2"
        d="M223.7,110.3c4.9,0,9.6-2.1,13.6-6.4l-4.6-4.2c-6,6.4-12.4,4.7-16.6,2.1a86.4,86.4,0,0,0-8.9-4.7l-1.3-.6-2.5,5.7,1.4.5a85.8,85.8,0,0,1,8.1,4.4A21.9,21.9,0,0,0,223.7,110.3Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M192.1,98.8l.7.3a6.1,6.1,0,0,0,4.6,0c.2,0,.2-.2.2-.3l-1.5-2.5c-.2-.6.2-1.3,1.1-1.7l3.6-2.1c.6-.2.9-.4,1.3-.2l4.4,1.9q.3,0,.3.6l1.9,3v.4l-1.7,2.3c-.2.2-.3.2-.5,0l-1-1.7a2.3,2.3,0,0,1-.7.7l-.8.6a.2.2,0,0,0-.2.2l-2.4,1.5a15.5,15.5,0,0,1-5,1.9h-.1l-2.5,1.3c-.2,0-.4,0-.4-.2l-2.1-3.2a4.2,4.2,0,0,1-.3-1.9A1.2,1.2,0,0,1,192.1,98.8Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-2"
        d="M194,105.6c.2,0,.4,0,.5-.2l2.3-1.3a15.2,15.2,0,0,0,5.1-1.9l3.4-2.1h.2l.4.6a1.2,1.2,0,0,0,.9.5,1.5,1.5,0,0,0,1-.4l.4-.5,1.3-1.7a1.3,1.3,0,0,0,0-1.2l-1.7-2.8c-.2-.4-.4-.8-.8-.9l-4.3-1.9a2.7,2.7,0,0,0-2.1.2L197,94c-1.1.6-1.9,1.9-1.5,2.7v.2l1.1,1.9a9.3,9.3,0,0,1-3.4-.2l-.7-.4a.9.9,0,0,0-1.2.2,1.3,1.3,0,0,0-.7,1.1,6.6,6.6,0,0,0,.5,2.5l2.1,3.4Zm9.4-6.3-2.4,1.5a9.3,9.3,0,0,1-4.6,1.7h-.1l-.2.2-1.9,1.2-1.7-2.9a2,2,0,0,1-.2-1.1l.4.2a7.9,7.9,0,0,0,5.1.2,1.9,1.9,0,0,0,.7-.8q.3-.6,0-.9L197,96.1a1.8,1.8,0,0,1,.8-.7l3.6-2.1a1.1,1.1,0,0,1,.7-.2l4.4,1.9,1.7,2.8a14.7,14.7,0,0,1-1,1.3l-1.1-2.2-.8,1.5c0,.2-.2.4-.5.5l-1.4.4.4.8Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-4"
        d="M238.6,103.1l-.7.8a16.5,16.5,0,0,1-3.1,2,7.7,7.7,0,0,1-4.3,1.2,7.1,7.1,0,0,1-5.1-2.7c-.2-.2-.2-.3-.2-.7s3-6.1,6.6-8.2a6.4,6.4,0,0,1,5.5-.5c2.8,1.1,3.6,5.3,1.7,7.5Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-2"
        d="M231,107.8a8.2,8.2,0,0,0,4.4-1.1,12.9,12.9,0,0,0,3-2.1,2.9,2.9,0,0,0,.8-.7l.4-.4a5.6,5.6,0,0,0,1.1-4.9,5.7,5.7,0,0,0-3-4,7.1,7.1,0,0,0-6.3.6c-3.8,2-6.2,7-6.8,8.5a1.4,1.4,0,0,0,.2,1.5,9.7,9.7,0,0,0,5.7,2.8A.6.6,0,0,1,231,107.8Zm7-5.3-.7.8a18.2,18.2,0,0,1-2.9,2.1,5.7,5.7,0,0,1-3.7.9,8.5,8.5,0,0,1-4.6-2.2c.8-1.6,2.9-5.7,6.3-7.6a5.1,5.1,0,0,1,4.9-.4,3.5,3.5,0,0,1,2.1,2.8,3.8,3.8,0,0,1-.8,3.5Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-2"
        d="M231.2,104.2a5.2,5.2,0,0,0,2.9-.7,24.9,24.9,0,0,0,2.4-1.7,3.2,3.2,0,0,0,.8-4,9.9,9.9,0,0,0-3-3.6l-.2-.2h-.4a5.8,5.8,0,0,0-2.3,1,13.4,13.4,0,0,0-4.9,5.1l-.2.4.2.3a5,5,0,0,0,.8,1.4A4.3,4.3,0,0,0,231.2,104.2Zm2.5-8.5a9.6,9.6,0,0,1,2.1,2.7,1.7,1.7,0,0,1-.4,2.1,11.3,11.3,0,0,1-2.1,1.5,3.5,3.5,0,0,1-4.7-1l-.4-.5a12.9,12.9,0,0,1,4.2-4.2Z"
        transform="translate(-1 -0.4)"
      />
      <path class="cls-3" d="M176.6,61.9l27.4,52-2.1,1.1L174.4,63Z" transform="translate(-1 -0.4)" />
      <path
        class="cls-2"
        d="M177.8,60.7l27.5,52.1-2.2,1.1-27.4-52Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-2"
        d="M197.6,107.3a12.4,12.4,0,0,0,6.2-2.1l2.5-1.5a.2.2,0,0,0,.2-.2l.7-.6a5,5,0,0,0,1-1.1l1.1-2.5a1.8,1.8,0,0,0,.2-.9v-1a1.3,1.3,0,0,0-1-1.1l-4.3-1.9a2.7,2.7,0,0,0-2.1.2l-3.6,1.9a2.7,2.7,0,0,0-1.5,2.1,1.8,1.8,0,0,0,.6,1.3,2,2,0,0,0,2.1,0l1.1-.6a.7.7,0,0,0,.4-.2l.2.6c0,.2-.2.6-.8.8s-4.2,1.1-5.5.5l-.5-.3a1.1,1.1,0,0,0-1.2.1,1.3,1.3,0,0,0-.7,1.2,4.1,4.1,0,0,0,3,4.5A2.4,2.4,0,0,0,197.6,107.3ZM208,98.8l-1.3,2.4q0,.3-.6.6l-1,.6-2.4,1.5a9.6,9.6,0,0,1-7,1.5,2.9,2.9,0,0,1-2.1-2.5l.4.2c1.7.8,4.3.6,6.8-.6a2.6,2.6,0,0,0,1.7-2.6l-.2-.8c0-.3-.4-.7-.8-.9a2.8,2.8,0,0,0-1.8,0l-1.2.6h-.4l.6-.5,3.6-1.9a1.5,1.5,0,0,1,.8-.2l4.3,1.7Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-4"
        d="M205.9,103.1l-2.5,1.5c-2.6,1.7-5.6,2.3-7.5,1.7a3.7,3.7,0,0,1-2.7-3.8c0-.3.6-.5.8-.5l.7.4c1.6.7,3.8.5,6.3-.6a2.4,2.4,0,0,0,1.3-1.7l-.2-.8c-.2-.5-.7-.5-1.5-.4l-1.1.6a1.7,1.7,0,0,1-1.4,0c-.5-.4-.1-1.3,1-1.9l3.6-1.9a2.1,2.1,0,0,1,1.3-.2l4.4,1.9c.1,0,.3.2.3.6v.9a.7.7,0,0,1-.2.6l-1.1,2.5a1.6,1.6,0,0,1-.7.7l-.8.4Z"
        transform="translate(-1 -0.4)"
      />
    </g>
    <path class="cls-2" d="M246.6,48.5h1.1v2.4h-1.1Z" transform="translate(-1 -0.4)" />
    <path
      class="cls-4"
      d="M267.5,56s-2,1.3,0,9.5a8,8,0,0,1-5.1,9.2,6.4,6.4,0,0,1-4.7-.9,2.4,2.4,0,0,1-.6-3c.8-1.4,1.6-3.6,1.6-7.6-.2-7,3-8.9,3-8.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M261.3,75.7a3.8,3.8,0,0,0,1.3-.2h.2a9,9,0,0,0,5.7-10.2c-1.9-7-.4-8.5-.4-8.5l1.5-1-1.7-.3-6.2-1.9-.4.2c-.2,0-3.6,2.2-3.4,9.6a17.7,17.7,0,0,1-1.3,7.2,3.2,3.2,0,0,0,.7,4A7.4,7.4,0,0,0,261.3,75.7Zm.9-1.7a5.5,5.5,0,0,1-3.9-.8,1.4,1.4,0,0,1-.4-1.9c.8-1.3,1.7-3.7,1.5-7.9s1.7-7.4,2.5-7.9l4.5,1.3c-.6,1.3-.9,4,.6,9.1C267,65.9,268.1,71.3,262.2,74Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M266.2,72.9c1-3.3-1.1-8.9-1.3-9.1l-1.5.5s1.9,5.3,1.1,8Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M264.1,50.2c-.7,4.3,1,8.3,3.8,8.7s5.5-2.9,6.3-7.2-1-8.3-3.8-8.7S264.9,45.8,264.1,50.2Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M268.3,59.8a5.9,5.9,0,0,0,4-2.1,12.1,12.1,0,0,0,2.4-5.8,11.8,11.8,0,0,0-.5-6.3,5.4,5.4,0,0,0-3.8-3.4c-3.2-.5-6.5,3-7.2,8s1.1,9,4.3,9.6C267.9,59.6,268.1,59.8,268.3,59.8Zm1.5-16.1h.4a3.2,3.2,0,0,1,2.4,2.5,12,12,0,0,1,.6,5.5,11,11,0,0,1-2.1,4.9,3.4,3.4,0,0,1-3.2,1.5c-2.3-.4-3.6-4-3-7.8S267.7,43.7,269.8,43.7Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M264.3,53.8c-.5,3,.8,5.8,2.7,6s3.8-1.9,4.3-5.1-.7-5.9-2.6-6.1S264.7,50.7,264.3,53.8Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M267.4,60.8c2.2,0,4.3-2.5,4.7-5.7a11.5,11.5,0,0,0-.4-4.6,4.1,4.1,0,0,0-2.8-2.4c-2.5-.4-4.8,2.1-5.3,5.7s.9,6.6,3.2,7Zm.9-11.2h.2a2.1,2.1,0,0,1,1.5,1.5,7.1,7.1,0,0,1,.4,3.6c-.4,2.6-1.9,4.5-3.4,4.3s-2.3-2.6-1.9-5.1S267,49.6,268.3,49.6Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M269.1,46.9c0,.8.1,1.4.1,2.1a42.8,42.8,0,0,1-.7,7.2,16.4,16.4,0,0,1-4,8,16,16,0,0,1-10.8,4.3,1.3,1.3,0,0,1-1.1-.8c-1.3-2.6-5.3-12.2-3.6-20.4,1-4.3,3.4-7.5,6.6-9.1,5.5-2.6,12.9,1.6,13.6,7.6Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M253.5,69.3a16.7,16.7,0,0,0,11.4-4.6,17.9,17.9,0,0,0,4.3-8.3A34,34,0,0,0,270,49a8.6,8.6,0,0,0-.2-2.1l-.2-1.1a10.5,10.5,0,0,0-5.5-7.6,10,10,0,0,0-9.2-.5,13.4,13.4,0,0,0-7,9.6c-1.7,8.3,2.4,18.2,3.6,21A2.2,2.2,0,0,0,253.5,69.3Zm5.3-31.1a9.6,9.6,0,0,1,4.6,1.2,8.7,8.7,0,0,1,4.7,6.4l.2,1.1c0,.8.2,1.6.2,2.1a30.7,30.7,0,0,1-.8,7,14.5,14.5,0,0,1-3.8,7.6c-3.5,3.6-8.3,4-10.2,4.1a.3.3,0,0,1-.3-.3c-1.2-2.7-5.1-12.1-3.6-19.9a11.5,11.5,0,0,1,6-8.5A5,5,0,0,1,258.8,38.2Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M249.8,60.6a31.8,31.8,0,0,1-1.2-13.5,18.2,18.2,0,0,1,1.5-4.1,18.8,18.8,0,0,1,8.4.2,4.9,4.9,0,0,1,3.6,4.9c0,1.5-.2,3.4-.4,5.7a8.7,8.7,0,0,1-9.5,7.3A6.9,6.9,0,0,1,249.8,60.6Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M253.2,62.1a9.6,9.6,0,0,0,9.4-8.2,17.9,17.9,0,0,0,.4-5.6,5.9,5.9,0,0,0-4.2-5.7,22.3,22.3,0,0,0-8.8-.2l-.4.2-.2.2a11.1,11.1,0,0,0-1.5,4.3c-.8,3.8-.4,8.5,1.1,13.8l.2.4.4.2a9.3,9.3,0,0,0,2.8.8C252.6,62.1,252.8,62.1,253.2,62.1Zm.7-18.6a20.8,20.8,0,0,1,4.6.6,4.4,4.4,0,0,1,3,4.2,54.8,54.8,0,0,1-.4,5.5,8.2,8.2,0,0,1-8.5,6.8,5.3,5.3,0,0,1-1.9-.4c-1.3-4.9-1.7-9.1-.9-12.7a12,12,0,0,1,1.3-3.6A6.3,6.3,0,0,1,253.9,43.5Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M273.2,45.2a3.5,3.5,0,0,0,1.1-5.1,3.6,3.6,0,0,0-3.2-2,3.2,3.2,0,0,1-2-1,3.9,3.9,0,0,0-4.4-.9,2.9,2.9,0,0,0-2.1,2.6h1.7c0-.4.4-.9,1.2-1.1a2.1,2.1,0,0,1,2.6.5,4.7,4.7,0,0,0,3,1.6c1,.1,1.5.1,2.1,1.3s-.2,2.8-.6,3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M274.2,49.2a3.7,3.7,0,0,0,3-4,5.7,5.7,0,0,0-3-4.9l-.8,1.5.4-.7-.4.7a4.4,4.4,0,0,1,2.3,3.6,2.4,2.4,0,0,1-1.7,2.5Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M275.7,42.6a4.9,4.9,0,0,0,1.1-4.5,3.6,3.6,0,0,0-2.3-2.5c-2.4-.8-3.9,1.5-4.5,2.6l1.5.6s1-2.3,2.7-1.7a1.8,1.8,0,0,1,1.1,1.3,3.5,3.5,0,0,1-.8,3.1Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M255.8,68.7l1.3-1a18.5,18.5,0,0,1-1.3-3.7l-1.5.2A13.5,13.5,0,0,0,255.8,68.7Z"
      transform="translate(-1 -0.4)"
    />
    <path class="cls-4" d="M261.2,50.1h1.3l-.2,1.4-1.3-.2Z" transform="translate(-1 -0.4)" />
    <path
      class="cls-2"
      d="M262.8,52.2h4l.2-1.1c0-.4.4-1.3,2.1-1.1l.3-2.5a3.7,3.7,0,0,0-4.3,2.3H263v2.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M256.6,50.5a.8.8,0,1,0,.7-.7A.8.8,0,0,0,256.6,50.5Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M249,50a.9.9,0,0,0,.8.7.8.8,0,0,0,.7-.7.8.8,0,1,0-1.5,0Z"
      transform="translate(-1 -0.4)"
    />
    <g id="commandwords">
      <path
        class="cls-3"
        d="M46.4,131.6a4.4,4.4,0,0,0-1.1.9,4,4,0,0,0-.7,1.3,5.9,5.9,0,0,0-.2,1.4,3.6,3.6,0,0,0,.2,1.1,1.3,1.3,0,0,0,.7.4,2.3,2.3,0,0,0,1.1-.3,7.1,7.1,0,0,0,.9-.7l.6-.8-.5-.5-.5.5c-.1.2-.2.3-.4.3l-.4.2-.4-.2v-.7c0-.5,0-1,.2-1.2l.6-.7.4-.2h.5l.5-1.1h-.6Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M50.5,133c-.2.2-.4.2-.5,0a2.2,2.2,0,0,1-.1-.9,4.1,4.1,0,0,1,.1-1.2,1,1,0,0,1,.5-.6.4.4,0,0,1,.6,0c0,.2.1.5.1.9s-.1.9-.1,1.2Zm0-3.7a3.1,3.1,0,0,0-1.1.8l-.7,1.2a5.9,5.9,0,0,0-.2,1.4,3.1,3.1,0,0,0,.2,1.1,1,1,0,0,0,.7.4l1.1-.3a4.3,4.3,0,0,0,1-.9,4.7,4.7,0,0,0,.7-1.2,3,3,0,0,0,.2-1.3,2,2,0,0,0-.2-1.2c-.2-.2-.4-.4-.6-.4A1.7,1.7,0,0,0,50.5,129.3Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M55.5,126.3l-.7.6-.5.7v-.4l-1,.6v4.4l1.1-.6v-3.1l.3-.4a.8.8,0,0,0,.2-.4l.3-.2h.3V131l1.2-.7V127c0-.4-.1-.7-.3-.8Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M59.5,123.1l-1.1.8v1l-.8.4v1l.8-.5v2.1c0,.5,0,.8.3,1s.6.1,1.1-.2a1.8,1.8,0,0,0,.7-.5,1.5,1.5,0,0,0,.5-.6l-.3-.6-.4.4-.3.2c-.2.1-.3.2-.4.1a.5.5,0,0,1-.2-.4v-2.1l1.1-.7v-.9l-1.3.7Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M63,124a1.2,1.2,0,0,1,.3-.9c0-.3.2-.4.5-.5s.4-.2.5,0a1,1,0,0,1,.2.7Zm.7-2.4a3.2,3.2,0,0,0-1,1,1.7,1.7,0,0,0-.6,1.2,2.8,2.8,0,0,0-.3,1.3,2,2,0,0,0,.3,1.1.7.7,0,0,0,.6.4l1.2-.3.8-.7a3.1,3.1,0,0,0,.7-.9l-.4-.4c-.2.2-.4.3-.5.5l-.6.4-.4.2c-.2,0-.2,0-.3-.2a.6.6,0,0,1-.2-.5l2.5-1.4v-.6a1.8,1.8,0,0,0-.3-1.1.7.7,0,0,0-.6-.4A2.5,2.5,0,0,1,63.7,121.6Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M69.9,118.2l-1.2.8-.6,1.7-.6-1-1.3.7,1.2,1.4L66,124.9l1.3-.7.7-2,.8,1.1,1.3-.7L68.8,121Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M72.6,115.6l-1.1.8v1l-.9.4v.9l.8-.4v2.1a1.1,1.1,0,0,0,.4,1c.2.2.6.1,1.1-.2l.7-.5.5-.6-.4-.6c-.1.1-.1.3-.3.3l-.4.3c-.1.1-.3.2-.4.1a.5.5,0,0,1-.2-.4v-2.1l1.2-.7v-.9l-1.2.7Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M76.8,117l-.4.4a.9.9,0,0,0-.3.5v.9l.3.2h.4l.5-.3c0-.2.2-.4.2-.6a.7.7,0,0,0,.1-.5.6.6,0,0,0-.1-.4l-.2-.2C77.1,116.8,77,116.9,76.8,117Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M81.1,115.4h-.3c-.1,0-.2-.2-.2-.4s-.1-.4-.1-.7a3.3,3.3,0,0,1,.2-1.2c.1-.3.2-.5.5-.6h.6v1.8l-.3.6C81.4,115.2,81.2,115.3,81.1,115.4Zm.6-5.8v2.1h-.4l-.5.2a2.3,2.3,0,0,0-.9.8,2.8,2.8,0,0,0-.5,1.1,5.1,5.1,0,0,0-.2,1.3,4.3,4.3,0,0,0,.2,1.2,1,1,0,0,0,.5.6,1.3,1.3,0,0,0,.8-.2l.7-.6c.1-.3.3-.4.4-.7v.4l1-.6v-6.2Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M84.9,111.5a1.5,1.5,0,0,1,.3-1c0-.2.2-.4.5-.5s.4-.2.5,0a1.2,1.2,0,0,1,.2.7Zm.7-2.4a2.2,2.2,0,0,0-1,.9,2,2,0,0,0-.6,1.2,3.1,3.1,0,0,0-.3,1.3,2,2,0,0,0,.3,1.1.7.7,0,0,0,.6.4l1.2-.3.8-.7a3.1,3.1,0,0,0,.7-.9l-.4-.3c-.2.2-.4.3-.5.5l-.6.4-.4.2c-.2,0-.2,0-.3-.2s-.2-.2-.2-.5l2.5-1.4v-.5a1.9,1.9,0,0,0-.3-1.2.7.7,0,0,0-.6-.4A2,2,0,0,0,85.6,109.1Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M90,110.3h-.6v-1.9l.3-.5.3-.4h.4c.1,0,.2.2.2.4v.8a4.5,4.5,0,0,1-.1,1.2A1,1,0,0,1,90,110.3Zm.5-4-.5.4-.6.8V107l-1.1.6v6.3l1.1-.7v-2.1a.8.8,0,0,0,1-.1,1.8,1.8,0,0,0,.8-.7,4.3,4.3,0,0,0,.5-1.2,4.9,4.9,0,0,0,.1-1.2,3.8,3.8,0,0,0-.1-1.2c-.1-.3-.3-.6-.5-.6S90.8,106.1,90.5,106.3Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M94.7,102.2l-2.3,1.3v.9l1.1-.7v3.8c0,.5.1.9.3,1s.6.2,1.1-.1l.6-.5.5-.5-.3-.7a.2.2,0,0,0-.2.2l-.3.2h-.3c-.1,0-.2-.2-.2-.4Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M98.7,105.3c-.2.2-.4.2-.5,0a2.2,2.2,0,0,1-.2-1,3.1,3.1,0,0,1,.2-1.1c.1-.3.3-.6.5-.6s.4-.1.5,0a1.7,1.7,0,0,1,.2.9,4.3,4.3,0,0,1-.2,1.2A1.3,1.3,0,0,1,98.7,105.3Zm0-3.8c-.4.3-.8.5-1,.9a4.7,4.7,0,0,0-.7,1.2,2.8,2.8,0,0,0-.3,1.3,1.9,1.9,0,0,0,.3,1.2c.2.2.3.4.7.4a1.9,1.9,0,0,0,1-.4,2.7,2.7,0,0,0,1-.8,3.7,3.7,0,0,0,.7-1.2,3.2,3.2,0,0,0,.3-1.4,1.8,1.8,0,0,0-.3-1.1.7.7,0,0,0-.6-.4Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M105.2,98l-1.2.7-.8,4.1-.8-3.2-1.2.7,1.3,3.8.4-.3c-.1.3-.1.5-.2.6l-.4.5-.6.6.2.8a3.9,3.9,0,0,0,1-.8l.7-1.1a2.1,2.1,0,0,0,.4-1.2Z"
        transform="translate(-1 -0.4)"
      />
      <path class="cls-3" d="M109.1,97l-3.2,1.8v1l3.2-1.8Z" transform="translate(-1 -0.4)" />
      <path
        class="cls-3"
        d="M111.9,97.7h-.3l-.3-.2V95.7l.3-.5c.1-.2.3-.3.3-.4h.4c.1,0,.2.1.2.3V96a4.5,4.5,0,0,1-.1,1.2Zm.5-4.1-.5.5c-.2.1-.4.5-.6.7v-.5l-1.1.7v6.4l1.1-.8V98.5a.8.8,0,0,0,1-.1,1.8,1.8,0,0,0,.8-.7,5.4,5.4,0,0,0,.5-1.1,6.2,6.2,0,0,0,.1-1.3,4.1,4.1,0,0,0-.1-1.2c-.1-.3-.3-.5-.5-.5S112.7,93.5,112.4,93.6Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M117.6,90.7a1.8,1.8,0,0,0-.8.7c-.1.4-.4.7-.5,1.1v-.8l-1.4.8v.8l.5-.2v2.6l-.5.3v.8l2.3-1.3v-.8l-.8.4V93.8a5.4,5.4,0,0,1,.5-1.1,1.5,1.5,0,0,1,.5-.6V93l.7-.5V90.6h-.2A.2.2,0,0,0,117.6,90.7Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M120,91.3a1.5,1.5,0,0,1,.3-1,.8.8,0,0,1,.5-.5c.2-.2.4-.2.5,0s.1.3.1.6Zm.7-2.4a2.2,2.2,0,0,0-1,.9,2.7,2.7,0,0,0-.6,1.2,3.1,3.1,0,0,0-.3,1.3,2,2,0,0,0,.3,1.1.7.7,0,0,0,.7.4l1.1-.3a2.7,2.7,0,0,0,.8-.7,3.1,3.1,0,0,0,.7-.9l-.4-.4-.5.5c-.2.2-.4.3-.5.5h-.8a.8.8,0,0,1-.2-.6l2.5-1.4V90a1.6,1.6,0,0,0-.3-1.1.6.6,0,0,0-.6-.5A2.8,2.8,0,0,0,120.7,88.9Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M127.1,85.3l-1.2.7-.8,3.9-.8-3-1.2.8,1.3,3.6,1.4-.7Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M130.1,83.6l-2.2,1.2v1l1-.6v2.6l-1.1.6v1l3.3-1.9v-1l-1,.6Zm-.6-1.9a1.3,1.3,0,0,0-.6.5c0,.2-.1.4-.1.6s.1.3.1.4.3.1.6-.1a2.3,2.3,0,0,0,.5-.5,1.3,1.3,0,0,0,.1-.6c0-.2,0-.3-.1-.4S129.6,81.5,129.5,81.7Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M133.2,83.6a1.3,1.3,0,0,1,.2-.9.8.8,0,0,1,.5-.5c.3-.2.5-.2.5,0a1.2,1.2,0,0,1,.2.7Zm.6-2.3a3.2,3.2,0,0,0-1,1,3.4,3.4,0,0,0-.6,1.2,2.7,2.7,0,0,0-.3,1.2,2.1,2.1,0,0,0,.3,1.2,1,1,0,0,0,.7.4,1.9,1.9,0,0,0,1.1-.4c.4-.1.6-.4.9-.6l.7-.9-.5-.4-.5.5-.5.4-.4.2c-.2,0-.3,0-.4-.2a.7.7,0,0,1-.1-.5l2.4-1.4v-.6a1.8,1.8,0,0,0-.2-1.1c-.2-.2-.4-.4-.6-.4Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M140.4,77.6l-1.1.6V82l-.5-2.8-.9.6-.4,3.2-.3-3.5-1,.7.6,4.1,1.2-.7.3-3.2.4,2.8,1.2-.8Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M143.6,73.4l-2.2,1.2v1.1l1.2-.7v5.9l-1.2.7v.9l2.3-1.3Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M46.5,141.7a3.1,3.1,0,0,0-1.1.9,4,4,0,0,0-.7,1.3,2.7,2.7,0,0,0-.2,1.3,2,2,0,0,0,.2,1.1,1,1,0,0,0,.7.4l1.1-.3a7.1,7.1,0,0,0,.9-.7l.6-.8-.5-.5-.5.5a1,1,0,0,1-.5.4l-.4.2c-.1-.1-.3-.2-.3-.3a1.5,1.5,0,0,1-.1-.7,1.9,1.9,0,0,1,.3-1.2,2,2,0,0,1,.6-.7l.4-.2h.5l.5-1.1h-.6A2.6,2.6,0,0,0,46.5,141.7Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M50.5,143c-.2.2-.4.2-.5,0a2,2,0,0,1-.1-.9,4.1,4.1,0,0,1,.1-1.2,1,1,0,0,1,.5-.6.4.4,0,0,1,.6,0c0,.2.1.5.1.9s-.1.9-.1,1.2A.9.9,0,0,1,50.5,143Zm0-3.7a3.9,3.9,0,0,0-1,.8l-.7,1.2a5.9,5.9,0,0,0-.2,1.4,3.1,3.1,0,0,0,.2,1.1,1,1,0,0,0,.7.5l1-.3a3.3,3.3,0,0,0,1.1-.9l.7-1.2a5.9,5.9,0,0,0,.2-1.3,3.3,3.3,0,0,0-.2-1.2c-.2-.2-.4-.4-.6-.4A2.4,2.4,0,0,0,50.5,139.3Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M56.1,136.1l-.4.4a.9.9,0,0,0-.3.6c-.1-.1-.1-.2-.3-.2h-.3a.7.7,0,0,0-.5.4l-.3.7v-.5l-.9.6v4.4l1.1-.6v-3.2a.8.8,0,0,0,.1-.4c.1-.1.1-.2.2-.2h.2v3.5l.8-.4v-3.2c0-.2.1-.3.1-.4h.4v3.5l1-.6v-3.3a1.5,1.5,0,0,0-.1-.7l-.2-.2C56.5,135.9,56.3,136,56.1,136.1Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M60.5,133.5a1,1,0,0,0-.4.5.9.9,0,0,0-.4.6c0-.2,0-.3-.2-.3h-.4c-.1.1-.3.2-.4.4a1.5,1.5,0,0,0-.3.7v-.4l-.9.5V140l1-.6v-3.2l.2-.4H59v3.5l.7-.4v-3.3l.2-.3.2-.2h.2v3.5l1-.6v-3.3c0-.3,0-.5-.1-.6l-.3-.3C60.9,133.4,60.7,133.4,60.5,133.5Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M63.5,135.7h-.4c-.1,0-.2-.2-.2-.4a.9.9,0,0,1,.3-.6,2.2,2.2,0,0,1,.7-.6l.2-.2v.7l-.3.5A1.1,1.1,0,0,1,63.5,135.7Zm.1-3.9-.7.5a2.7,2.7,0,0,1-.8.7l.3.7.6-.5.5-.4h.6c.2,0,.2.1.2.4v.2l-.5.3a5.8,5.8,0,0,0-1.4,1.2,2.7,2.7,0,0,0-.5,1.4c0,.4.1.7.3.8l1-.2.7-.6.6-.8c0,.2.2.2.3.2l.6-.2.3-1h-.2c0-.1-.1-.2-.1-.3v-1.8a1,1,0,0,0-.4-.9A2.7,2.7,0,0,0,63.6,131.8Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M68.7,128.8l-.7.5-.5.8v-.3l-1,.5v4.4l1.1-.7v-3l.3-.5c.1,0,.2-.2.3-.3l.2-.2h.3c.1,0,.1.1.1.2v3.3l1.1-.6v-3.3c0-.4-.1-.7-.3-.8Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M72.4,130.5H72c-.1,0-.2-.1-.2-.3a1.7,1.7,0,0,1-.1-.8c0-.5.1-.8.1-1.2a1.2,1.2,0,0,1,.6-.6c0-.1.2-.1.3-.1H73v1.9l-.3.5C72.6,130.3,72.5,130.5,72.4,130.5Zm.6-5.9v2.2h-.5l-.5.2a1.8,1.8,0,0,0-.8.7,3,3,0,0,0-.6,1.1c0,.5-.1.9-.1,1.3s.1.9.1,1.2a.8.8,0,0,0,.5.6c.1.1.5,0,.7-.2a1.8,1.8,0,0,0,.7-.5l.5-.7v.4l1.1-.6v-6.3Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M82.9,123l-3.3,1.9v1l3.3-1.9Zm0-1.7-3.3,1.9v1l3.3-1.9Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M89.9,115l-1.1.6v2.3l.9-.5Zm1.3-.7-1.1.6.2,2.2.9-.5Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M93.8,112.7l-1.1.7v6.3l1.1-.7v-3.1l.3-.4a.8.8,0,0,0,.2-.4h.6v3.4l1.2-.7v-3.3a1,1,0,0,0-.3-.8c-.2-.1-.4-.1-.8.1a2.2,2.2,0,0,0-.6.5l-.5.8Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M100.4,110.7l-1.1.7v3.1l-.3.5c-.1.2-.3.3-.4.4h-.2c-.1,0-.1-.2-.1-.5v-3l-1.2.7v3.1a2,2,0,0,0,.2.9,1,1,0,0,0,.9-.1c.3-.2.4-.4.7-.5a3.5,3.5,0,0,0,.5-.8v.5l1-.6Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M103.1,111.5h-.4c-.1,0-.2-.2-.2-.4a1.4,1.4,0,0,1,.2-.6.8.8,0,0,1,.4-.4c.2-.1.3-.2.4-.1a.8.8,0,0,1,.2.4,1.4,1.4,0,0,1-.2.7C103.4,111.1,103.4,111.3,103.1,111.5Zm1.8-4.1-.5.6-.6.5a1.8,1.8,0,0,1-.7.5H103a2.4,2.4,0,0,0-.8.6,2.1,2.1,0,0,0-.6,1,1.9,1.9,0,0,0-.3,1,1.4,1.4,0,0,0,.2.7.5.5,0,0,0,.5.3,1,1,0,0,0-.4.5v.5c0,.2.1.4.3.4s.5,0,.9-.3l.6-.3c.2-.1.4-.2.5-.1s.1.1.1.3v.2l-.3.4-.6.4-.6.3h-.3v-.3l-1.1.6a1.4,1.4,0,0,0,.2.7c.1.2.3.2.6.2a1.7,1.7,0,0,0,1.1-.6,7.4,7.4,0,0,0,1.6-1.2,3,3,0,0,0,.5-1.4,1.1,1.1,0,0,0-.2-.6l-.5-.2a1.3,1.3,0,0,0-.8.3l-.6.3h-.3c-.1,0-.1-.1-.1-.2h0v-.2a.1.1,0,0,0,.1-.1h.3a2.8,2.8,0,0,0,.9-.7l.6-.8a3.1,3.1,0,0,0,.1-.9c0-.2-.1-.5-.1-.6H104l.6-.4c.1-.2.3-.2.5-.4Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M107.6,110.3q-.4.2-.6,0c0-.2-.1-.6-.1-1s.1-.8.1-1.2a1.2,1.2,0,0,1,.6-.6.3.3,0,0,1,.5,0,2.2,2.2,0,0,1,.1,1,4.5,4.5,0,0,1-.1,1.2Zm0-3.8a3.1,3.1,0,0,0-1.1.8l-.7,1.2a6.8,6.8,0,0,0-.2,1.4,2.7,2.7,0,0,0,.2,1.1c.2.3.4.5.7.5a2.1,2.1,0,0,0,1.1-.4,3.9,3.9,0,0,0,1-.8,7.5,7.5,0,0,0,.7-1.2,3.6,3.6,0,0,0,.2-1.4c0-.5,0-.9-.2-1.1s-.4-.5-.6-.5A1.4,1.4,0,0,0,107.6,106.5Z"
        transform="translate(-1 -0.4)"
      />
      <path class="cls-3" d="M117.9,102l-3.1,1.8v1.1l3.1-1.8Z" transform="translate(-1 -0.4)" />
      <path class="cls-3" d="M122.2,99.5l-3,1.8v1l3.1-1.8Z" transform="translate(-1 -0.4)" />
      <path
        class="cls-3"
        d="M125.2,100.2h-.6V98.2l.2-.5.4-.4h.3c.1,0,.2.1.2.4a1.7,1.7,0,0,1,.1.8,4.3,4.3,0,0,1-.2,1.2Zm-.6-5.3-1.2.8V102l1.1-.6v-.5q.3.4.9,0c.4-.1.6-.4.9-.7a4.3,4.3,0,0,0,.5-1.2,5,5,0,0,0,.2-1.2,3.3,3.3,0,0,0-.2-1.2c-.1-.3-.3-.6-.4-.6a1.8,1.8,0,0,0-.9.2c-.2.1-.3.3-.5.5a2.5,2.5,0,0,0-.4.7Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M131.2,93.1l-1.1.6v3.2l-.3.5-.3.4h-.3c-.1,0-.1-.1-.1-.4V94.3L128,95v3.2c0,.4.1.7.3.8s.4.1.8,0l.7-.6.5-.7v.5l1-.6Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M134.5,91.1l-2.2,1.3v.9l1-.6v2.7l-1.1.6v.9l3.3-1.9v-.9l-1,.6Zm-.7-1.9-.5.5a1.3,1.3,0,0,0-.1.6c0,.2,0,.4.1.4h.5l.6-.6c0-.2.1-.4.1-.6s-.1-.3-.1-.4A.5.5,0,0,0,133.8,89.2Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M138.6,87l-2.4,1.3v.9l1.2-.7v3.8c0,.5,0,.8.3,1s.6.2,1-.2l.7-.4c.2-.2.4-.3.4-.5l-.2-.7-.3.3h-.6c-.1,0-.1-.1-.1-.3Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M142.5,90.1h-.3l-.3-.3a1.7,1.7,0,0,1-.1-.8,4.3,4.3,0,0,1,.2-1.2,1.5,1.5,0,0,1,.5-.6h.6v1.9a1.7,1.7,0,0,0-.2.5C142.8,90,142.7,90.1,142.5,90.1Zm.7-5.9v2.2h-.4l-.5.2c-.4.1-.6.4-.9.7a2.7,2.7,0,0,0-.5,1.1,6.9,6.9,0,0,0-.2,1.3,3.7,3.7,0,0,0,.2,1.2c.1.3.2.5.5.6a1.2,1.2,0,0,0,.8-.1l.7-.6.4-.7v.4l1-.6V83.6Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M146.4,87.7V83.9l.2-.2h.8l.3.5V86c-.1.3-.1.5-.3.7s-.3.4-.3.5l-.5.4Zm.1-4.8-1.3.7v5.9l1.3-.8,1-.7.8-.9a6.1,6.1,0,0,0,.5-1.2,8.6,8.6,0,0,0,.1-1.6,2.4,2.4,0,0,0-.2-1.3c-.2-.3-.4-.6-.6-.6h-.9Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M152.7,80.6a1.2,1.2,0,0,0-.7.7,4.5,4.5,0,0,0-.6,1.2v-.8l-1.4.7v.9l.5-.3v2.7l-.5.2v.9l2.4-1.4v-.8l-.8.4V83.7a5.4,5.4,0,0,1,.5-1.1,1.5,1.5,0,0,1,.5-.6v.9l.7-.5V80.5h-.2C152.9,80.4,152.8,80.5,152.7,80.6Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M155.6,82.6h-.4c-.1,0-.2-.2-.2-.3a.6.6,0,0,1,.3-.6c.2-.2.4-.5.7-.6l.2-.2v.7a.9.9,0,0,1-.3.5C155.8,82.4,155.7,82.6,155.6,82.6Zm0-3.8a1.2,1.2,0,0,0-.6.5,2.7,2.7,0,0,0-.8.7l.2.7a1.5,1.5,0,0,0,.6-.5c.2-.2.4-.2.6-.3a.7.7,0,0,1,.6-.2,1,1,0,0,1,.1.4v.2l-.5.3a8.7,8.7,0,0,0-1.4,1.2,3,3,0,0,0-.5,1.4c0,.4.1.7.4.8a.8.8,0,0,0,.9-.2,2,2,0,0,0,.7-.6,2.4,2.4,0,0,0,.6-.8.4.4,0,0,0,.4.2l.6-.2.2-1c-.1,0-.2,0-.2-.1v-2a1,1,0,0,0-.5-1A3.9,3.9,0,0,0,155.6,78.8Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M161,74a2,2,0,0,0-.9.6,4.1,4.1,0,0,0-.5.9,2.9,2.9,0,0,0-.2.9V77l-.8.6v.9l.7-.4v3.2l1.2-.7V77.4l1.1-.7v-1l-1.3.7v-.6a3.5,3.5,0,0,1,.1-.6l.6-.4.4-.2h.4l.4-1.1h-.6Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M164.7,72.6l-1.1.9v.9l-.8.4v1l.8-.5v2.1a1.1,1.1,0,0,0,.4,1c.2.2.6.1,1.1-.2a1.8,1.8,0,0,0,.7-.5,1.5,1.5,0,0,0,.5-.6l-.3-.7-.3.3-.3.3h-.5c-.1,0-.2-.1-.2-.4v-2l1.2-.7v-1l-1.3.7Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M169,71.1l-.9.7a2.8,2.8,0,0,0-.6.9,1.9,1.9,0,0,0-.2.8.8.8,0,0,0,.2.6l.4.2h1.5c.1,0,.1,0,.1.1a.5.5,0,0,1-.2.4l-.4.4-.6.2h-.5l-.6,1.2h.7A2.1,2.1,0,0,0,169,76l.9-.7a5,5,0,0,0,.7-.8,1.8,1.8,0,0,0,.2-1c0-.2,0-.5-.1-.6h-2c-.1,0-.1,0-.1-.1a.8.8,0,0,1,.2-.4l.4-.3.6-.3h.5l.5-1h-.7A2,2,0,0,0,169,71.1Z"
        transform="translate(-1 -0.4)"
      />
      <path class="cls-3" d="M96,124.6l-3.1,1.9v1l3.1-1.8Z" transform="translate(-1 -0.4)" />
      <path class="cls-3" d="M100.3,122.2l-3,1.7V125l3-1.8Z" transform="translate(-1 -0.4)" />
      <path
        class="cls-3"
        d="M103.3,122.8h-.4c-.1,0-.1-.1-.2-.2v-1.8c.1-.2.1-.4.2-.5s.3-.3.4-.4h.3c.1,0,.2.1.2.4s.1.4.1.8a3.7,3.7,0,0,1-.2,1.2Zm-.6-5.2-1.1.8v6.2l1-.6v-.4q.3.5.9,0a2.3,2.3,0,0,0,.9-.8,2.8,2.8,0,0,0,.5-1.1,3.2,3.2,0,0,0,.2-1.3,3.3,3.3,0,0,0-.2-1.2c-.1-.3-.3-.6-.4-.6a1.8,1.8,0,0,0-.9.2l-.5.5a2.5,2.5,0,0,0-.4.7Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M109.3,115.7l-1.1.7v3.2l-.3.5-.3.3h-.3c-.1,0-.1-.1-.1-.4V117l-1.3.6v3.2c0,.4.1.7.3.8s.4.1.8,0l.7-.6a1,1,0,0,0,.5-.7v.5l1.1-.6Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M112.6,113.8l-2.2,1.2v1l1-.6V118l-1,.6v1l3.3-1.9v-.9l-1,.6Zm-.7-1.9a2.3,2.3,0,0,0-.5.5,1.7,1.7,0,0,0-.1.7.6.6,0,0,0,.1.4c.1.1.3.1.5-.1a1.3,1.3,0,0,0,.6-.5c0-.2.1-.4.1-.6s-.1-.3-.1-.4A.4.4,0,0,0,111.9,111.9Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M116.7,109.7l-2.4,1.2v1l1.2-.7V115c0,.5,0,.8.3,1s.6.2,1-.2l.7-.4.5-.5-.3-.8-.3.3h-.6a.4.4,0,0,1-.1-.3Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M120.6,112.8h-.3l-.3-.3a1.9,1.9,0,0,1-.1-.8,3.7,3.7,0,0,1,.2-1.2,1,1,0,0,1,.5-.6h.6v1.9a1.7,1.7,0,0,0-.2.5A.8.8,0,0,1,120.6,112.8Zm.6-5.9v2.2h-.9a3.4,3.4,0,0,0-.9.8,5.4,5.4,0,0,0-.5,1.1,6.9,6.9,0,0,0-.2,1.3,3.7,3.7,0,0,0,.2,1.2,1,1,0,0,0,.5.6.9.9,0,0,0,.8-.2l.7-.6.4-.6v.4l1-.6v-6.3Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M127.1,104.1l-3.4,2v5.8l1.2-.8v-2.2l1.8-1v-1.1l-1.8,1.1v-1.6l2-1.1Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M131.2,103.1l-1.1.6v3.2l-.3.5-.3.4h-.3c-.1,0-.1-.2-.1-.5v-3.1l-1.1.7v3.2a1.2,1.2,0,0,0,.3.9c.1.1.4,0,.8-.1s.4-.4.7-.5l.5-.8v.5l1-.6Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M134.1,100.3l-1.1.9v.9l-.9.5v.9l.9-.4v2c0,.5.1.9.3,1s.6.1,1.1-.1l.7-.5a1.2,1.2,0,0,0,.5-.6l-.3-.6c-.1,0-.2.2-.3.3l-.4.3h-.4c-.1,0-.2-.1-.2-.4v-2l1.1-.7v-1l-1.3.7Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M139.9,98l-1.1.7v3.2l-.2.5c-.1.2-.3.2-.4.3H138c-.1,0-.1-.2-.1-.4V99.3l-1.1.7v3.2c0,.4,0,.6.2.8s.4.1.9-.1l.7-.5a2.2,2.2,0,0,0,.5-.8v.6l1-.6Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M144,95.6a1.6,1.6,0,0,0-.8.8,3.7,3.7,0,0,0-.5,1.1l-.2-.9-1.4.8v.9l.6-.3v2.7l-.6.2v.9l2.4-1.4v-.8l-.7.4V98.7a3.6,3.6,0,0,1,.4-1.1l.5-.7v.9l.7-.5.2-1.9h-.3Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M146.4,96.2a2,2,0,0,1,.2-.9c.1-.3.3-.5.5-.5s.5-.2.6,0a3.5,3.5,0,0,1,.1.6Zm.7-2.4a2.7,2.7,0,0,0-1.1,1,3.4,3.4,0,0,0-.6,1.2,5,5,0,0,0-.2,1.2,3.7,3.7,0,0,0,.2,1.2,1,1,0,0,0,.7.4,1.9,1.9,0,0,0,1.1-.4c.4-.1.6-.4.9-.6l.7-.9-.5-.4-.5.5a1,1,0,0,1-.5.4l-.4.2c-.2,0-.3,0-.4-.2s-.1-.2-.1-.5l2.5-1.4V95a1.8,1.8,0,0,0-.3-1.1c-.2-.3-.3-.4-.6-.4A1.9,1.9,0,0,0,147.1,93.8Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M151.3,89.8l-1.1.6v2.2l.9-.4Zm1.3-.9-1.1.6.2,2.3.9-.5Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M149.1,53.3c-.4,2.5-3.4,3.7-3.9,3.9h0c.5.2,3.5,1.4,3.9,3.9h.1c.4-2.5,3.4-3.7,3.9-3.9h0c-.5-.2-3.5-1.4-4-3.9Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M160.4,53.3c-.4,2.5-3.4,3.7-3.9,3.9h0c.5.2,3.4,1.4,3.9,3.9h.1c.4-2.5,3.4-3.7,3.9-3.9h0C163.8,57,160.9,55.8,160.4,53.3Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M160.4,42c-.4,2.5-3.4,3.7-3.9,3.9h0c.5.2,3.4,1.4,3.9,3.9h.1c.4-2.5,3.4-3.7,3.9-3.9h0C163.8,45.7,160.9,44.5,160.4,42Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M42.9,131.3l-2.2,1.3v8l2.3-1.3v-1.1l-1.1.7v-6l1.1-.6Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M171.6,42c-.4,2.5-3.3,3.7-3.9,3.9h0c.5.2,3.4,1.4,3.9,3.9h.1c.4-2.5,3.4-3.7,3.9-3.9h0c-.5-.2-3.5-1.4-4-3.9Z"
        transform="translate(-1 -0.4)"
      />
    </g>
    <g id="lightning">
      <g class="cls-5">
        <g>
          <path
            class="cls-4"
            d="M43.5,75.4c0-.1-.2-.1-.3,0l-.3.2-3.8,1.3L53.6,49.4c0-.2,0-.2-.1-.3l-8.4-5.2c-.2-.1-.5,0-.8.4l-38,60.8c-.2.4-.4.6-.2.7v.2l9.2,5.4a1,1,0,0,0-.1.4L2.1,142.7c-.2.4-.1.7.1.7h0l8.5,5.3c.1.1.2,0,.3-.1L40,92.9,52,80.8c.1-.1,0-.2-.1-.4Z"
            transform="translate(-1 -0.4)"
          />
          <path
            class="cls-2"
            d="M10.8,149.8l-.6-.3-8.5-5.1a1.5,1.5,0,0,1-.5-2.1l12.9-30.5-8.7-5.1-.2-.4c-.5-.6,0-1.3.2-1.6L43.5,43.8c.6-1,1.4-1.2,2.1-.8l8.5,5.3a1.2,1.2,0,0,1,.4,1.6L41.2,75.1l1.5-.6.8-.2h.2l8.7,5.4a1.1,1.1,0,0,1,.5.9,1,1,0,0,1-.3,1L40.7,93.5l-29.1,56-.6.3Zm-7.7-6.9,7.4,4.5L39.3,92.2,50.7,80.8l-7.2-4.4h-.3l-6.1,2L52.4,49.6,45.1,45,7.2,105.5l9.2,5.4-.2,1.2Z"
            transform="translate(-1 -0.4)"
          />
          <path
            class="cls-3"
            d="M53,49.7,14.9,110.4c-.4.7-.1,1.3.4,1l13.6-7.9c.5-.3.8.1.5.8L10.8,148c-.4.9.3,1.2.9.4L52.3,81.7c.4-.6.2-1.3-.4-1L38,88.8c-.4.3-.7-.1-.4-.7l16.3-38C54.3,49.2,53.5,48.9,53,49.7Z"
            transform="translate(-1 -0.4)"
          />
          <path
            class="cls-2"
            d="M11,149.9h-.6a1.6,1.6,0,0,1-.6-2.1l18.1-42.5-12.1,7.1a1.4,1.4,0,0,1-1.7-.3,2,2,0,0,1,0-2.1L52.2,49.2c.6-1,1.5-1.2,2.1-.8a1.6,1.6,0,0,1,.5,2.1L39.1,87.1l12.3-7.2a1.5,1.5,0,0,1,1.7.2,1.8,1.8,0,0,1,.1,2.1L12.5,148.9A1.9,1.9,0,0,1,11,149.9Zm18.2-47.5a1.2,1.2,0,0,1,.8.4,1.5,1.5,0,0,1,.3,1.9l-15.7,37,35.9-59-12,6.9a1.2,1.2,0,0,1-1.6-.1,1.7,1.7,0,0,1-.3-1.9L50.3,55.8,16.7,109.4l11.7-6.8Z"
            transform="translate(-1 -0.4)"
          />
          <path
            class="cls-2"
            d="M14.6,92.4l-1.1,1.7,8.8,5.3,1-1.7Z"
            transform="translate(-1 -0.4)"
          />
          <path class="cls-2" d="M40.9,50.7l-1,1.7,8.7,5.2,1-1.6Z" transform="translate(-1 -0.4)" />
          <path class="cls-2" d="M9.3,126.3,8.2,128l8.8,5.3,1-1.7Z" transform="translate(-1 -0.4)" />
          <path
            class="cls-2"
            d="M34.6,44,20.2,66.7l1.7,1.1L36.3,45.1Z"
            transform="translate(-1 -0.4)"
          />
          <path
            class="cls-2"
            d="M18.2,69.8l-4.4,7.1L15.5,78,20,70.9Z"
            transform="translate(-1 -0.4)"
          />
          <path
            class="cls-2"
            d="M32.3,126,18,148.7l1.7,1.1L34,127.1Z"
            transform="translate(-1 -0.4)"
          />
          <path
            class="cls-2"
            d="M16,151.7l-4.5,7.1,1.8,1.1,4.4-7.1Z"
            transform="translate(-1 -0.4)"
          />
        </g>
      </g>
    </g>
    <path
      class="cls-2"
      d="M202,246.3l1.4-2.5-22.1-13a6.1,6.1,0,0,1-2.8-5.1V180.2h-2.8v45.5a8.4,8.4,0,0,0,4.2,7.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M123.9,229.4V226l8.8-2.6L153.9,211l7.3,4.2,2.9-.8h.3v3.4c0,.5-.3.8-.9,1.1l-27.4,15.8a4.7,4.7,0,0,1-4,0l-7.6-4.5C124.2,230.2,124.2,229.6,123.9,229.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M134.4,236.1a4.8,4.8,0,0,0,2.2-.5l27.5-15.9c.5-.2.8-.8,1.1-1.7v-3.4c0-.2,0-.5-.3-.5s-.5-.3-.5,0l-2.6.5-7.3-4.2h-.9l-21.2,12.4-8.5,2.3c-.3,0-.5.3-.5.9v3.4a1.5,1.5,0,0,0,1.1,1.6l7.6,4.6A8,8,0,0,0,134.4,236.1Zm29.7-20.9v2.6c0,.2,0,.5-.6.5l-27.4,15.9a4,4,0,0,1-3.4,0l-7.6-4.6c-.3-.2-.6-.2-.6-.8h0v-3.1l8.5-2.3,20.9-12.1,7.1,4.2h.5Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M124.2,225.7l8.8-2.6,1.7-1.1v13.3a3.9,3.9,0,0,1-2-.6l-7.6-4.5a1.5,1.5,0,0,1-.9-1.1c-.3,0-.3-2.9,0-3.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M134.4,236.1h.8V221.2l-2.5,1.4-8.5,2.2c-.3,0-.6.3-.6.9v3.4a2,2,0,0,0,1.2,1.7l7.6,4.5A2.9,2.9,0,0,0,134.4,236.1Zm-.3-13v11.6l-1.1-.3-7.7-4.5c-.2-.3-.5-.3-.5-.8V226l8.4-2.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M136.4,231.6l27.4-15.8a1.4,1.4,0,0,0,0-2.6l-7.9-4.5a4,4,0,0,0-3.7,0l-27.4,15.8a1.4,1.4,0,0,0,0,2.6l7.9,4.5A4,4,0,0,0,136.4,231.6Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M134.4,232.7a5.9,5.9,0,0,0,2.2-.5l27.5-15.9a2.3,2.3,0,0,0,1.1-1.9,2.2,2.2,0,0,0-1.1-2l-7.9-4.5a4.3,4.3,0,0,0-4.6,0l-27.4,15.8a2.3,2.3,0,0,0-1.1,2,2.3,2.3,0,0,0,1.1,2l7.9,4.5A8,8,0,0,0,134.4,232.7Zm1.7-1.7a2.9,2.9,0,0,1-3.1,0l-7.9-4.5c-.3-.3-.6-.5-.6-.8s.3-.6.6-.9L152.5,209a2.9,2.9,0,0,1,3.1,0l7.9,4.5c.3.3.6.6.6.9s-.3.5-.6.8Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M119.7,202.5h4.5l47.5-27.4,33.1,27.4h2.5l-.3,3.7a2.9,2.9,0,0,1-1.4,2.5l-48,27.7a4.3,4.3,0,0,1-4.6-.3L120.2,209a2.8,2.8,0,0,1-.8-2Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M155.6,237.3a6,6,0,0,0,2.2-.6L205.9,209a3.2,3.2,0,0,0,1.7-2.6v-.2l.3-4.3h-3.1l-33.4-27.4-47.8,27.7h-4.8v.6l-.3,4.2a5.1,5.1,0,0,0,1.2,2.6l32.8,27.1A11.3,11.3,0,0,0,155.6,237.3Zm50.9-31.7v.3a2.7,2.7,0,0,1-1.1,2l-48.1,27.7a3.8,3.8,0,0,1-3.7-.3l-32.8-27.2c-.6-.2-.6-.8-.6-1.4l.3-3.6h4.6l47.2-27.2,32.8,27.2H207Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M153,235.9l-32.8-27.2a2.8,2.8,0,0,1-.8-2l.3-4.2h4.5l2.3-1.4,24.3,16.1,4.8,9.6v9.6A3.1,3.1,0,0,1,153,235.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M156.2,237.3V226.8l-4.9-9.9-24.6-16.4-2.5,1.4h-4.8v.6l-.3,4.2a5.8,5.8,0,0,0,1.1,2.6L153,236.4a5,5,0,0,0,2.9,1.2Zm-1.2-9.9v8.7a3,3,0,0,1-1.4-.5l-32.8-27.2c-.6-.3-.6-.8-.6-1.4l.3-3.7h4.3l2.2-1.1L150.8,218Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M205.4,208.1v-4.2l-1.2-.8v-1.2l.6.3h2.5l-.3,3.7A2.2,2.2,0,0,1,205.4,208.1Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M205.4,209.3l.5-.3a3.2,3.2,0,0,0,1.7-2.6v-.2l.3-4.3h-3.1l-1.1-.8-.3,2.8,1.1.9v3.9Zm1.1-3.7v.3c0,.5-.3.8-.3,1.1v-3.4l-1.1-.8h1.7Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M157.9,232.5l48-27.7a3,3,0,0,0,.3-5.1l-32.5-26.9a3.6,3.6,0,0,0-4-.3l-48.9,28.3a2.6,2.6,0,0,0-.3,4.2l32.8,27.2A4.7,4.7,0,0,0,157.9,232.5Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M155.9,233.6a6,6,0,0,0,2.2-.6l48.1-27.7a4.1,4.1,0,0,0,2-2.8,3.6,3.6,0,0,0-1.4-3.1l-32.6-26.9a4.4,4.4,0,0,0-4.8-.3l-48.9,28.3a4.4,4.4,0,0,0-1.7,2.6,3.6,3.6,0,0,0,1.2,2.8L152.8,233A10.7,10.7,0,0,0,155.9,233.6Zm15.8-61.1a5.1,5.1,0,0,1,2,.6l32.5,26.8a3,3,0,0,1,.8,2,2.7,2.7,0,0,1-1.1,2l-48.1,27.7a3.2,3.2,0,0,1-3.6-.3l-32.8-27.1a1.3,1.3,0,0,1-.6-1.7,1.5,1.5,0,0,1,.9-1.4l48.6-28A2,2,0,0,1,171.7,172.5Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M157,229.1l45.8-26.6c.3-.3.6-.9,0-1.1L172,175.6c-.6-.3-1.1-.3-1.4,0l-46.4,26.6c-.3.3-.3.9,0,.9l31.1,25.7C155.9,229.4,156.4,229.6,157,229.1Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M156.4,229.9a1.8,1.8,0,0,0,1.2-.3l45.8-26.5a1.5,1.5,0,0,0,.5-1.2,1.1,1.1,0,0,0-.5-1.1l-30.8-25.7a2.1,2.1,0,0,0-2.3-.3l-46.4,26.6a1,1,0,0,0-.5.8c0,.3,0,.9.5,1.1L155,229.1A1.2,1.2,0,0,0,156.4,229.9Zm15-54c.3,0,.3,0,.6.3l30.8,25.7L157,228.5a.8.8,0,0,1-1.1,0l-31.1-25.7,46.3-26.6C171.1,175.9,171.1,175.9,171.4,175.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M189,202.2,161.2,218l-15.5-13,27.7-15.8Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M161.2,218.6l.3-.3,28-15.8v-.6l-.3-.3-15.8-13.2-.3.2-27.7,16.2v.5l.3.3Zm26.6-16.7-26.6,15.3-14.4-11.9L173.1,190Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M173.4,189.2,145.7,205l-1.1-21.7L172,167.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M146,205.9l.3-.3L174,189.5v-.3l-1.4-22.1-.6-.2-.3.2L144,183.3v.2l1.4,22.1Zm26.6-17-26.3,15.3-1.2-20.4,26.3-15.2Z"
      transform="translate(-1 -0.4)"
    />
    <path class="cls-2" d="M170.6,187.5l-22.6,13-.6-15.5,22.3-13Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M172.8,192.3l.6,1-22.7,13.2-.6-1Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M183.4,201.2l.6.9-22.7,13.2-.6-.9Z" transform="translate(-1 -0.4)" />
    <path
      class="cls-4"
      d="M191.2,274.3l-4.2,1.1-4.8-1.7.5-1.1,1.4-.6s2-.2,2.3-1.4,3.1,0,3.1,0l2,1.7Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M186.7,276l4.8-1.1.6-2.9-2.6-1.9c-.5-.3-2.5-.9-3.4-.3s-.5.3-.5.8-1.2.9-1.7.9l-1.7.5-1.2,2Zm3.9-2.3-3.6.9-4-1.4.3-.3,1.1-.3a4.7,4.7,0,0,0,2.9-1.7,7.3,7.3,0,0,1,2.2.3l1.7,1.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M206.5,249.1s-8.8-2.8-11.3-5c0,0,1.4,3.1-.3,8.4s-2.3,13.9-2.6,17.6a1.8,1.8,0,0,1-1.7,1.7h-.8c-.8,0-2.8-.9-2.8-2-.3-7.1-.9-31.4.8-33.7s8.2-5.1,11.6-4.5,12.7,2,12.7,2Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M189.8,272.3h.8c1.2,0,2-.8,2.3-2.2s.3-2,.3-3.4c.6-4.3,1.1-10.8,2.3-13.9a13.5,13.5,0,0,0,.8-7c3.4,1.9,9.6,3.9,9.9,4.2l.6.3,5.9-16.7h-.8s-9.7-1.4-12.8-2-10.1,2-12.1,4.8-1.4,22.4-1.2,34c0,.5.3.8.6,1.4A25.4,25.4,0,0,0,189.8,272.3Zm3.4-30.8,1.4,2.8s1.4,3.1-.3,8c-1.1,3.1-1.7,9.6-2.2,14.1a15.1,15.1,0,0,0-.3,3.4,1.2,1.2,0,0,1-1.2,1.1h-.8a3.4,3.4,0,0,1-2-.8c-.3-.3-.3-.3-.3-.6-.5-18.9-.2-31.9.9-33.4s7.9-4.8,11-4.2,9.6,1.7,11.9,2L206.2,248c-2-.6-8.5-3.1-10.5-4.8Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M181.3,272.3a2.6,2.6,0,0,1,2.8-.5h-.2c-.6.5,0,1.1.8,1.7s4.3.8,5.4-.9V272a17.8,17.8,0,0,0,1.4-1.4.8.8,0,0,1,1.1.3,6,6,0,0,1-.3,4.5l-.2,3.4c0,.3,0,.6-.3.6h-1.2l-1.1-.3c-.3,0-.3-.3-.3-.6v-1.6c0-.3-.2-.3-.2-.3l-.6.3c-.6.2-.9.5-1.4.5a3.2,3.2,0,0,1-1.7-.3C183.3,276,180.2,274.3,181.3,272.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M191.8,280h.5a.3.3,0,0,0,.3-.3c.3-.3.3-.6.6-.9l.3-3.4a8.2,8.2,0,0,0,.3-4.8l-.9-.8a1.5,1.5,0,0,0-1.1.3,18.2,18.2,0,0,0-1.4,1.4v.8c-.9,1.4-2.9,1.7-4.8.9s-.9-.9-.9-.9a.3.3,0,0,0,.3-.3l.8-.5-1.1-.3c-2.3-.6-3.1,0-3.4.8a3.3,3.3,0,0,0-.3,1.5c.3,1.1,2,2.5,4.8,3.9a2.3,2.3,0,0,0,2,.3,3.5,3.5,0,0,0,1.7-.6h.3v1.4c0,.6.3.9.6.9a1.8,1.8,0,0,0,1.1.3C191.2,280,191.5,280,191.8,280Zm0-.9h-.9a2,2,0,0,1-1.1-.3v-1.7a1,1,0,0,0-.3-.8c-.3-.3-.5-.3-.8,0l-.6.3c-.3.3-.8.3-1.4.5a3.2,3.2,0,0,1-1.4-.2c-2.6-1.5-4-2.6-4.3-3.4v-.9c.3-.6,1.2-.6,1.7-.6v.3c0,.9.9,1.4,1.4,1.7,2.3,1.2,4.9.9,6-1.1l.3-.6,1.1-1.1h.3l.3.3a6.3,6.3,0,0,1-.3,4.2v3.4Z"
      transform="translate(-1 -0.4)"
    />
    <path class="cls-4" d="M189.4,274.3h.8l-.3,1.9h-.8Z" transform="translate(-1 -0.4)" />
    <path
      class="cls-4"
      d="M184.7,255.6v-3.1l7.6-2.2,19-11.1,18.4,10.5,2.5-.6h.3v3.2a2.4,2.4,0,0,1-.6,1.1l-24.6,14.1a3.4,3.4,0,0,1-3.4,0l-18.6-10.4A5.1,5.1,0,0,1,184.7,255.6Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M205.6,268.4a3.9,3.9,0,0,0,2-.6l24.6-14.1a1.6,1.6,0,0,0,.9-1.4v-3.2c0-.2,0-.5-.3-.5s-.3-.3-.6,0l-2.2.5L211.9,239H211l-18.9,11-7.7,2.3a.5.5,0,0,0-.5.5v3.1a2.1,2.1,0,0,0,.8,1.7l18.7,10.5C204.2,268.1,204.8,268.4,205.6,268.4Zm26.3-18.7V252a.6.6,0,0,1-.3.5L207,266.7a2.8,2.8,0,0,1-2.8,0l-18.6-10.5a.9.9,0,0,1-.3-.6h0v-2.5l7.6-2,18.7-11,18.1,10.5h.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M230.5,249.4l2-.5h.3V252a2,2,0,0,1-.6,1.1l-1.4.8v-4.5Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M230,254.8l2.2-1.4a1.6,1.6,0,0,0,.9-1.4v-3.1c0-.3,0-.6-.3-.6s-.3-.3-.6,0l-2.2.6Zm1.9-5.1V252a.6.6,0,0,1-.3.5l-.2.3V250Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M184.7,252.3l7.6-2.3,13.3,9.6v7.9a2.7,2.7,0,0,1-1.9-.5L185,256.5c-.6-.3-.6-.6-.6-1.1s.3-2.3.3-3.1Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M205.6,268.4h.9v-8.8l-13.9-10.2-.3.3-7.6,2.3a.6.6,0,0,0-.6.5v3.1c0,.9.3,1.5.9,1.7l18.7,10.5A3.6,3.6,0,0,0,205.6,268.4Zm-.5-8.2V267c-.3,0-.6-.3-.9-.3l-18.6-10.5a.9.9,0,0,1-.3-.6v-2.5l7-2Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M207.3,264.1l24.6-14.4a1.3,1.3,0,0,0,0-2.3L213.3,237a3.4,3.4,0,0,0-3.4,0l-24.6,14.4a1.3,1.3,0,0,0,0,2.3l18.6,10.4A3.4,3.4,0,0,0,207.3,264.1Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M205.6,265.3a5.1,5.1,0,0,0,2-.6l24.6-14.4a2.1,2.1,0,0,0,.9-1.7,1.7,1.7,0,0,0-.9-1.7l-18.6-10.5a3.6,3.6,0,0,0-4,0L185,250.8a2.1,2.1,0,0,0-.9,1.7,1.7,1.7,0,0,0,.9,1.7l18.7,10.5C204.2,265.3,204.8,265.3,205.6,265.3Zm6-28a2.5,2.5,0,0,1,1.4.3L231.6,248a.9.9,0,0,1,.3.6s0,.5-.3.5L207,263.6a2.8,2.8,0,0,1-2.8,0l-18.6-10.5a.9.9,0,0,1-.3-.6s0-.5.3-.5l24.6-14.4A2.2,2.2,0,0,1,211.6,237.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M185.3,207.9l-2.6-1.7a5.2,5.2,0,0,0-3.1-.9c-1.4,0-2.5.3-3.1,1.7v.6l2.6.8v.3l-.9.3s.9,2.5,5.4,2S185.3,207.9,185.3,207.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M181.9,212.1h1.4c1.7-.3,2.5-.8,2.8-1.7a3.1,3.1,0,0,0-.5-2.8l-.3-.3-2.6-1.7a5,5,0,0,0-3.6-.8,3.8,3.8,0,0,0-3.7,1.9v1.4l2,.9-.3.3.3.5S178.2,212.1,181.9,212.1Zm2.8-3.7a1.7,1.7,0,0,1,.3,1.7,2.2,2.2,0,0,1-2,.9c-2.8.3-3.9-.6-4.5-1.2l.6-.2-.3-1.2-2.6-.8a2.4,2.4,0,0,1,2.6-1.4,4.4,4.4,0,0,1,2.8.8Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M187.8,208.7l-1.4-.8h-.8a5,5,0,0,0-2,2.8c0,.3,0,.8.3.8l1.7.9a1,1,0,0,0,.8-.3l1.4-2.3A.8.8,0,0,0,187.8,208.7Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M186.1,213a2.3,2.3,0,0,0,1.2-.6l1.4-2.3a1.5,1.5,0,0,0,.3-1.1c0-.3-.3-.6-.6-.9l-1.4-.8c-.6-.3-1.2-.3-1.4,0a6.6,6.6,0,0,0-2,3.1,1.4,1.4,0,0,0,.5,1.7l1.7.9Zm1.4-3.7h0l-1.4,2.5-1.7-.8a8.9,8.9,0,0,1,1.7-2.6Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-6"
      d="M205.1,207c-.3,1.1.5-1.4,0,0-1.4,4-3.4,8.2-3.4,8.2a82.6,82.6,0,0,0-7.7-3.1,34.7,34.7,0,0,1-5.6-3.1h-.3a3.5,3.5,0,0,0-2.5,3.1v.3c1.1,1.1,11,9.9,18.3,11.6a25.8,25.8,0,0,0,6.3-11C212.7,205.9,205.9,204.5,205.1,207Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M204.5,224.8a27.7,27.7,0,0,0,6.8-11.6c1.4-4.5-.6-7-2.8-7.9s-2.9,0-3.4.9-.3.2-.3.5v.3c-1.1,3.1-2.6,6.5-3.1,7.6-1.4-.5-4.5-1.9-7.1-3.1s-5.1-2.5-5.4-3.1-.5-.3-.8,0a4,4,0,0,0-2.8,3.7,1.5,1.5,0,0,0,.2.9c1.2,1.1,11.1,10.1,18.7,11.5Zm2.5-18.4h.9c1.7.6,3.1,2.6,2.3,6.3a24,24,0,0,1-6,10.4c-7-1.7-16.1-9.9-17.5-11.3a2.5,2.5,0,0,1,1.7-2.5,43.8,43.8,0,0,0,5.6,3.1c3.2,1.1,7.4,3.1,7.4,3.1l.6.3.2-.6,3.2-7.9c0-.3.2-.3.2-.6S206.5,206.4,207,206.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M172.3,270.3a4.2,4.2,0,0,1-2.9,1.5,3,3,0,0,0-2.5,1.4l2.3,2.8,4.8-.3,2.5-2,.6-3.1-2.9-1.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M168.6,276.6l5.1-.3,2.8-2,.9-3.9-3.7-1.7-2,.8a4,4,0,0,1-2.5,1.1,4,4,0,0,0-3.1,1.7l-.3.3Zm4.8-1.4-4.2.2-1.7-2.2a2.8,2.8,0,0,1,1.9-.9,6,6,0,0,0,3.4-1.4l1.4-.5,2.3.8-.6,2.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M221.8,247.4s-11.4,19.3-39.6-2.2a.3.3,0,0,0-.3.3,13.6,13.6,0,0,1-.6,8.7c-1.7,4-3.4,12.8-4.2,16.2a1.9,1.9,0,0,1-1.7,1.4h-.9c-.8,0-2.2-.9-2.2-2,.3-7.1,1.4-31.4,3.1-33.4s9-2.8,12.1-2l21.2,6Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M174.5,272.3h.9a2.2,2.2,0,0,0,2.2-1.9l.3-.9c.9-3.7,2.3-11.6,4-15.3a13.6,13.6,0,0,0,.8-7.9c10.5,7.6,19.5,10.8,27.5,9.1s11.8-7.7,11.8-8l.3-.5-13.6-7.7-21.2-5.9c-3.4-.8-9.9-1.1-12.7,2.3-1.4,1.4-2.2,11.8-3.1,33.3v.3a3.5,3.5,0,0,0,.6,1.7A2.9,2.9,0,0,0,174.5,272.3Zm.9-1.1h-.9a4.8,4.8,0,0,1-1.4-.6c-.3-.2-.3-.2-.3-.8v-.3c1.2-25.4,2.3-31.7,2.9-32.5,2.2-2.8,8.2-2.8,11.6-2l21.2,5.9,12.1,6.8a18.9,18.9,0,0,1-10.7,6.8c-7.9,1.4-17-1.7-27.5-9.6-.2-.3-.5-.3-.8,0a1.1,1.1,0,0,0-.3.9,13.1,13.1,0,0,1-.5,8.4c-1.7,3.7-3.4,11.6-4,15.6l-.3.8A2.1,2.1,0,0,1,175.4,271.2Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M165.2,273.5c.3-1.7,2-2,4-1.7a10.9,10.9,0,0,0-1.5.8c-.5.6,0,1.1,1.2,1.7a4.5,4.5,0,0,0,5.6-1.4l.3-.3.3-.6a8.5,8.5,0,0,1,1.1-1.4c.3-.5,1.2-.2,1.4.3a9.6,9.6,0,0,1,.3,4.5v3.7c0,.3,0,.6-.3.6l-.2.3h-1.7c-.3,0-.3-.3-.3-.6v-2a.3.3,0,0,0-.3-.3l-.3.3a1.5,1.5,0,0,1-1.1.6,3.9,3.9,0,0,1-2.6,0C168.3,277.1,164.6,275.7,165.2,273.5Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M177.1,280.2h.5a1.3,1.3,0,0,0,.6-.2,1.1,1.1,0,0,0,.3-.9v-3.7c.6-2.5.3-3.9-.3-4.8s-.6-.8-1.1-.8-.9,0-1.2.6-.8,1.1-1.1,1.4l.3.2-.3-.2-.3.5-.3.3c-.8,1.4-2.8,2-5,1.4s-1.2-.5-1.2-.8a3.1,3.1,0,0,1,1.2-.9l2.2-.5-2.2-.3c-.9,0-4-.3-4.6,2s4,4.5,6,5.3a5.4,5.4,0,0,0,3.1,0c.3-.3.8-.3,1.1-.5v1.4c0,.5.3.8.9.8A3.4,3.4,0,0,1,177.1,280.2Zm.3-9.6c.2,0,.2,0,.2.3a6.6,6.6,0,0,1,0,4.3v3.9h-1.9l-.3-2a.6.6,0,0,0-.6-.5h-.6l-.2.3c-.3.2-.6.5-.9.5a2.8,2.8,0,0,1-2.2,0c-2.6-.8-6-2.2-5.4-4.2a1.9,1.9,0,0,1,2-1.4.8.8,0,0,0-.3,1.1c.3.8,1.1,1.1,1.7,1.4a5,5,0,0,0,6.2-1.7l.3-.3.5-.3a11.2,11.2,0,0,1,1.5-1.4Z"
      transform="translate(-1 -0.4)"
    />
    <path class="cls-4" d="M175.1,274h.8v2.6h-.8Z" transform="translate(-1 -0.4)" />
    <path
      class="cls-2"
      d="M181.3,245.2h1.1a6.2,6.2,0,0,0-1.6-3.4l-.9.8A6.2,6.2,0,0,1,181.3,245.2Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M223.2,216.1s2.2,15.5,3.6,24-9.6,13-16.6,13.8-14.5-2.8-16.7-6.5a16.1,16.1,0,0,0-5.7-5.3s9.1-6.2,11.6-22.1,11.6-18.4,11.9-18.4S223.2,216.1,223.2,216.1Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M208.2,254.5h2c5.3-.6,12.1-3.1,15.2-7.3a9.5,9.5,0,0,0,2-7.1c-1.4-8.5-3.7-24-3.7-24v-.3c-11.3-15-11.8-15-12.1-15s-9.9,2-12.5,18.9-11,21.8-11.3,21.8l-.8.6.8.5a17.5,17.5,0,0,1,5.4,5.1C195.2,251.1,201.7,254.5,208.2,254.5Zm14.4-38.2c.3,1.7,2.5,15.9,3.7,23.8a8.3,8.3,0,0,1-1.7,6.2c-3.1,4-9.4,6.2-14.4,7.1-7.1.8-14.2-3.1-16.2-6.2a20,20,0,0,0-5-5.1c2.2-2,8.7-8.5,11-22.1s9.9-17.5,11.3-17.8S218.6,211.3,222.6,216.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-6"
      d="M191.2,243.2c7.4-5.1,10.8-15.8,11-16.4l-.8-.3s-3.4,11.1-10.8,15.9Z"
      transform="translate(-1 -0.4)"
    />
    <g id="girl-arm">
      <path
        class="cls-3"
        d="M175.4,212.1a10,10,0,0,0-2-3.4,1.4,1.4,0,0,0-2,.6c0,.3-.3.3-.3,0l-2.5-1.4c-.3-.3-.6,0-.9.2a4.4,4.4,0,0,0-.2,3.4c1.1,2.9,5.6,3.7,5.6,3.7Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-2"
        d="M173.1,216.1l3.1-3.7v-.3a9.5,9.5,0,0,0-2.2-3.7c-.6-.3-1.2-.5-1.4-.3s-.9.6-1.5.9l-2.5-1.4a1.2,1.2,0,0,0-1.7.3c-.6.5-1.1,1.9-.3,3.9s6,4,6,4Zm1.7-4-2,2.5c-1.1-.2-3.9-1.4-4.8-3.1a3.3,3.3,0,0,1,0-2.8l2.9,1.4c.5.3.8,0,1.1-.3l.6-.5s.2,0,.2.3S174.2,211.3,174.8,212.1Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-2"
        d="M177.1,213.5l-1.4-1.4a1.1,1.1,0,0,0-.9-.3,7.9,7.9,0,0,0-2.8,2.3c-.3.3-.3.8.3,1.1l1.7,1.4c.2.3.5.3.8,0l2.3-2A.8.8,0,0,0,177.1,213.5Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-2"
        d="M174.5,217.5a1.1,1.1,0,0,0,.9-.3l2.2-2a1.5,1.5,0,0,0,.6-1.1c0-.3,0-.9-.3-1.1l-1.4-1.5a1.3,1.3,0,0,0-1.4-.2,8.3,8.3,0,0,0-3.1,2.5,1.7,1.7,0,0,0,.3,2l1.7,1.4A.7.7,0,0,0,174.5,217.5Zm.9-5.1,1.4,1.4v.6l-2.3,1.9-1.7-1.4v-.3A5.9,5.9,0,0,1,175.4,212.4Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-6"
        d="M204.2,209.3a1.8,1.8,0,0,0-2.2-.9,2.3,2.3,0,0,0-1.2.6,21.4,21.4,0,0,0-3.9,5.1l-7.7,10.7a59,59,0,0,0-6.5-5.3,24.6,24.6,0,0,1-4.8-4.9h-.3a3.3,3.3,0,0,0-3.1,2.6v.3c.9,1.4,7.9,12.4,14.5,16.7a1.7,1.7,0,0,0,1.4,0c1.9-1.7,8.4-7.7,11.8-13C205.9,213.8,205.1,210.7,204.2,209.3Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-2"
        d="M189.5,234.2a1.2,1.2,0,0,0,1.1-.6c2-1.7,8.5-7.6,11.9-13.3s4-9,2.3-11.6a2.7,2.7,0,0,0-2.8-1.1,1.8,1.8,0,0,0-1.5.8,25.5,25.5,0,0,0-4.2,5.1c-2,3.1-5.9,8.5-7.3,10.2-1.2-1.1-4-3.4-6.3-5.1s-4.2-4.2-4.8-4.5a.9.9,0,0,0-.8-.3,3.8,3.8,0,0,0-3.7,2.8v.9c.8,1.1,7.9,12.4,14.7,16.7Zm14.7-24.9-.5.3c1.4,2.2.5,5.6-2.3,10.4s-9.6,11.3-11.6,13c-.3.3-.6.3-.6,0-6.2-3.9-13-14.4-14.1-16.1a3,3,0,0,1,2.5-2,26.3,26.3,0,0,0,4.8,4.8,76.1,76.1,0,0,1,6.6,5.4l.5.6.3-.6s5.4-7.1,7.6-10.7a22,22,0,0,1,4-4.8c.3-.3.6-.3.8-.6s1.2,0,1.5.6l.5-.3-.5.3Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-2"
        d="M188.4,227.7l1.1-.3a4.8,4.8,0,0,1,.3-2.6l-1.1-.3C188.4,224.5,188.1,226.2,188.4,227.7Z"
        transform="translate(-1 -0.4)"
      />
    </g>
    <path
      class="cls-4"
      d="M205.4,199.1s1.1,4,.2,5.7,3.7,1.4,3.7,1.4l4.8-3.4a10.1,10.1,0,0,1-1.4-4.3c0-1.9.3-2.2-.3-1.9S205.4,199.1,205.4,199.1Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M207.9,206.7h1.7l5.4-3.9-.3-.6s-1.4-2.3-1.1-4v-1.4c0-.5,0-.8-.3-1.1s-.6,0-.9,0-6.5,2.5-7,2.8l-.6.3.3.6c.3,1.1.8,3.9.3,5.1a1.2,1.2,0,0,0,0,1.4C205.6,206.7,206.8,206.7,207.9,206.7Zm1.1-1.1c-1.4,0-2.8,0-3.1-.3V205c.9-1.7.3-4.5,0-5.6a49.7,49.7,0,0,1,6-2.3v1.1a8.5,8.5,0,0,0,1.1,4.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M205.9,180.4s-5.9-.2-7.6,4.8,2,8.8,2,8.8,5.1-1.4,5.9-4S205.9,180.4,205.9,180.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M200,194.9h.3c.5-.3,5.3-1.7,6.2-4.3s0-9.6,0-9.9v-.5h-.6s-6.2-.3-8.5,5S199.4,194.3,200,194.9Zm5.4-13.9c.2,2.3.5,7.4,0,8.8s-3.7,2.8-5.1,3.4a7.9,7.9,0,0,1-1.7-8C200,181.6,203.9,181,205.4,181Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-6"
      d="M209.3,181s4-3.4,5.7,5.1c1.1,5.9-1.2,9.3-5.7,12.7a5.1,5.1,0,0,1-4.2.9,6.5,6.5,0,0,1-3.7-4.3,22.3,22.3,0,0,1-.6-10.2c-.8-3.4,1.4-3.1,5.7-4.2Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M206.2,200.8a5.7,5.7,0,0,0,3.4-1.1c5.1-4,6.8-8,5.9-13.6-.5-3.4-1.7-5.7-3.4-6.2s-2.5.3-3.1.5l-2.8.3c-.8.3-1.7.3-2.3.6s-2.8.5-3.4,1.7a3.8,3.8,0,0,0-.2,2.5,20.8,20.8,0,0,0,.5,10.2,6.8,6.8,0,0,0,4.3,4.8C205.4,200.5,205.6,200.8,206.2,200.8ZM211,181h.6c.8.3,2,1.4,2.5,5.1,1.1,5.9-1.4,9-5.4,12.1a4.1,4.1,0,0,1-3.6.9,6,6,0,0,1-3.4-4,18.7,18.7,0,0,1-.6-9.9c-.3-.8-.3-1.4,0-1.7s1.4-.8,2.8-1.1,1.5-.3,2.3-.6l3.1-.2h.3A2.2,2.2,0,0,1,211,181Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M206.5,209c-2,.3-4.8-2-3.4-3.4l.3-.3c1.1-.8,5.1.3,7.3-1.1a3.1,3.1,0,0,0,1.7-2.8,1.8,1.8,0,0,1,.3-1.2c.3-.3.6-.3,1.1-.3s2.3,1.7,1.7,3.4a8.4,8.4,0,0,1-4.8,4.6A32.5,32.5,0,0,1,206.5,209Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M206.2,209.6h.3a17.2,17.2,0,0,0,4.2-1.2,8.4,8.4,0,0,0,5.1-4.8,3.8,3.8,0,0,0-.3-3.1,2.1,2.1,0,0,0-1.9-1.1,6.1,6.1,0,0,0-1.5.3c-.5.2-.5,1.1-.5,1.7s0,1.1-1.4,2.2-2.9.9-4.6.9a4.7,4.7,0,0,0-2.8.5.3.3,0,0,0-.3.3,1.6,1.6,0,0,0-.3,2A5.5,5.5,0,0,0,206.2,209.6Zm.3-1.2a4.4,4.4,0,0,1-3.1-1.7c-.3-.3,0-.5,0-.5s1.4-.3,2.2-.3,3.7,0,5.1-.9,2-2.8,2-3.4v-.5a.4.4,0,0,1,.6,0c.3,0,.8.3.8.5a2.3,2.3,0,0,1,.3,2,9,9,0,0,1-4.5,4.3A17.4,17.4,0,0,0,206.5,208.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M207.6,177.6c-3.1.3-7.1,3.1-7.6,5.4s-.6,4.2,2.2,3.9c1.2,0,2,2.9,2.3,4s1.1,1.1,1.4.8,2,1.2,2.3,2.3-.3,2.3-.9,2.6c1.7,4.2-6.8,9,1.7,12.4.3,0-5.6,8.5,2,13s19.5,2.5,22.3-5.1c5.1-13-12.7-15.3-13.5-26.3C219.2,181.8,213,177,207.6,177.6Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M219.8,224.5a19,19,0,0,0,7-1.1c3.7-1.4,6.3-3.4,7.4-6.2,3.1-7.6-1.7-11.9-6.2-16.1s-6.8-6.2-7.4-10.8a15,15,0,0,0-5.4-11,9.7,9.7,0,0,0-7.6-2.5c-3.4.5-7.3,3.1-8.2,5.6s-.6,3.1,0,4a4.1,4.1,0,0,0,2.8.8c.3,0,.6.6,1.5,2.8,0,.3.2.3.2.6a2.8,2.8,0,0,0,2.3,1.4.9.9,0,0,1,.6.3,1.7,1.7,0,0,1,.8,1.4c0,.9-.3,2-.6,2l-.5.3.3.6c.5,1.4-.3,2.8-.9,4.5s-1.7,3.4-.8,5.1,1.4,1.9,3.4,2.8c-4,7.3-.9,11.3,2.5,13.3S216.4,224.5,219.8,224.5Zm-11.1-46.3a10.6,10.6,0,0,1,6,2.2,14.2,14.2,0,0,1,4.8,9.9c.3,5.1,3.9,8.5,7.6,11.6s8.8,7.7,6,14.7c-1.2,3.1-4.3,4.8-6.5,5.7-4.8,1.7-11.4,1.4-15-.9s-4.8-6.2-2-11.6c.3-.5.3-.5.3-.8v-.3h-.3c-1.7-.8-2.8-1.4-3.1-2.5s.3-2.6.8-4,1.7-3.4,1.2-5.1a5.1,5.1,0,0,0,.8-2.8,3,3,0,0,0-1.4-2.3,3.9,3.9,0,0,0-1.4-.5c-.3,0-.9-.3-.9-.6a.7.7,0,0,0-.2-.6c-.6-1.7-1.5-3.9-2.9-3.6s-1.4,0-1.7-.3-.3-1.2.3-2.9,4.3-4.5,7.1-4.8C208.2,178.2,208.5,178.2,208.7,178.2Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M201.7,186.9l1.1-.2c-.6-3.4,1.7-4.3,1.7-4.3l-.6-1.1A5.2,5.2,0,0,0,201.7,186.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M209.6,209.3a14.3,14.3,0,0,1,1.7-3.1l-.9-.9a7.7,7.7,0,0,0-1.9,3.7Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M216.4,190.3h1.1a13.1,13.1,0,0,0-3.1-7.3l-.8.8.2-.5-.2.5S215.8,185.8,216.4,190.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M226.6,219.7a8.1,8.1,0,0,0,3.9-6.2h-1.1a7.4,7.4,0,0,1-3.4,5.1Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M205.6,249.1l3.7-18.6a4.9,4.9,0,0,1,2-2.8l22.9-13.1a1.3,1.3,0,0,1,.8-.2,5,5,0,0,1,3.4,2.2l-2.5,1.7h-.3l-3.1,15.9a4.4,4.4,0,0,1-2,2.8l-17.2,6.8-1.7,2-2.3,6.7c-.6,0-3.7,0-3.7-2.5v-.3C205.4,250,205.4,249.4,205.6,249.1Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M209.6,253.4l.3-.6,2.2-6.8,1.5-1.9,17.2-6.8a5.5,5.5,0,0,0,2.3-3.1l2.8-15.3,2.5-1.7c.3-.3.6-.6.3-.9s-1.4-2.5-3.9-2.5a1.8,1.8,0,0,0-1.2.3l-22.9,13a4.8,4.8,0,0,0-2.2,3.4l-3.7,18.6v1.2c.3,2.2,2.5,3.1,4.2,3.1Zm20.6-17-17.5,6.8v.3l-1.7,2.3-2,6.5a2.6,2.6,0,0,1-2.8-2v-.9l3.7-18.6a4,4,0,0,1,1.7-2.6l22.9-13h.5a3.6,3.6,0,0,1,2.6,1.7l-2,1.1-.6-.2-3.1,16.6A4.5,4.5,0,0,1,230.2,236.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M205.4,250.3v-.9l3.6-18.6a2.2,2.2,0,0,1,.9-1.7,9,9,0,0,0,2.5,1.7s3.4,1.9,3.7,1.9a55.2,55.2,0,0,1,5.7,6,9.1,9.1,0,0,1-.3,2l-8.5,3.4-1.7,1.9-2.3,6.8C208.7,252.8,205.6,252.8,205.4,250.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M209.6,253.4l.3-.6,2.2-6.8,1.5-1.9,8.7-3.4v-.3a12.2,12.2,0,0,0,.3-2.3c-.3-.8-5.7-6.2-5.9-6.2a22.1,22.1,0,0,1-3.4-2,7.9,7.9,0,0,1-2.6-1.7l-.5-.5-.6.5a2.7,2.7,0,0,0-.9,2l-3.6,18.7V250c.3,2.3,2.5,3.1,4.2,3.1Zm11.6-13.3-8.2,3.1v.3l-1.7,2.3v.2l-2,6.5c-.8,0-2.5-.2-2.8-1.9v-.9l3.7-18.7c0-.2.2-.5.2-.8a20,20,0,0,0,2.3,1.4c.9.6,3.1,1.7,3.7,2s4.8,4.8,5.4,5.6S221.2,239.2,221.2,240.1Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M233.3,215.2l1.2-.6a1.2,1.2,0,0,1,.8-.2,5.3,5.3,0,0,1,3.4,2.2l-1.4.9c-.6-.3-.6-.6-.6-.6S235.3,216.1,233.3,215.2Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M237,218.6l1.7-1.1c.3-.3.6-.6.3-.9s-1.4-2.5-4-2.5a1.7,1.7,0,0,0-1.1.3l-2,1.1,1.2.6a6,6,0,0,1,2.8,1.7c0,.2.3.5.8.8Zm.6-2-.6.3v-.3a14.4,14.4,0,0,0-2.2-1.7h.2A4.9,4.9,0,0,1,237.6,216.6Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M207.9,251.4l3.7-18.9a4,4,0,0,1,2-2.9l22.9-13a1.1,1.1,0,0,1,1.6,1.4l-3.3,18.4a3.9,3.9,0,0,1-2,2.8l-23.2,13.9A1.8,1.8,0,0,1,207.9,251.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M209.3,253.4a1.1,1.1,0,0,0,.9-.3l23.1-13.9a4.5,4.5,0,0,0,2.3-3.3l3.4-18.4a2.8,2.8,0,0,0-.8-2,1.3,1.3,0,0,0-2,0l-22.9,13a5.1,5.1,0,0,0-2.3,3.1l-3.7,19c-.3.8,0,1.4.9,1.9S208.7,253.4,209.3,253.4Zm28-36.5h.3a1,1,0,0,1,.3.6l-3.4,18.4a4.5,4.5,0,0,1-1.7,2.5l-23.2,13.9a.6.6,0,0,1-.6,0,1,1,0,0,1-.3-.6l3.7-19a4.5,4.5,0,0,1,1.7-2.5l22.9-13Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M207.3,253.1l.3-.8c-2-.3-1.7-1.7-1.7-2l3.7-19.3-.9-.2L205.1,250C204.8,250.8,205.1,252.5,207.3,253.1Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M140,201.1l-4.2,2.5a2.2,2.2,0,0,1-2.3-.3l-7.6-6.5a1,1,0,0,1,0-1.7l4.2-2.5a2.2,2.2,0,0,1,2.3.3l7.6,6.5A1,1,0,0,1,140,201.1Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M134.7,204.5c.5,0,.8,0,1.1-.3l4.2-2.6a1.3,1.3,0,0,0,.9-1.1,2,2,0,0,0-.6-1.4l-7.6-6.5a2.5,2.5,0,0,0-2.8-.3l-4.3,2.6a1.4,1.4,0,0,0-.8,1.1,2.6,2.6,0,0,0,.5,1.4l7.7,6.5A1.9,1.9,0,0,0,134.7,204.5Zm-3.4-11.3a1.2,1.2,0,0,1,.8.2l7.7,6.5v.3a.3.3,0,0,1-.3.3l-4.3,2.6a1.7,1.7,0,0,1-1.4,0l-7.6-6.5v-.3a.3.3,0,0,1,.3-.3l4.2-2.6C130.7,193.2,131,193.2,131.3,193.2Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M140,199.9l-4.2,2.6a2.2,2.2,0,0,1-2.3-.3l-7.6-6.5a1,1,0,0,1,0-1.7l4.2-2.5a2.4,2.4,0,0,1,2.3.2l7.6,6.5C140.6,198.8,140.6,199.7,140,199.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M134.7,203.3a1.8,1.8,0,0,0,1.1-.2l4.2-2.6a1.5,1.5,0,0,0,.9-1.1,1.8,1.8,0,0,0-.6-1.4l-7.6-6.5a2.5,2.5,0,0,0-2.8-.3l-4.3,2.5a1.7,1.7,0,0,0-.8,1.2,2.9,2.9,0,0,0,.5,1.4l7.7,6.5A3.4,3.4,0,0,0,134.7,203.3Zm-3.4-11.6a.9.9,0,0,1,.8.3l7.7,6.5v.3a.3.3,0,0,1-.3.3l-4.3,2.5a1.2,1.2,0,0,1-1.4,0l-7.6-6.5v-.2a.3.3,0,0,1,.3-.3l4.2-2.6A1,1,0,0,1,131.3,191.7Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M141.6,295.9l1.5-2.5-22.2-13.1a5.8,5.8,0,0,1-2.8-5.1V229.6h-2.8v45.6a8.6,8.6,0,0,0,4.2,7.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M63.4,278.9v-3.4l8.8-2.6,21.2-12.4,7.4,4.2,2.8-.8h.3v3.4c0,.5-.3.8-.8,1.1L75.6,284.3a4.7,4.7,0,0,1-4,0l-7.7-4.6C63.7,279.7,63.4,279.5,63.4,278.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M73.9,285.7a4.8,4.8,0,0,0,2.2-.6l27.5-15.8a2.8,2.8,0,0,0,1.2-1.7v-3.5c0-.2,0-.5-.3-.5s-.6-.3-.6,0l-2.5.5L94,259.9h-.9L71.9,272.4l-8.5,2.2c-.3,0-.6.3-.6.9v3.4a1.8,1.8,0,0,0,1.1,1.7l7.7,4.5A6,6,0,0,0,73.9,285.7Zm29.5-21v2.6c0,.3,0,.5-.6.5L75.3,283.7a3.4,3.4,0,0,1-3.4,0l-7.7-4.5c-.3-.3-.3-.3-.5-.9h.2v-3.1l8.5-2.3,21-12.2,7.1,4.3h.6Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M63.7,275.2l8.7-2.5,1.7-1.2v13.4a3.6,3.6,0,0,1-1.9-.6l-7.7-4.6a1.2,1.2,0,0,1-.8-1.1c-.3.3-.3-2.5,0-3.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M73.9,285.7h.8v-15l-2.5,1.4-8.5,2.3c-.3,0-.6.2-.6.8v3.4a2,2,0,0,0,1.1,1.7l7.7,4.6A2.6,2.6,0,0,0,73.9,285.7Zm-.6-12.8v11.7l-1.1-.3-7.7-4.6c-.3-.2-.3-.2-.6-.8v-3.1l8.5-2.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M75.8,281.2l27.6-15.9a1.4,1.4,0,0,0,0-2.6l-8-4.5a4,4,0,0,0-3.7,0L64.2,274.1a1.4,1.4,0,0,0,0,2.5l7.7,4.6A5.2,5.2,0,0,0,75.8,281.2Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M73.9,282.3a6,6,0,0,0,2.2-.6l27.5-15.9a2.2,2.2,0,0,0,1.2-1.9,2,2,0,0,0-1.2-2l-7.9-4.6a4.5,4.5,0,0,0-4.5,0L63.7,273.2a2.5,2.5,0,0,0-1.2,2,2.1,2.1,0,0,0,1.2,2l7.9,4.5A6,6,0,0,0,73.9,282.3Zm1.7-1.7a3.1,3.1,0,0,1-3.2,0l-7.9-4.5c-.3-.3-.6-.6-.6-.9s.3-.6.6-.8L92,258.5a2.9,2.9,0,0,1,3.1,0l8,4.5a1.4,1.4,0,0,1,.5.9,1.5,1.5,0,0,1-.5.8Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M59.1,252.2h4.6l47.6-27.8L144.5,252H147l-.3,3.6a2.9,2.9,0,0,1-1.4,2.6L97.1,286a4.3,4.3,0,0,1-4.5-.3L59.7,258.5a2.7,2.7,0,0,1-.9-2Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M95.1,287.1a9.5,9.5,0,0,0,2.3-.5l48.2-28.1a3.2,3.2,0,0,0,1.7-2.6v-.3l.3-4.2h-3.1L111,223.9,63.1,251.7H58v.5l-.3,4.3a5.5,5.5,0,0,0,1.1,2.5l32.9,27.3A18.1,18.1,0,0,0,95.1,287.1Zm51.1-32v.3a2.2,2.2,0,0,1-1.2,1.9L96.8,285.1a3.5,3.5,0,0,1-3.7-.2L60.2,257.6c-.5-.3-.5-.8-.5-1.4l.3-3.7h4.5l47.4-27.2,32.9,27.2h1.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M92.6,285.4,59.7,258.2a2.5,2.5,0,0,1-.9-2l.3-4.2h4.6l2.2-1.5,24.4,16.2,4.8,9.6V286A2.5,2.5,0,0,1,92.6,285.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M95.7,287.1V276.6l-4.8-9.9L66.2,250.3l-2.5,1.4H58.5v.5l-.2,4.3a4.6,4.6,0,0,0,1.1,2.5l32.9,27.3a5.4,5.4,0,0,0,2.8,1.1Zm-1.4-10.2v8.8a2.5,2.5,0,0,1-1.4-.6L60,257.9c-.6-.3-.6-.8-.6-1.4l.3-3.7h4.2l2.3-1.1L90,267.6Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M143.9,251.4l.6.3H147l-.3,3.7a2.9,2.9,0,0,1-1.4,2.5v-.3l-5.4,3.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M139.9,261.9l4.9-3.1.8-.3a3.2,3.2,0,0,0,1.7-2.6v-.3l.3-4.2h-3.1l-.3-.3-.9.9.6.5h2l-.3,2.9a2.9,2.9,0,0,1-.8,1.7l-6,3.6Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M97.1,282l48.2-27.8a3,3,0,0,0,.3-5.1L113,222.2a3.3,3.3,0,0,0-4-.3L60,250.3a2.6,2.6,0,0,0-.3,4.2l32.9,27.2A4.1,4.1,0,0,0,97.1,282Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M95.4,283.1a6.4,6.4,0,0,0,2.3-.5l48.2-27.8a4.4,4.4,0,0,0,2-2.8,3.8,3.8,0,0,0-1.4-3.2l-32.7-26.9a4.4,4.4,0,0,0-4.8-.3L60,250a3.5,3.5,0,0,0-1.7,2.5,3.6,3.6,0,0,0,1.1,2.9l32.9,27.2A9.6,9.6,0,0,0,95.4,283.1Zm15.9-60.9a3.8,3.8,0,0,1,1.7.5l32.6,26.7a3,3,0,0,1,.9,2,3,3,0,0,1-1.2,2L97.1,281.2a3.8,3.8,0,0,1-3.7-.3L60.5,253.7A1.4,1.4,0,0,1,60,252a1.6,1.6,0,0,1,.8-1.5l49.1-28.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M96.5,278.9,142.8,252c.3-.3.5-.9,0-1.2L111.9,225a1.3,1.3,0,0,0-1.5,0L63.9,251.7c-.2.3-.2.8,0,.8l31.2,25.8C95.4,279.2,96,279.2,96.5,278.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M95.7,279.7a2.2,2.2,0,0,0,1.1-.2l46-26.7a1.4,1.4,0,0,0,.5-1.1,1.3,1.3,0,0,0-.5-1.2l-30.9-25.8a2.6,2.6,0,0,0-2.3-.3L63.1,251.1c-.3.3-.6.6-.6.9a1.1,1.1,0,0,0,.6,1.1l31.2,25.8A2,2,0,0,0,95.7,279.7Zm15-54.1c.3,0,.3,0,.6.3l30.9,25.8L96.3,278.3a.9.9,0,0,1-1.2,0L63.9,252.5l46.5-26.6A.3.3,0,0,1,110.7,225.6Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M62.5,244v-3.4l8.8-2.5,21.3-12.5,7.3,4.2,2.9-.8h.3v3.4c0,.6-.3.8-.9,1.1L74.7,249.4a4.7,4.7,0,0,1-4,0l-7.6-4.5C62.8,244.9,62.5,244.6,62.5,244Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M73,250.8a7.1,7.1,0,0,0,2.3-.5l27.5-15.9c.6-.3.8-.9,1.1-1.7v-3.4c0-.3,0-.6-.3-.6s-.5-.3-.5,0l-2.6.6L93.1,225h-.8L71,237.5l-8.5,2.3c-.3,0-.6.2-.6.8V244a1.7,1.7,0,0,0,1.2,1.7l7.6,4.6A7.8,7.8,0,0,0,73,250.8Zm29.5-21v2.6c0,.3,0,.6-.6.6L74.4,248.8a3.4,3.4,0,0,1-3.4,0l-7.6-4.5c-.3-.3-.6-.3-.6-.9h0v-3.1l8.5-2.2,21-12.2,7.1,4.2h.5Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M62.5,240.3l8.8-2.5,1.7-1.2V250a4.3,4.3,0,0,1-2-.6l-7.6-4.5a1.6,1.6,0,0,1-.9-1.2Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M73,250.8h.9v-15l-2.6,1.4-8.5,2.3c-.3,0-.6.3-.6.8v3.4a1.9,1.9,0,0,0,1.2,1.7L71,250A2.5,2.5,0,0,0,73,250.8Zm-.6-12.7v11.6l-1.1-.3-7.6-4.5c-.3-.3-.6-.3-.6-.9v-3.1l8.5-2.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M101.1,231l-.6-1.4,2.6-.6h.3v3.4c0,.6-.3.8-.9,1.1l-1.4.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M100.2,235.5l2.3-1.4a2.4,2.4,0,0,0,1.1-1.7V229c0-.3,0-.6-.2-.6s-.6-.3-.6,0l-3.1.9.2.5c.3.6.3,1.2.6,1.2v4.5Zm2.3-5.7v2.6c0,.3,0,.6-.6.6l-.5.2v-2.5a.9.9,0,0,0-.3-.6Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M75,246.3l27.5-15.9a1.4,1.4,0,0,0,0-2.6l-7.9-4.5a4,4,0,0,0-3.7,0L63.4,239.2a1.3,1.3,0,0,0,0,2.5l7.9,4.6A4.7,4.7,0,0,0,75,246.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M73,247.4a6.5,6.5,0,0,0,2.3-.6L102.8,231a2.4,2.4,0,0,0,1.1-2,2.2,2.2,0,0,0-1.1-2l-8-4.5a4.1,4.1,0,0,0-4.5,0L62.8,238.3a2.4,2.4,0,0,0-1.1,2,2,2,0,0,0,1.1,2l7.9,4.5A7.1,7.1,0,0,0,73,247.4Zm1.4-1.7a2.9,2.9,0,0,1-3.1,0l-7.9-4.5c-.3-.3-.6-.6-.6-.9s.3-.5.6-.8l27.5-15.9a2.9,2.9,0,0,1,3.1,0l7.9,4.5c.3.3.6.6.6.9s-.3.6-.6.8Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M127.5,251.1,103.4,265,88,252l23.9-13.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M103.4,265.6l25.2-14.5-16.7-13.9-25,14.5Zm22.9-14.5-22.9,13L88.9,252.2l22.7-13.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M133.7,250.5l-24.1,13.6L94.3,251.4l23.8-13.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M109.6,265l25.2-14.5-16.7-13.9-25,14.5Zm23-14.7-23,13L95.1,251.4l22.7-13.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M122.4,240.9l-4.3,2.5a2.4,2.4,0,0,1-2.3-.2l-7.6-6.6a1,1,0,0,1,0-1.7l4.2-2.5a2.2,2.2,0,0,1,2.3.3l7.7,6.5C122.9,239.8,122.9,240.6,122.4,240.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M117,244.3c.5,0,.8,0,1.1-.3l4.3-2.5a1.7,1.7,0,0,0,.8-1.2,2.2,2.2,0,0,0-.6-1.4l-7.6-6.5a2.6,2.6,0,0,0-2.9-.3l-4.2,2.6a1.3,1.3,0,0,0-.9,1.1,2,2,0,0,0,.6,1.4l7.7,6.5A1.9,1.9,0,0,0,117,244.3ZM113.6,233a1.3,1.3,0,0,1,.8.2l7.7,6.6v.2a.3.3,0,0,1-.3.3l-4.3,2.6a1.2,1.2,0,0,1-1.4,0l-7.6-6.5v-.3s0-.3.2-.3l4.3-2.6C113,233,113.3,233,113.6,233Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M122.4,239.8l-4.3,2.5a2.2,2.2,0,0,1-2.3-.3l-7.6-6.5a1,1,0,0,1,0-1.7l4.2-2.5a2.4,2.4,0,0,1,2.3.2l7.7,6.6A1.1,1.1,0,0,1,122.4,239.8Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M117,243.2c.5,0,.8,0,1.1-.3l4.3-2.6a1.6,1.6,0,0,0,.8-1.1,2,2,0,0,0-.6-1.4l-7.6-6.5a2.6,2.6,0,0,0-2.9-.3l-4.2,2.5a1.6,1.6,0,0,0-.9,1.2,2.2,2.2,0,0,0,.6,1.4l7.7,6.5A1.9,1.9,0,0,0,117,243.2Zm5.1-4-4.3,2.5c-.6.3-1.1.3-1.4,0l-7.7-6.5v-.3s0-.2.3-.2l4.3-2.6a1.2,1.2,0,0,1,1.4,0l7.7,6.5v.3A.3.3,0,0,0,122.1,239.2Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M101.9,271.2l-4.2,2.6a2.2,2.2,0,0,1-2.3-.3l-1.7-1.1a1,1,0,0,1,0-1.7l4.3-2.6a2,2,0,0,1,2.2.3l1.7,1.1A1,1,0,0,1,101.9,271.2Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M96.5,274.6a2,2,0,0,0,1.2-.2l4.2-2.6a1.5,1.5,0,0,0,.9-1.1,1.8,1.8,0,0,0-.6-1.4l-1.7-1.2a2.6,2.6,0,0,0-2.8-.3l-4.3,2.6a1.6,1.6,0,0,0-.8,1.1,2.3,2.3,0,0,0,.5,1.4l1.7,1.2A4.1,4.1,0,0,0,96.5,274.6Zm2.6-6.2a1.1,1.1,0,0,1,.9.3l1.7,1.1v.3a.3.3,0,0,1-.3.3l-4.3,2.5c-.6.3-1.1.3-1.4,0L94,271.8v-.3a.3.3,0,0,1,.3-.3l4.2-2.5C98.5,268.4,98.8,268.4,99.1,268.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M101.9,270.1l-4.5,2.6a2.8,2.8,0,0,1-2.3-.3l-1.7-1.2a1.1,1.1,0,0,1,0-1.7l4.3-2.5a2,2,0,0,1,2.2.3l1.8,1.1C102.5,268.7,102.5,269.5,101.9,270.1Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M96.5,273.5c.6,0,.9,0,1.2-.3l4.2-2.5a1.6,1.6,0,0,0,.9-1.2,2.2,2.2,0,0,0-.6-1.4l-1.7-1.1a2.4,2.4,0,0,0-2.8-.3l-4.3,2.6a1.4,1.4,0,0,0-.8,1.1,2.6,2.6,0,0,0,.5,1.4l1.7,1.1A4.4,4.4,0,0,0,96.5,273.5Zm2.6-6.2a1.1,1.1,0,0,1,.9.3l1.7,1.1v.3a.3.3,0,0,1-.3.3l-4.3,2.5c-.6.3-1.1.3-1.4,0L94,270.7v-.3a.3.3,0,0,1,.3-.3l4.2-2.5C98.5,267.3,98.8,267.3,99.1,267.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M104.8,246.6l-4.3,2.5a2.2,2.2,0,0,1-2.3-.3l-1.7-1.1a1.2,1.2,0,0,1,0-1.7l4.3-2.6a2.7,2.7,0,0,1,2.3.3l1.7,1.2A1,1,0,0,1,104.8,246.6Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M99.7,250.3c.5,0,.8,0,1.1-.3l4.3-2.6a1.6,1.6,0,0,0,.8-1.1,1.8,1.8,0,0,0-.6-1.4l-1.7-1.2a2.8,2.8,0,0,0-2.8-.3L96.5,246a1.6,1.6,0,0,0-.8,1.1,2.3,2.3,0,0,0,.6,1.5l1.7,1.1A3.5,3.5,0,0,0,99.7,250.3Zm2.5-6.3a1.1,1.1,0,0,1,.9.3l1.7,1.1v.3a.3.3,0,0,1-.3.3l-4.3,2.6a1.7,1.7,0,0,1-1.4,0l-1.7-1.2v-.3a.3.3,0,0,1,.3-.3l4.3-2.5C101.7,244,101.9,244,102.2,244Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M104.8,245.4l-4.3,2.6a2.2,2.2,0,0,1-2.3-.3l-1.7-1.1a1.1,1.1,0,0,1,0-1.7l4.3-2.6a2.2,2.2,0,0,1,2.3.3l1.7,1.1A1,1,0,0,1,104.8,245.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M99.7,248.8a1.8,1.8,0,0,0,1.1-.2l4.3-2.6a1.8,1.8,0,0,0,.8-1.1,2.3,2.3,0,0,0-.6-1.5l-1.7-1.1a2.6,2.6,0,0,0-2.8-.3l-4.3,2.6a1.6,1.6,0,0,0-.8,1.1,2,2,0,0,0,.6,1.4l1.7,1.2A2.2,2.2,0,0,0,99.7,248.8Zm2.5-5.9a1.1,1.1,0,0,1,.9.3l1.7,1.1v.3a.3.3,0,0,1-.3.3l-4.3,2.5a1.2,1.2,0,0,1-1.4,0l-1.7-1.1V246a.3.3,0,0,1,.3-.3l4.3-2.5C101.7,242.9,101.9,242.9,102.2,242.9Z"
      transform="translate(-1 -0.4)"
    />
    <path class="cls-2" d="M81.7,255.1,93.4,261l-.7,1.3-11.6-5.9Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M77.2,252.8l8,9.2-1.1.9-8-9.2Z" transform="translate(-1 -0.4)" />
    <path
      class="cls-4"
      d="M71.6,269.8a.3.3,0,0,1,.3.3l-1.2,5.7c0,.5-.5,1.4-1.9,1.7a3,3,0,0,1-2.3,0c-1.4-.3-2-.9-2-1.7l-1.1-5.7a.3.3,0,0,1,.3-.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M67.6,278.3a1.8,1.8,0,0,0,1.2-.3,2.9,2.9,0,0,0,2.5-2.2l1.1-5.4a.9.9,0,0,0-1.1-1.1H63.7a1.5,1.5,0,0,0-.9.2,1.1,1.1,0,0,0-.3.9l1.2,5.7c0,1.1.8,1.7,2.5,2.2Zm3.7-7.9-1.1,5.4c0,.3-.6.8-1.4,1.1a2.3,2.3,0,0,1-2,0c-1.2-.3-1.4-.8-1.4-1.1l-1.2-5.1h7.1Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M64.8,268.1c-1.7.9-1.7,2.6,0,3.4a6.8,6.8,0,0,0,5.9,0c1.7-.8,1.7-2.5,0-3.4A7.6,7.6,0,0,0,64.8,268.1Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M67.6,272.9a6.8,6.8,0,0,0,3.4-.8,2.8,2.8,0,0,0,1.4-2.3,2.9,2.9,0,0,0-1.4-2.3,6.8,6.8,0,0,0-6.5,0,3.2,3.2,0,0,0-1.4,2.3,3,3,0,0,0,1.4,2.3A5.5,5.5,0,0,0,67.6,272.9Zm0-4.8a6.6,6.6,0,0,1,2.6.6,1.6,1.6,0,0,1,.8,1.1,1.7,1.7,0,0,1-.8,1.2,6.4,6.4,0,0,1-5.4,0,1.6,1.6,0,0,1-.9-1.2,1.5,1.5,0,0,1,.9-1.1A11.8,11.8,0,0,1,67.6,268.1Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M136,314.6a19.8,19.8,0,0,1,.5,5.4s-3.4,1.4-5.6.3a6,6,0,0,0-4.9.3l-6.8-.9c0,.3-1.4-2.8.9-3.7s7.4-3.1,7.4-3.1l2.8-.8,4.5,1.4C135.4,313.8,136,314.1,136,314.6Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M132.8,321.4a15.1,15.1,0,0,0,4-.8l.3-.3V320a18.5,18.5,0,0,0-.6-5.7,2.6,2.6,0,0,0-1.7-1.7l-4.8-1.4-2.8,1.2s-5.1,1.9-7.4,3.1-2,1.7-1.4,3.4.3,1.7,1.1,1.7h.6a31.9,31.9,0,0,1,3.7.5l2.8.3a5,5,0,0,1,4.3-.3C131.1,321.4,132,321.4,132.8,321.4Zm3.2-1.7c-.9.3-3.2,1.2-4.9.3a4.9,4.9,0,0,0-5.1.3,19.5,19.5,0,0,0-2.2-.3,39.1,39.1,0,0,0-4-.6c-.3-.2-.3-1.1-.3-1.7s.3-.5.9-.8c2.2-1.1,7.3-3.1,7.3-3.1l2.6-.9,4.5,1.4q.4,0,.9.9A19.9,19.9,0,0,1,136,319.7Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M135.7,309.5l-.6,3.4a3.9,3.9,0,0,1-4,1.4c-2.5-.5-.8-6.2-.8-6.2Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M132.3,314.9a4.8,4.8,0,0,0,3.4-1.7l.5-4-6.2-1.9-.3.5c0,.3-1.1,4-.3,6a3.5,3.5,0,0,0,1.5,1.1Zm2.2-2.3a2.8,2.8,0,0,1-3.1.9.6.6,0,0,1-.5-.6c-.6-1.1-.3-3.1,0-4.5l3.9,1.1Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M124.3,281.7l11.9,4.6a11.7,11.7,0,0,1,.6,5.6,74,74,0,0,0,0,17.6s-2.5,3.1-6.8.3c0,0-2.8-20.4-5.4-27.5C124.3,282.3,124.3,282,124.3,281.7Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M133.1,311.8a6.3,6.3,0,0,0,4-1.7l.3-.3v-.3a114.8,114.8,0,0,1,0-17.6,13.4,13.4,0,0,0-.6-5.9v-.3l-13.3-5.1.3,1.4c0,.3,0,.3.3.6,2.5,6.8,5.1,26.9,5.3,27.2v.3l.3.3A5.2,5.2,0,0,0,133.1,311.8Zm2.9-2.6c-.6.6-2.6,2-5.7.3-.3-2.5-2.8-19.8-5.1-26.6l10.5,3.9a12.9,12.9,0,0,1,.3,5.1C135.4,297,135.7,304.4,136,309.2Z"
      transform="translate(-1 -0.4)"
    />
    <path class="cls-2" d="M123.5,314.7l.6,1.9-1,.3-.6-1.9Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M126,313.9l.6,1.9-1.1.3-.6-1.8Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M127.8,313l.7,1.9-1.1.3-.6-1.9Z" transform="translate(-1 -0.4)" />
    <path
      class="cls-4"
      d="M119.2,320a3.2,3.2,0,0,1-.3-2.5c4.6,1.4,15.9.8,17.6.5v2s-3.4,1.4-5.6.3a6,6,0,0,0-4.9.3C125.8,320.9,119.2,319.7,119.2,320Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M132.8,321.4a15.1,15.1,0,0,0,4-.8l.3-.3v-3.1h-.6c-2,0-13,.8-17.6-.6l-.5-.3-.3.6a3.1,3.1,0,0,0,.6,3.1l.2.3h.3l4,.6,2.8.2a4.7,4.7,0,0,1,4.3-.2A4.5,4.5,0,0,0,132.8,321.4Zm3.2-1.7c-.9.3-3.2,1.2-4.9.3a4.9,4.9,0,0,0-5.1.3,19.5,19.5,0,0,0-2.2-.3,39.1,39.1,0,0,0-4-.6c0-.2-.3-.5-.3-1.1,4.6,1.1,13.6.6,16.5.6Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M124.6,303v-3.1l7.7-2.3,19-11L169.7,297l2.6-.5h.2v3.1a1.8,1.8,0,0,1-.5,1.1l-24.7,14.2a3.4,3.4,0,0,1-3.4,0l-18.7-10.5C124.9,303.9,124.9,303.3,124.6,303Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M145.9,315.8a4.3,4.3,0,0,0,2-.6L172.5,301a1.5,1.5,0,0,0,.9-1.4v-3.1c0-.3,0-.6-.3-.6s-.6-.3-.6,0l-2.2.6-18.2-10.2h-.8l-19,11-7.7,2.3a.6.6,0,0,0-.5.6v3.1a2.2,2.2,0,0,0,.8,1.7l18.7,10.5C144.5,315.5,145,315.8,145.9,315.8ZM172.3,297v2.3a.9.9,0,0,1-.3.6l-24.7,14.2a2.8,2.8,0,0,1-2.8,0l-18.7-10.5a.9.9,0,0,1-.3-.6h0v-2.6l7.6-2.2,18.7-11.1,18.5,10.5h.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M170.8,296.8l2-.6h.3v3.1a1.7,1.7,0,0,1-.6,1.1l-1.4.9v-4.5Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M170,302.1l2.3-1.4a1.6,1.6,0,0,0,.8-1.4v-3.1c0-.3,0-.6-.3-.6s-.5-.3-.5,0l-2.3.6Zm2.3-5.1v2.3a.9.9,0,0,1-.3.6l-.3.3v-2.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M124.9,299.9l7.7-2.3,13.3,9.7v7.9a2.6,2.6,0,0,1-2-.6l-18.7-10.5c-.6-.2-.6-.5-.6-1.1a12.8,12.8,0,0,1,.3-3.1Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M145.9,315.8h.8V307l-13.9-10.2-.2.2-7.7,2.3a.6.6,0,0,0-.6.6V303a1.7,1.7,0,0,0,.9,1.7l18.7,10.5A3.9,3.9,0,0,0,145.9,315.8Zm-.6-8.3v6.8l-.8-.2-18.7-10.5a.9.9,0,0,1-.3-.6v-2.6l7.1-1.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M147.6,311.5,172.3,297a1.3,1.3,0,0,0,0-2.2l-18.8-10.5a3.4,3.4,0,0,0-3.4,0l-24.6,14.4a1.3,1.3,0,0,0,0,2.3l18.7,10.5A2.5,2.5,0,0,0,147.6,311.5Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M145.9,312.6a4.9,4.9,0,0,0,2-.5l24.6-14.5a2,2,0,0,0,.9-1.7,1.8,1.8,0,0,0-.9-1.7l-18.7-10.5a3.5,3.5,0,0,0-3.9,0l-24.7,14.5a2,2,0,0,0-.9,1.7,1.8,1.8,0,0,0,.9,1.7l18.7,10.5A2.6,2.6,0,0,0,145.9,312.6Zm5.9-28a3.9,3.9,0,0,1,1.5.2L172,295.3a.9.9,0,0,1,.3.6s0,.6-.3.6l-24.7,14.4a2.4,2.4,0,0,1-2.8,0l-18.7-10.5a.6.6,0,0,1-.3-.5s0-.6.3-.6l24.6-14.5A3,3,0,0,1,151.8,284.6Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M134.3,250.5l-3.2-1.7a6.4,6.4,0,0,0-3.9-.8,3.9,3.9,0,0,0-3.7,2v.8l3.1.9v.3l-1.1.2s.8,2.9,6.5,2.3S134.3,250.5,134.3,250.5Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M130.3,255.1H132c2-.3,3.1-.9,3.4-2a2.9,2.9,0,0,0-.9-3.1h-.2l-3.2-1.7a6.9,6.9,0,0,0-4.2-1.2c-2,0-3.4.6-4.3,2.3l-.2,1.4,2.5.9-.6.3.3.5C125.2,252.5,126,255.1,130.3,255.1Zm3.7-4c.3.3.8,1.1.5,1.7s-1.1.9-2.5,1.1c-3.4.6-4.8-.5-5.4-1.4l.9-.3-.3-1.1-2.9-.8a3.4,3.4,0,0,1,3.2-1.5,6.7,6.7,0,0,1,3.4.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M137.1,251.7l-1.7-.9h-.9a5.9,5.9,0,0,0-1.9,2.9c-.3.2,0,.8.2.8l2,.9a1.1,1.1,0,0,0,.9-.3l1.7-2.3C137.7,252.5,137.7,252,137.1,251.7Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M135.1,255.9a1.4,1.4,0,0,0,1.1-.5l1.8-2.3a2.3,2.3,0,0,0,.2-1.1,1.4,1.4,0,0,0-.5-.9l-1.7-.8a1.3,1.3,0,0,0-1.5,0,6.8,6.8,0,0,0-2.2,3.1,1.3,1.3,0,0,0,.8,1.7l2,.8Zm0-4.5,1.7.8-1.7,2.3h-.3l-2-.8A8.1,8.1,0,0,1,135.1,251.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M156.7,250c-.6,1.1.5-1.4,0,0l-3.7,8.5a71.4,71.4,0,0,0-8.5-3.4c-3.1-1.2-5.7-2.9-6.3-3.1h-.3a3.9,3.9,0,0,0-2.8,3.4v.2c1.1,1.2,12.2,10.2,20.4,12a24.9,24.9,0,0,0,7.1-11.4C165.2,248.6,157.5,247.1,156.7,250Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M156.1,268.1c.6-.3,5.1-4.2,7.4-11.9,1.4-4.5-.6-7.1-3.1-7.9a3.8,3.8,0,0,0-4,.5c-.3,0-.3.3-.3.6v.3c-1.4,3.1-2.8,6.5-3.4,7.9-1.4-.5-5.1-2.2-7.9-3.1a35.2,35.2,0,0,1-6.3-3.1c-.3-.3-.6-.3-.8,0s-3.2,1.7-3.2,4a1,1,0,0,0,.3.8c1.2,1.1,12.5,10.2,20.7,11.9Zm2.8-18.7a1.8,1.8,0,0,1,1.2.3c2,.6,3.4,2.5,2.2,6.2a22.3,22.3,0,0,1-6.8,10.8c-7.9-1.7-18.1-10.2-19.8-11.6a3.2,3.2,0,0,1,2.2-2.6,24.1,24.1,0,0,0,6.3,3.1,63.3,63.3,0,0,1,8.2,3.4l.6.3.3-.5,3.7-8.3c0-.2.2-.2.2-.5S158.1,249.4,158.9,249.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M112.7,322a16.4,16.4,0,0,1-.3,5.4s-3.4.8-5.6-.6a5.2,5.2,0,0,0-4.9-.5c-.2,0-6.5-2-6.5-1.7s-1.1-2.9,1.4-3.7l8-2,2.8-.6,4.3,2C112.1,320.9,112.7,321.4,112.7,322Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M109.9,328.5a10.5,10.5,0,0,0,2.5-.3h.3V328a12,12,0,0,0,.3-5.7c0-.9-.6-1.4-1.4-2L107,318l-3.1.6a80.5,80.5,0,0,0-7.9,2c-1.4.3-2,1.4-2,3.1s.3,1.7.8,1.7h.6a33,33,0,0,1,3.4,1.1l2.9.9h.2a4.5,4.5,0,0,1,4.3.6A22,22,0,0,0,109.9,328.5Zm2-1.4c-.9.3-3.4.6-4.9-.6a5.4,5.4,0,0,0-5.1-.5l-2.2-.6a32.4,32.4,0,0,1-3.7-1.1c0-.3-.3-1.2,0-1.7l.8-.9c2.3-.6,7.7-1.7,8-1.7l2.5-.6,4.3,2a1.4,1.4,0,0,1,.5.9A41,41,0,0,1,111.9,327.1Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M113.6,316.9l-1.2,3.4a3.5,3.5,0,0,1-3.9.6c-2.3-1.2.2-6.3.2-6.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M109.9,322a5,5,0,0,0,2.8-1.1l1.1-4-5.9-2.8-.3.5c-.3.3-2,3.7-1.1,6,.3.5.5,1.1,1.1,1.4Zm2-2a3.3,3.3,0,0,1-3.2.6.6.6,0,0,1-.5-.6c-.3-1.1.3-3.1.8-4.2l3.7,1.7Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M164,290.2s-7.3,9.7-13.9,11.7a21.8,21.8,0,0,1-17-2.9,90.9,90.9,0,0,1-9-6.8c-.3-.3-.3,0-.3.3s-.6,6.8-2.9,10.2a85.2,85.2,0,0,0-7.1,15s-3.6,1.7-6.2-2.5c0,0,6-19.6,6.8-26.9.6-4.6,3.1-6.9,5.1-7.7a7,7,0,0,1,3.4-.6l2,.3a50.3,50.3,0,0,1,9.6,2.6l15.1,5.6Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M111.9,318.9a5.9,5.9,0,0,0,1.9-.3h.3v-.3a68.4,68.4,0,0,1,7.1-15,20.5,20.5,0,0,0,2.9-9.9,65.9,65.9,0,0,0,8.5,6.2c5.6,4,13,4.5,17.5,2.8,6.6-2.2,13.9-11.6,14.2-11.9l.6-.8-15.9-2L134,282a55.3,55.3,0,0,0-9.7-2.5l-1.9-.3a5.6,5.6,0,0,0-3.7.5c-2.3,1.2-4.9,3.4-5.4,8.3-.9,7.3-6.8,26.6-6.8,26.9v.6C108.5,318.3,110.4,318.9,111.9,318.9Zm1.4-1.4c-.9.2-3.1.8-5.1-2.3.8-2.6,5.9-19.9,6.8-26.9a9,9,0,0,1,4.5-7.4,5.4,5.4,0,0,1,3.1-.6l2,.3a59.1,59.1,0,0,1,9.4,2.5l15,5.7,13.9,1.7c-2,2.3-7.7,9.1-12.8,10.8-3.4,1.1-10.4,1.1-16.4-2.8a87.3,87.3,0,0,1-9.1-6.8.9.9,0,0,0-.8-.3c-.3.3-.6.5-.6.8a25.2,25.2,0,0,1-2.5,9.9A59.8,59.8,0,0,0,113.3,317.5Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M123.2,292.2h1.1a10,10,0,0,0-1.9-5.1l-.9.9A6.5,6.5,0,0,1,123.2,292.2Z"
      transform="translate(-1 -0.4)"
    />
    <path class="cls-2" d="M100.3,320.6l.4,1.6-1.1.3-.4-1.7Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M102.6,320.1l.3,1.7-1.1.2-.3-1.7Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M104.9,319.6l.3,1.6-1.1.3-.3-1.7Z" transform="translate(-1 -0.4)" />
    <path
      class="cls-4"
      d="M95.4,324.6a3.7,3.7,0,0,1-.3-2.3c6.3,2.3,17.3,3.4,17.6,3.4s-.3,1.1-.3,1.7-3.4.8-5.6-.6a5.2,5.2,0,0,0-4.9-.5C101.7,326.5,95.4,324.6,95.4,324.6Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M109.9,328.5a10.5,10.5,0,0,0,2.5-.3h.3V328c0-.6.3-1.2.3-1.7v-.6h-.6c-.5,0-11.3-1.1-17.3-3.4l-.5-.3-.3.6c-.3.8-.3,2.8.5,3.1l.6.3a19,19,0,0,1,3.4,1.1l2.9.9h.2a4.7,4.7,0,0,1,4.3.5A15.3,15.3,0,0,1,109.9,328.5Zm2-1.4c-.9.3-3.4.6-4.9-.6a5.4,5.4,0,0,0-5.1-.5l-2.2-.6a32.4,32.4,0,0,1-3.7-1.1v-.9c5.4,2,13.9,2.9,16.1,3.1C111.9,326.5,111.9,326.8,111.9,327.1Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M136.5,280s-4.5,10.5-4.5,16.2c0,0,4.2,9.4,15,8.5,4.6-.3,13.4-5.1,17-9.6,1.5-2,0-9.1.6-11.4l5.7-25.2s2-7.1-1.4-10.8a2.6,2.6,0,0,0-1.7-.9c-1.7-.2-6.6,1.2-6.6,1.2,3.7-.9-11,4.5-11,4.5l-5.4,4.3-5.1,19.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M145.6,305.6H147c4.6-.3,13.6-4.9,17.6-10,1.1-1.4.9-4.5.6-7.3s-.3-3.4,0-4.3l5.6-25.2c0-.3,2-7.4-1.7-11.4a6.2,6.2,0,0,0-1.9-1.1,33.7,33.7,0,0,0-6.3.8h-.3c-.2,0-.2.3-.2.3v.3c-2,.9-7.1,2.8-10.5,4.3h-.3l-5.4,4.5-5.1,19.3-2.9,3.9c-.2.6-4.5,10.5-4.5,16.5C131.4,296.5,135.7,305.6,145.6,305.6Zm21-58.2h.3a1.6,1.6,0,0,1,1.4.9c3.1,3.4,1.4,10.2,1.4,10.2L164,283.7a34.7,34.7,0,0,0,0,4.6c.3,2.5.3,5.6-.2,6.5-3.7,4.8-12.2,9.1-16.8,9.6a13.9,13.9,0,0,1-14.2-7.9c0-5.4,4-15.1,4.3-15.9l2.8-4.3,5.1-19,5.1-3.9c8.3-3.1,10.8-4.3,11.7-4.8S165.2,247.4,166.6,247.4Z"
      transform="translate(-1 -0.4)"
    />
    <g id="boy-arm">
      <path class="cls-2" d="M108.2,252l2.9,7.1-1.3.5-2.9-7.1Z" transform="translate(-1 -0.4)" />
      <path
        class="cls-3"
        d="M116.1,262.4s-1.4-2.8-2.8-3.6a1.6,1.6,0,0,0-2.3.8c0,.3-.3.3-.6.3l-3.4-1.4c-.2-.3-.8,0-1.1.3s-.8,1.9,0,3.9,7.4,3.7,7.4,3.7Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-2"
        d="M113.6,266.7l3.4-4.3-.3-.2s-1.4-3.2-3.1-4a2.4,2.4,0,0,0-3.2.8l-3.4-1.4a1.7,1.7,0,0,0-1.9.6c-.6.8-1.2,2.3,0,4.5s7.6,4,7.9,4Zm1.9-4.5-2.5,3.1c-1.1-.3-5.4-1.2-6.5-3.4s-.6-2.6,0-3.4.3-.3.3,0l3.4,1.4c.5.3,1.1,0,1.1-.3s1.1-.6,1.4-.6A9.4,9.4,0,0,1,115.5,262.2Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-2"
        d="M118.1,263.9l-1.7-1.5a.8.8,0,0,0-.9,0,8.8,8.8,0,0,0-2.8,2.6c-.3.3,0,.8.3,1.1l2,1.2a1.1,1.1,0,0,0,1.1,0l2.3-2.3A.7.7,0,0,0,118.1,263.9Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-2"
        d="M115.5,268.1a1.8,1.8,0,0,0,1.2-.3l2.3-2.2a1.9,1.9,0,0,0,.5-1.2,2.7,2.7,0,0,0-.5-1.1l-1.8-1.4c-.5-.3-1.1-.6-1.4-.3a6.8,6.8,0,0,0-3.1,2.8,1.7,1.7,0,0,0,.3,2l2,1.1A.6.6,0,0,0,115.5,268.1Zm2.3-3.7-2.3,2.6h-.2l-2-1.2v-.2a5.5,5.5,0,0,1,2.5-2.3h.3Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-4"
        d="M147.3,257.3c-.6-.8-1.4-.8-2.5-.8a1.6,1.6,0,0,0-1.2.6,26.6,26.6,0,0,0-3.9,5.3c-2.3,4-7.7,11.4-7.7,11.4a69.6,69.6,0,0,0-7.7-4.8,52.7,52.7,0,0,1-5.6-4.3h-.3a3.4,3.4,0,0,0-3.4,2.8v.3c.8,1.2,9.3,11.7,17,15.3a1.3,1.3,0,0,0,1.4-.2c2.3-2,8.8-8.3,11.9-13.9S148.4,258.8,147.3,257.3Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-2"
        d="M132.8,283.4c.6,0,.9-.3,1.5-.5,1.9-2,8.8-8.5,11.9-14.2s3.4-9.4,1.7-11.6a3.1,3.1,0,0,0-3.1-.9,6.6,6.6,0,0,0-1.5.9,37.2,37.2,0,0,0-4.2,5.3c-2,3.4-6,9.1-7.1,10.8a78,78,0,0,0-7.1-4.5c-2.8-1.7-5.1-3.7-5.4-4.3a1,1,0,0,0-.8-.3,5,5,0,0,0-4,3.2.9.9,0,0,0,.3.8c.8,1.2,9.6,11.6,17.3,15.3Zm14.5-26.1-.6.3c1.5,2,.9,5.4-1.7,10.5S135.4,280,133.4,282a1,1,0,0,1-.8.3c-7.1-3.4-15.4-13.3-16.8-14.8a2.7,2.7,0,0,1,2.6-1.9,22.4,22.4,0,0,0,5.7,4.2c3.1,1.7,7.3,4.8,7.6,4.8l.6.3.3-.5s5.4-7.4,7.6-11.4a18.3,18.3,0,0,1,4-5.1c.3-.3.6-.3.8-.6s1.5,0,1.7.6Zm-.6.6.6-.3Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-2"
        d="M131.4,276.9l1.2-.3a6.8,6.8,0,0,1,0-2.5l-1.2-.3A9.5,9.5,0,0,0,131.4,276.9Z"
        transform="translate(-1 -0.4)"
      />
    </g>
    <path
      class="cls-3"
      d="M145.6,296.5l3.7-18.7a5.1,5.1,0,0,1,2-2.9l22.9-13a1.1,1.1,0,0,1,.9-.3,5.7,5.7,0,0,1,3.4,2.3l-2.5,1.7h-.3l-3.2,15.8a3.9,3.9,0,0,1-1.9,2.9l-17.3,6.8-1.7,2-2.3,6.8c-.6,0-3.7,0-3.7-2.6v-.8Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M149.9,300.7l.2-.5,2.3-6.8,1.4-2,17.3-6.8a5,5,0,0,0,2.3-3.2l2.8-15.3,2.6-1.7c.3-.3.6-.5.3-.8s-1.4-2.6-4-2.6c-.3,0-.9,0-1.1.3l-23,13.1a4.8,4.8,0,0,0-2.3,3.4L145,296.5v1.1c.3,2.3,2.6,3.1,4.3,3.1Zm25.5-36-3.1,16.7a4.4,4.4,0,0,1-1.7,2.6l-17.3,6.8v.3l-1.7,2.3-2,6.5c-.9,0-2.6-.3-2.9-2V297l3.7-18.7a4.2,4.2,0,0,1,1.7-2.5l23-13.1h.6a3.9,3.9,0,0,1,2.5,1.7l-2,1.2Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M145.6,297.6v-.8l3.7-18.8a2.9,2.9,0,0,1,.8-1.7,7.9,7.9,0,0,0,2.6,1.7,41.3,41.3,0,0,0,3.7,2,55.2,55.2,0,0,1,5.7,6,9.1,9.1,0,0,1-.3,2l-8.5,3.4-1.7,2-2.3,6.8C149,300.2,145.9,300.2,145.6,297.6Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M149.9,301l.2-.6,2.3-6.8,1.4-1.9,8.8-3.4V288a12.2,12.2,0,0,0,.3-2.3c-.3-.8-5.7-6.2-5.9-6.2s-2-1.2-3.5-2a9,9,0,0,1-2.5-1.7l-.6-.6-.5.6a2.4,2.4,0,0,0-.9,2l-3.7,18.7v1.1c.3,2.3,2.6,3.1,4.3,3.1Zm11.6-13.6-8.2,3.1v.3l-1.7,2.3-2.3,6.5c-.9,0-2.6-.3-2.8-2v-.8l3.6-18.8c0-.2.3-.5.3-.8a20,20,0,0,0,2.3,1.4,34.9,34.9,0,0,0,3.7,2c.6.6,4.8,4.8,5.4,5.7S161.5,286.6,161.5,287.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M173.4,262.4l1.1-.5a1.1,1.1,0,0,1,.9-.3,5.7,5.7,0,0,1,3.4,2.3l-1.4.8c-.6-.3-.6-.6-.6-.6A16.5,16.5,0,0,0,173.4,262.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M177.4,265.8l2-1.1.2-.6-.2-.2c-.3-.3-1.5-2.6-4-2.6a1.8,1.8,0,0,0-1.2.3l-1.9,1.1,1.1.6a6.2,6.2,0,0,1,2.8,1.7c0,.3.3.6.9.8Zm.5-1.9-.5.2v-.2a11.9,11.9,0,0,0-2.3-1.7h.3A4.7,4.7,0,0,1,177.9,263.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M148.2,298.7l3.6-19a4.4,4.4,0,0,1,2-2.8l23-13c.9-.6,2,.2,1.7,1.4l-3.4,18.4a4.6,4.6,0,0,1-2,2.9l-23.2,13.8A1.7,1.7,0,0,1,148.2,298.7Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M149.6,300.7a.9.9,0,0,0,.8-.3l23.3-13.8a5.2,5.2,0,0,0,2.3-3.5l3.4-18.4a2.7,2.7,0,0,0-.9-2,1.5,1.5,0,0,0-2,0l-23,13.1a5,5,0,0,0-2.2,3.1l-3.7,19c-.3.8,0,1.4.8,2S149,300.7,149.6,300.7Zm28.1-36.6h.2a1,1,0,0,1,.3.6l-3.4,18.4a4,4,0,0,1-1.7,2.6l-23.2,13.9a.4.4,0,0,1-.6,0,1,1,0,0,1-.3-.6l3.7-19a3.8,3.8,0,0,1,1.7-2.5l23-13.1Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M160.1,246.6l-8.3,3.7s-3.6,0-3.1,3.6c0,0,5.4,3.7,11.9-1.1S160.1,246.6,160.1,246.6Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M153.5,255.6a12.5,12.5,0,0,0,7.4-2.5c2.3-1.7,3.4-3.4,3.1-4.8s-3.4-2.6-3.9-2.6h-.3l-8.2,3.7a4.1,4.1,0,0,0-2.9,1.4,3.9,3.9,0,0,0-.5,3.1v.3l.2.3C148.4,254.2,150.4,255.6,153.5,255.6Zm6.6-8.5c.8.3,2.5.6,2.5,1.7s0,1.5-2.5,3.4c-5.4,4-10,2-11.1,1.2s0-1.4.3-1.7,2.3-.9,2.3-.9h.2Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M159.5,241.5s-.6,4.8.6,6.8a7.1,7.1,0,0,1-8.3,2.2c-.2,0-.2-.2-.5-.2s2-2.3.8-6l3.7-4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M154.7,251.7a7.4,7.4,0,0,0,5.9-3.1l.3-.3-.3-.3c-.8-1.4-.5-5.1-.2-6.3v-.5l-4.6-1.7-4.2,4.5v.3c1.1,3.4-.3,5.1-.6,5.4l-.3.3v.3c0,.2.3.2.3.5s.3.3.6.3A10.7,10.7,0,0,0,154.7,251.7Zm4.5-3.4a5.8,5.8,0,0,1-7.1,1.7,6.9,6.9,0,0,0,.6-5.7l3.4-3.4,2.8,1.1C158.7,243.2,158.4,246.3,159.2,248.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M154.4,244.9s-1.4,2.2-6.2.5c0,0-3.7-6.5-.9-12.2H153l6.5,2.9-2.3,6.8Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M151.3,246.6a5.1,5.1,0,0,0,3.7-1.5l3.1-1.9,2.3-7.7-7.4-3.1h-6.3l-.2.3c-2.9,6.2.8,12.4.8,12.7v.3h.3A6.9,6.9,0,0,0,151.3,246.6Zm2.5-2s-1.4,1.7-5.4.5c-.5-1.1-2.8-6.2-.8-11h5.1l6,2.5-2,6Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M162.3,231.3s3.4,2.5.6,7.6-1.1,5.1-1.1,5.1-.9,1.1-3.1,0c0,0-2,3.1-4.6.6,0,0-1.4-5.1.6-7.4v-.3a10.5,10.5,0,0,1-9.7-5.6s1.5-6,8.8-6S162.3,231.3,162.3,231.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M156.4,246.6h.3a2.5,2.5,0,0,0,2.2-1.5c2.3,1.2,3.4-.2,3.4-.2l.3-.6-.3-.3s-.5-1.4,1.2-4.5c2.5-4.8,0-7.7-.6-8.5s-2-6-9.1-6-9.3,6.5-9.3,6.5v.6c2.5,4.8,7.1,5.7,9.3,6-1.1,2.5,0,6.8,0,7v.3A5.1,5.1,0,0,0,156.4,246.6Zm2.3-3.2-.3.6a5.5,5.5,0,0,1-1.7,1.4,4.8,4.8,0,0,1-1.7-.5c-.3-1.5-.9-5.1.2-6.6s.3-.5,0-.8-.2-.3-.5-.3a9.3,9.3,0,0,1-8.8-5.1c.3-1.1,2-5.4,8.2-5.4s8,5.1,8,5.1v.3h.2s2.9,2.3.6,7.1a11,11,0,0,0-1.4,5.4c-.3.3-.9.3-2-.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M158.4,233.2a2.6,2.6,0,0,1,1.7-1.7,4.2,4.2,0,0,1,2.2.3l.6-.8a3.3,3.3,0,0,0-2.8-.3,4.9,4.9,0,0,0-2.3,2Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M152.7,255.4l1.1-.3a3.8,3.8,0,0,1,.9-3.4l-.9-.9A4.4,4.4,0,0,0,152.7,255.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M162.3,250.5l.9-.8a6.2,6.2,0,0,0-3.4-2l-.3,1.1A8.2,8.2,0,0,1,162.3,250.5Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M64.5,234.1v-3.7l13.6,1.1,1.1-7.6L91.7,231l2.3-.6h.3v3.7a2,2,0,0,1-.6,1.1l-12.8,7.4a3.4,3.4,0,0,1-3.4,0l-12.7-7.4C64.8,234.9,64.5,234.4,64.5,234.1Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M79.8,243.4a3.9,3.9,0,0,0,2-.5l12.8-7.4a1.6,1.6,0,0,0,.8-1.4v-3.7c0-.3,0-.6-.3-.6s-.3-.3-.5,0l-2.3.6-12.5-7.1H79l-.3.3L77.5,231l-13.3-1.2a.6.6,0,0,0-.5.6v3.7a2.2,2.2,0,0,0,.8,1.7l12.8,7.4A12.9,12.9,0,0,0,79.8,243.4ZM94.3,231v3.1a.9.9,0,0,1-.3.6L81.2,242a2.4,2.4,0,0,1-2.8,0l-12.8-7.3a1.2,1.2,0,0,1-.2-.6h0V231l13,1.1h.3l.3-.3,1.1-7.1,12.2,6.8h.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M64.8,230.1l13.6,1.2,1.7,4.5v7.1a2,2,0,0,1-1.7-.6l-12.8-7.4c-.5-.2-.5-.5-.5-1.1s-.6-3.1-.3-3.7Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M79.8,243.4h.9v-7.9L79,230.1l-.6.3-13.6-1.1a.6.6,0,0,0-.6.5v3.7a1.7,1.7,0,0,0,.9,1.7l12.7,7.4A2.2,2.2,0,0,0,79.8,243.4Zm-.6-7.3v6.2c-.2,0-.5-.3-.8-.3l-12.8-7.3a1.2,1.2,0,0,1-.2-.6V231l12.7,1.1Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M92.9,232.1a3,3,0,0,1-.3-1.1l2.2-.6h.3v3.7a2.7,2.7,0,0,1-.5,1.1l-1.2.9v-4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M92.3,236.9l2.3-1.4a1.6,1.6,0,0,0,.8-1.4v-3.7c0-.3,0-.6-.3-.6s-.3-.3-.5,0l-2.9.9.3.6a1.8,1.8,0,0,1,.3,1.1Zm2-5.9v3.1a.9.9,0,0,1-.3.6l-.3.2v-2.8a.9.9,0,0,0-.3-.6Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M81.5,238.6l12.8-7.3a1.4,1.4,0,0,0,0-2.3l-12.8-7.4a3.4,3.4,0,0,0-3.4,0L65.4,229a1.3,1.3,0,0,0,0,2.3l12.7,7.3A3.4,3.4,0,0,0,81.5,238.6Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M79.8,239.8a5.1,5.1,0,0,0,2-.6l12.8-7.4a2.1,2.1,0,0,0,.8-1.7,1.9,1.9,0,0,0-.8-1.7L81.8,221a3.6,3.6,0,0,0-4,0l-12.7,7.4a2.1,2.1,0,0,0-.9,1.7,1.7,1.7,0,0,0,.9,1.7l12.7,7.4A5.1,5.1,0,0,0,79.8,239.8Zm-.3-17.9a2.2,2.2,0,0,1,1.4.3l12.8,7.4a.6.6,0,0,1,.3.5s0,.6-.3.6l-12.8,7.4a2.8,2.8,0,0,1-2.8,0l-12.7-7.4a.9.9,0,0,1-.3-.6s0-.5.3-.5l12.7-7.4A2.9,2.9,0,0,1,79.5,221.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M65.6,242.9l31.8-22.1a3,3,0,0,0,1.1-2.3l3.2-24.4c0-.9-3.7-2.8-4.3-2.6L63.1,211.4a2.9,2.9,0,0,0-1.2,2.3v26.1C61.9,240.6,64.8,243.2,65.6,242.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M65.4,243.4h.5L98,221.3a3.5,3.5,0,0,0,1.4-2.8l3.1-24.4c0-.9-1.1-1.7-2-2.3s-2.3-1.1-3.1-.8L63.1,210.8a3.7,3.7,0,0,0-1.7,2.9v26.1c0,1.1,2,2.8,3.1,3.6S64.8,243.4,65.4,243.4Zm35.7-49.6L98,218.2a3.1,3.1,0,0,1-.9,2l-32,22.1a14.1,14.1,0,0,1-2.9-2.5V213.7a4.1,4.1,0,0,1,.9-2l34.3-19.9A7.8,7.8,0,0,1,101.1,193.8Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M66.2,242.9,100.5,223a2.9,2.9,0,0,0,1.2-2.2V194.7c0-.9-.6-1.5-1.2-.9L66.2,213.7a2.8,2.8,0,0,0-1.1,2.2V242C65.1,242.6,65.6,243.2,66.2,242.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M65.6,243.4a1.5,1.5,0,0,0,.9-.2l34.3-19.9a3.7,3.7,0,0,0,1.7-2.8V194.4c0-.9-.3-1.4-.8-1.4a1.3,1.3,0,0,0-1.5,0L65.9,212.8a4,4,0,0,0-1.7,2.9v26c0,.9.3,1.5.9,1.5Zm.3-1.1h0c-.3,0-.3,0-.3-.3V215.9a3.8,3.8,0,0,1,.9-1.9l34.3-19.9h.3v26.7a3.8,3.8,0,0,1-.9,1.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M68.8,238.3l29.4-17a2,2,0,0,0,.6-1.1V198.9c0-.5-.3-.5-.6-.5l-29.4,17a2,2,0,0,0-.6,1.1v21.3C67.9,238.3,68.2,238.3,68.8,238.3Z"
      transform="translate(-1 -0.4)"
    />
    <g id="charts">
      <path
        class="cls-4"
        d="M158.7,188.1l2-2.3,6.5,1.4.3-1.1-7.4-1.7-2,2.5-7.9-1.1v1.1Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-4"
        d="M70.5,234.7l3.9-8.6h2l2.8-10.4,4.9,4.2,2-2.8,5.1,2.5,1.4-1.4,4.2,1.4.3-.8-4.8-1.7-1.4,1.4-5.1-2.8-1.7,2.8L79,214l-3.4,11.3h-2l-4,9.1Z"
        transform="translate(-1 -0.4)"
      />
    </g>
  </svg>
</template>

<script>
import coords from "@/components/coords.js";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { mapState } from "vuex";

gsap.registerPlugin(ScrollTrigger);

export default {
  computed: {
    ...mapState(["toggleConfig", "startConfig", "isAnimationDisabled", "viewportSize"]),
  },
  mixins: [coords],
  props: {
    x: {
      type: [Number, String],
      default: 1200,
    },
    y: {
      type: [Number, String],
      default: 50,
    },
    xSmall: {
      type: [Number, String],
      default: 1200,
    },
    ySmall: {
      type: [Number, String],
      default: 50,
    },
  },
  methods: {
    deployPreview() {
      gsap
        .timeline({
          scrollTrigger: {
            trigger: "#milestone-deploypreview",
            toggleActions: this.toggleConfig,
            start: this.startConfig,
          },
        })
        .add("deployP")
        .fromTo(
          "#robotarm, #girl-arm, #boy-arm",
          {
            duration: 0.5,
            rotation: -20,
            y: -5,
            x: 5,
            stagger: 0.3,
            transformOrigin: "100% 100%",
          },
          {
            rotation: 0,
            repeat: 3,
            y: 0,
            x: 0,
            yoyo: true,
            ease: "sine.inOut",
          },
          "deployP"
        )
        .fromTo(
          "#girl-arm",
          {
            duration: 0.25,
            rotation: -20,
            y: -5,
            x: 5,
            stagger: 0.3,
            transformOrigin: "100% 100%",
          },
          {
            rotation: 0,
            repeat: 6,
            y: 0,
            x: 0,
            yoyo: true,
            ease: "sine.inOut",
          },
          "deployP+=0.3"
        )
        .fromTo(
          "#boy-arm",
          {
            duration: 0.25,
            rotation: -20,
            y: -5,
            x: 5,
            stagger: 0.3,
            transformOrigin: "100% 100%",
          },
          {
            rotation: 0,
            repeat: 5,
            y: 0,
            x: 0,
            yoyo: true,
            ease: "sine.inOut",
          },
          "deployP+=0.5"
        )
        .fromTo(
          "#lightning",
          {
            duration: 1,
            scale: 0.5,
            opacity: 0,
            transformOrigin: "50% 50%",
          },
          {
            scale: 1,
            opacity: 1,
            ease: "sine",
          },
          "deployP"
        )
        .fromTo(
          "#commandwords path",
          {
            duration: 0.05,
            opacity: 0,
          },
          {
            opacity: 1,
            stagger: 0.05,
            ease: "power3",
          },
          "deployP+=0.5"
        );
    },
  },
  mounted() {
    this.deployPreview();
  },
};
</script>

<style lang="scss" scoped>
.cls-1 {
  fill: none;
}

.cls-2 {
  fill: #0e1e25;
}

.cls-3 {
  fill: #fff;
}

.cls-4 {
  fill: #ffad43;
}

.cls-5 {
  clip-path: url(#clip-path);
}

.cls-6 {
  fill: #caa677;
}
</style>
